/* Norsk katalog — kildespråket.
 * Tekstene her skal være ordrett like de som sto hardkodet i komponentene, slik at norske brukere ikke ser noen endring. Norsk er også fallback for alle andre
 * språk, så en nøkkel skal alltid finnes her først.
 * Nøkkelnavn: <område>.<hva>. Rutenære nøkler bruker rute-key fra `NAV`
 * (`nav.home`, `navhelp.home`, `route.home`) slik at oppslaget kan gjøres
 * dynamisk fra datastrukturen.
 */
window.PlummeI18n.register('no', {
  // ---------------------------------------------------------------- generelt
  'common.save': 'Lagre endringer',
  'common.saving': 'Lagrer...',
  'common.cancel': 'Avbryt',
  'common.hoursMinutes': '{h}t {m}m',
  'common.delete': 'Slett',
  'common.confirmTitle': 'Er du sikker?',
  'common.continue': 'Fortsett',
  'account.view': 'Kontovisning',
  'account.relevant': 'Relevante',
  'account.all': 'Alle',
  'account.favorites': 'Favoritter',
  'account.addFavorite': 'Legg til i favoritter',
  'account.removeFavorite': 'Fjern fra favoritter',
  'account.searchHint': 'Søk navn, nummer eller f.eks. 5x',
  'common.working': 'Jobber...',
  'common.close': 'Lukk',
  'common.on': 'På',
  'common.off': 'Av',
  'common.active': 'Aktiv',
  'common.yes': 'Ja',
  'common.no': 'Nei',
  // Korte månedsnavn. Egen katalog i stedet for Intl, fordi Intl gir 'jan.'/'mars'
  // på nb-NO og ville endret dagens norske grafer og tabeller.
  'month.short.1': 'Jan',
  'month.short.2': 'Feb',
  'month.short.3': 'Mar',
  'month.short.4': 'Apr',
  'month.short.5': 'Mai',
  'month.short.6': 'Jun',
  'month.short.7': 'Jul',
  'month.short.8': 'Aug',
  'month.short.9': 'Sep',
  'month.short.10': 'Okt',
  'month.short.11': 'Nov',
  'month.short.12': 'Des',
  // ------------------------------------------------- delte UI-primitiver (ui.jsx)
  'ui.summary.title': 'Oppsummering',
  'ui.summary.exVat': 'Sum ekskl. MVA',
  'ui.summary.vat': 'MVA',
  'ui.summary.total': 'Totalsum',
  'ui.more': 'Mer',
  'ui.filter': 'Filter',
  'ui.filterReset': 'Nullstill filter',
  'ui.filterChoices': 'Filtervalg',
  'ui.period': 'Periode',
  'ui.from': 'Fra',
  'ui.to': 'Til',
  'ui.fromMonth': 'Fra måned',
  'ui.toMonth': 'Til måned',
  'ui.fromDate': 'Fra dato',
  'ui.toDate': 'Til dato',
  'ui.today': 'I dag',
  'ui.wholeYearTitle': 'Hele {year}',
  'ui.quick.wholeYear': 'Hele året',
  'ui.quick.ytd': 'Hittil i år',
  'ui.quick.thisTerm': 'Denne terminen',
  'ui.quick.lastYear': 'Forrige år',
  'ui.term': 'Termin {n}',
  'ui.amountSearch': 'Søk på beløp',
  'ui.amountFrom': 'Beløp fra',
  'ui.amountTo': 'Beløp til',

  // --------------------------------- delte listebyggeklosser (list-shared.jsx)
  'list.search': 'Søk',
  'list.copy': 'Kopier',
  'list.copied': 'Kopiert: {text}',
  'list.export': 'Eksporter',
  'list.download': 'Last ned',
  'list.downloaded': '{label} lastet ned',
  'list.nothingToExport': 'Ingen rader å eksportere',
  'list.downloading': '{label} lastes ned …',
  'list.upload': 'Last opp',
  'list.add': 'Legg til',
  'list.archiveTitle': 'Flytt til arkiv?',
  'list.archiveConfirm': 'Flytt til arkiv',
  'list.deleteTitle': 'Slette?',
  'list.delete': 'Slett',
  'list.archiveBody': 'Vil du flytte {name} til arkivet? Kunden skjules fra aktive kundelister, men fakturaer, betalinger og historikk beholdes. Dette kan ikke angres herfra.',
  'list.deleteBody': 'Er du sikker på at du vil slette {name}? Dette kan ikke angres.',

  'crm.prospect': 'Prospekt',
  'crm.active': 'Aktiv',
  'crm.quoteSent': 'Tilbud sendt',
  'crm.pause': 'På pause',

  'badge.paid': 'Oppgjort',
  'badge.active': 'Aktiv',
  'badge.sent': 'Sendt',
  'badge.draft': 'Utkast',
  'badge.created': 'Ikke sendt',
  'badge.overdue': 'Forfalt',
  'badge.credited': 'Kreditert',
  'badge.inactive': 'Passiv',
  'badge.ok': 'Levert',
  'badge.no': 'Ikke levert',
  'badge.soon': 'Forfaller snart',

  'status.draft': 'Utkast',
  'status.created': 'Ikke sendt',
  'status.sent': 'Sendt',
  'status.paid': 'Betalt',
  'status.overdue': 'Forfalt',
  'status.credited': 'Kreditert',

  // ------------------------------------------------------------- app-ramme
  'app.loading': 'Laster regnskapet ditt…',
  'app.loadingPersonalFinance': 'Laster privatøkonomien din…',
  'app.loadingEmployeePortal': 'Laster ansattportalen din…',
  'project.cost.field': 'Prosjekt',
  'project.cost.none': 'Ikke på prosjekt',
  'project.cost.billable': 'Viderefaktureres kunden',
  'project.cost.pickTitle': 'Velg prosjekt',
  'project.cost.search': 'Søk etter prosjekt eller kunde',
  'project.cost.searchEmpty': 'Ingen prosjekter passer søket.',
  'project.cost.toProject': 'Til prosjekt',
  'app.employeePortalVerifyTitle': 'Bekreft e-postadressen din',
  'app.employeePortalVerifyText': 'Vi har sendt en bekreftelseslenke til {{email}}. Det kan ta noen minutter før den kommer. Sjekk også søppelpost. Åpne lenken for å fortsette.',
  'app.employeePortalVerifyResend': 'Send lenken på nytt',
  'app.employeePortalVerifySent': 'Bekreftelseslenke er sendt på nytt.',
  'app.employeePortalVerifyAlready': 'E-postadressen er allerede bekreftet. Last siden på nytt.',
  'app.employeePortalVerifyFailed': 'Kunne ikke sende bekreftelseslenke.',
  'app.emailVerifyCheck': 'Jeg har bekreftet',
  'app.emailVerifyConfirmed': 'E-postadressen er bekreftet.',
  'app.emailVerifyNotConfirmed': 'E-postadressen er ikke bekreftet ennå. Åpne lenken i e-posten og prøv igjen.',
  'app.emailVerifyCheckFailed': 'Kunne ikke kontrollere e-postadressen.',
  'app.emailVerifyInitialFailed': 'Kontoen ble opprettet, men bekreftelseslenken kunne ikke sendes. Prøv å sende den på nytt.',
  'app.placeholder.title': 'Denne siden er på vei',
  'app.placeholder.text': 'Vi pusser på de siste detaljene her. Stikk innom snart!',
  'app.nobusiness.title': 'Hva vil du starte med?',
  'app.nobusiness.text': 'Du er logget inn, men har ingen foretak i Plumme ennå.',
  'app.nobusiness.create': 'Opprett foretak',
  'app.nobusiness.signOut': 'Logg ut',
  'common.signOut': 'Logg ut',
  // ------------------------------------------------------------ innlogging
  'auth.sub.default': 'Enkel bokføring for små foretak',
  'auth.sub.forgot': 'Tilbakestill passordet ditt',
  'auth.sub.sent': 'Sjekk e-posten din',
  'auth.sub.signup': 'Opprett konto og sett opp foretak',
  'auth.language': 'Språk',
  'auth.invite.household': 'Du har fått en invitasjon til familieøkonomi. Logg inn, eller opprett en konto med e-postadressen invitasjonen ble sendt til.',
  'auth.invite.business': 'Du har fått en klientinvitasjon. Skriv inn e-postadressen invitasjonen ble sendt til, så åpner vi invitasjonen etter innlogging.',
  'auth.email': 'E-post',
  'auth.emailPlaceholder': 'din@epost.no',
  'auth.password': 'Passord',
  'auth.name': 'Navn',
  'auth.namePlaceholder': 'Ditt navn',
  'auth.passwordMin': 'Minst 6 tegn',
  'auth.showPassword': 'Vis passord',
  'auth.hidePassword': 'Skjul passord',
  'auth.remember': 'Husk meg',
  'auth.forgot': 'Glemt passord?',
  'auth.signIn': 'Logg inn',
  'auth.signingIn': 'Logger inn...',
  'auth.noAccount': 'Har du ikke konto?',
  'auth.createAccount': 'Opprett konto',
  'auth.creating': 'Oppretter...',
  'auth.backToLogin': 'Tilbake til innlogging',
  'auth.forgotCopy': 'Skriv inn e-posten du logger inn med, så sender vi deg en lenke for å lage et nytt passord.',
  'auth.sendResetLink': 'Send tilbakestillingslenke',
  'auth.sending': 'Sender...',
  'auth.sentCopy': 'Vi har sendt en lenke til {email}. Følg lenken i e-posten for å lage et nytt passord.',
  'auth.wrongEmail': 'Brukte vi feil e-post? Prøv på nytt',
  'auth.error.signIn': 'Innlogging feilet.',
  'auth.error.reset': 'Kunne ikke sende tilbakestillingslenke.',
  'auth.error.signUp': 'Kunne ikke opprette konto.',

  // ------------------------------------------------------- hurtigfangst bilag
  'capture.scan': 'Skann bilag',
  'capture.toInbox': 'Til Innboks',
  'capture.toPurchase': 'Til Betalt kjøp',
  'capture.analysisFailed': 'Bilaget ble lastet opp, men analysen feilet.',
  'capture.readyInPurchase': 'Bilaget er klart i Betalt kjøp.',
  'capture.uploadingToInbox': 'Laster bilaget opp til Innboks ...',
  'capture.uploadedToInbox': 'Bilag lastet opp til Innboks.',
  'capture.uploadFailed': 'Kunne ikke laste opp bilaget.',
  'capture.analysisTimedOut': 'Bilaget er sendt inn. Analysen bruker litt tid og fortsetter i bakgrunnen.',
  'capture.paymentDialogLoadFailed': 'Kunne ikke laste betalingsvalgene. Prøv igjen.',
  // ------------------------------------------------------------ navigasjon
  'nav.home': 'Hjem',
  'nav.aiBookkeeper': 'AI Regnskapsfører',
  'nav.aiAdvisor': 'AI Rådgiver',
  'nav.newSale': 'Nytt salg',
  'nav.invoices': 'Fakturaliste',
  'nav.otherSales': 'Annet salg',
  'nav.customers': 'Kunder',
  'nav.products': 'Produkter',
  'nav.projects': 'Prosjekter',
  'nav.subscriptions': 'Avtaler',
  'nav.newPurchase': 'Nytt kjøp',
  'nav.manualEntry': 'Fri postering',
  'nav.suppliers': 'Leverandører',
  'nav.assets': 'Eiendeler',
  'nav.inventory': 'Varelager',
  'nav.inbox': 'Innboks',
  'nav.incomeStatement': 'Resultatregnskap',
  'nav.trialBalance': 'Saldobalanse',
  'nav.budget': 'Budsjett',
  'nav.filings': 'MVA-melding',
  'nav.taxReturn': 'Skattemelding',
  'nav.yearEndClosing': 'Årsavslutning',
  'nav.annualAccounts': 'Årsregnskap',
  'nav.payroll': 'Lønn',
  'nav.mileageLog': 'Kjørebok',
  'nav.vouchers': 'Transaksjoner',
  'nav.bank': 'Bank',
  'nav.myPage': 'Min side',
  'nav.activityLog': 'Aktivitetslogg',
  'nav.altinn': 'Altinn',
  'nav.settings': 'Innstillinger',

  'navgroup.sales': 'Salg',
  'navgroup.purchases': 'Kjøp',
  'navgroup.reports': 'Rapporter',
  'navgroup.filings': 'Innleveringer',
  'navgroup.employees': 'Ansatte',
  'navgroup.other': 'Annet',
  'navgroup.miscellaneous': 'Øvrig',
  'navgroup.ai': 'AI',
  'navgroup.settings': 'Innstillinger',

  // Hjelpemodus-tekst per rute.
  'navhelp.home': 'Startsiden din – nøkkeltall, grafer og snarveier til å registrere salg og kjøp.',
  'navhelp.aiBookkeeper': 'SuperPlumma går gjennom bank, bilag, MVA og frister og lager forslag. Du kontrollerer og godkjenner før noe bokføres.',
  'navhelp.aiAdvisor': 'Økonomisk rådgivning fra SuperPlumma – helsescore, anbefalinger, kontantstrømprognose, risiko og skatteoptimalisering.',
  'navhelp.newSale': 'Lag en ny faktura eller et tilbud til en kunde. Salget bokføres automatisk.',
  'navhelp.invoices': 'Oversikt over alle fakturaer og tilbud – status, forfall og betaling.',
  'navhelp.customers': 'Kunderegisteret ditt. Legg til og rediger kunder du fakturerer.',
  'navhelp.products': 'Varer og tjenester du selger, med pris og MVA-sats – klare til bruk på faktura.',
  'navhelp.projects': 'Før timer på prosjekter og aktiviteter, følg med på hva som er gjort, og gjør ufakturerte timer om til fakturautkast.',
  'navhelp.subscriptions': 'Abonnement, repeterende fakturaer og kundelister med kontroll over automatiske utsendinger.',
  'navhelp.newPurchase': 'Registrer et kjøp eller en leverandørfaktura med bilag, leverandør, beløp og konto.',
  'navhelp.manualEntry': 'Bokfør manuelt rett på konto når du trenger full kontroll over føringen.',
  'navhelp.suppliers': 'Leverandørregisteret ditt – navn, org.nr. og kontonummer for utbetalinger.',
  'navhelp.assets': 'Driftsmidler og varige verdier som avskrives over tid.',
  'navhelp.inventory': 'Varetelling og verdien av varelageret ditt. Dokumenter tellingen og bokfør endringen i beholdningen.',
  'navhelp.inbox': 'Bilag som er kommet inn, men ikke bokført ennå. Dra dem på riktig føring.',
  'navhelp.incomeStatement': 'Inntekter minus kostnader – ser du om bedriften går med overskudd.',
  'navhelp.trialBalance': 'Saldo på alle konti – grunnlaget for regnskapsrapportene dine.',
  'navhelp.budget': 'Sett opp budsjett og følg med på hvordan du ligger an mot målene.',
  'navhelp.filings': 'Kontroller MVA-grunnlaget for hver termin. Selve meldingen leveres hos Skatteetaten.',
  'navhelp.taxReturn': 'Utkast til skattemelding basert på regnskapet – kontroller tallene før du leverer hos Skatteetaten.',
  'navhelp.yearEndClosing': 'Steg-for-steg gjennom alt som må gjøres for å lukke regnskapsåret.',
  'navhelp.annualAccounts': 'Resultat, balanse, noter og signering. Årsregnskapet leveres til Regnskapsregisteret utenfor Plumme.',
  'navhelp.payroll': 'Kjør lønn, lag lønnsslipper og bokfør lønnen. A-meldingen leveres utenfor Plumme.',
  'navhelp.mileageLog': 'Registrer kjøring i jobben og se kilometer og fradrag for året.',
  'navhelp.vouchers': 'Samlet oversikt over bokførte transaksjoner og tilhørende bilag – søk og finn igjen.',
  'navhelp.bank': 'Last opp kontoutskrifter og avstem bankkontoene mot regnskapet.',
  'navhelp.myPage': 'Din egen profil og innstillinger som bruker.',
  'navhelp.activityLog': 'Full historikk over hva som er gjort i regnskapet, og av hvem.',
  'navhelp.altinn': 'Snarvei til innsendinger og post i Altinn.',
  'navhelp.settings': 'Innstillinger for selskapet, regnskapet og appen.',
  'navhelp.fallback': 'Åpne {label}.',

  // -------------------------------------------------------------- sidetitler
  'route.home': 'Hjem',
  'route.newSale': 'Nytt salg',
  'route.newSaleliste': 'Fakturaliste',
  'route.customers': 'Kunder',
  'route.products': 'Produkter',
  'route.projects': 'Prosjekter',
  'route.aiBookkeeper': 'AI Regnskapsfører',
  'route.aiAdvisor': 'AI Rådgiver',
  'route.newPurchase': 'Betalt kjøp',
  'route.manualEntry': 'Fri postering',
  'route.vouchers': 'Transaksjoner',
  'route.suppliers': 'Leverandører',
  'route.assets': 'Eiendeler',
  'route.filings': 'Innsendinger',
  'route.inbox': 'Innboks',
  'route.documentation': 'Dokumentasjon',
  'route.mileageLog': 'Kjørebok',
  'route.bank': 'Bank',
  'route.altinn': 'Altinn',
  'route.settings': 'Innstillinger',
  'route.otherSales': 'Annet salg',
  'route.subscriptions': 'Avtaler',
  'route.incomeStatement': 'Resultatregnskap',
  'route.trialBalance': 'Saldobalanse',
  'route.budget': 'Budsjett',
  'route.payroll': 'Lønn',
  'route.taxReturn': 'Skattemelding',
  'route.yearEndClosing': 'Årsavslutning',
  'route.annualAccounts': 'Årsregnskap',
  'route.myPage': 'Min side',
  'route.employeePortal': 'Ansattportal',
  'route.activityLog': 'Aktivitetslogg',
  'route.personalFinance': 'Privatøkonomi',

  // ------------------------------------------------------------------ shell
  'shell.openMenu': 'Åpne meny',
  'shell.closeMenu': 'Lukk meny',
  'shell.collapseMenu': 'Kollaps meny',
  'shell.showLabels': 'Vis menytekst',
  'shell.hideLabels': 'Skjul menytekst',
  'shell.designSystem': 'Designsystem ↗',
  'shell.customizeMenu': 'Tilpass meny',
  'shell.customizeHelpTitle': 'Tilpass meny',
  'shell.customizeHelp': 'Velg hvilke sider som skal vises i sidemenyen. Skjul de du ikke bruker for å holde menyen ryddig.',
  'shell.customizeTitle': 'Tilpass sidemenyen',
  'shell.customizeVisible': '{visible} av {total} synlige',
  'shell.customizeLead': 'Skru av sider du ikke bruker, så skjules de fra sidemenyen. Du kan slå dem på igjen når som helst.',
  'shell.customizeAllPages': 'Alle sider', 'shell.customizeAiMode': 'AI-modus',
  'shell.customizeAlwaysOn': 'Alltid på',
  'shell.customizeDone': 'Ferdig',
  'shell.camCapture': 'Ta bilde av bilag',
  'shell.camHelp': 'Ta et bilde av et bilag med kamera og last det rett inn i Innboks eller som et nytt kjøp.',
  'shell.moreOptions': 'Flere valg',
  'shell.search': 'Søk',
  'shell.searchAll': 'Søk i alt',
  'shell.searchHelp': 'Søk i aktiv virksomhet — kunder, fakturaer, produkter, bilag, prosjekter, sider og hjelp. Trykk for å åpne søket (snarvei: Ctrl/⌘+K).',
  'shell.searchPlaceholderLong': 'Søk i alt — fakturaer, kunder, bilag…',
  'shell.searchEnterHint': 'for å se alle treff',
  'shell.companyHelpTitle': 'Velg selskap eller arbeidsgiver',
  'shell.companyHelp': 'Bytt mellom regnskapene du fører og arbeidsgiverne du er ansatt hos. Alt du ser i appen gjelder det valgte selskapet.',
  'shell.yearHelpTitle': 'Regnskapsår',
  'shell.yearHelp': 'Velg hvilket regnskapsår du jobber med. Alle tall og innleveringer gjelder det valgte året.',

  'shell.theme.helpTitle': 'Lyst / mørkt tema',
  'shell.theme.help': 'Bytt mellom lyst og mørkt utseende i hele appen. Valget huskes til neste gang.',
  'shell.theme.toLight': 'Bytt til lyst tema',
  'shell.theme.toDark': 'Bytt til mørkt tema',
  'shell.theme.light': 'Lyst tema',
  'shell.theme.dark': 'Mørkt tema',

  'shell.bg.label': 'Bakgrunnsfarge',
  'shell.bg.title': 'Bakgrunnsfarge for denne siden',
  'shell.bg.help': 'Velg bakgrunnsfarge for akkurat denne siden. Fargen lagres per side.',
  'shell.bg.menuTitle': 'Bakgrunnsfarge · denne siden',
  'shell.bg.default': 'Plomme',
  'shell.bg.mint': 'Mint',
  'shell.bg.varm': 'Varm',
  'shell.bg.sky': 'Blå',
  'shell.bg.rose': 'Rose',
  'shell.bg.skog': 'Skog',

  'skin.title': 'Utseende',
  'skin.standard': 'Standard',
  'skin.standardSub': 'Plumme',
  'skin.klassisk': 'Klassisk',
  'skin.klassiskSub': 'Nøktern',

  'shell.client.employers': 'Dine arbeidsgivere',
  'shell.client.employer': 'Arbeidsgiver',
  'shell.client.employee': 'Ansatt',
  'shell.client.private': 'Privat',
  'shell.client.firm': 'Regnskapsbyrå',
  'shell.client.firmSub': 'Klientoversikt og avstemming',

  // Regnskapsbyra-flaten
  'rf.firm': 'Regnskapsbyrå',
  'rf.role.owner': 'Eier',
  'rf.role.admin': 'Administrator',
  'rf.role.employee': 'Medarbeider',
  'rf.group.firm': 'Regnskapsfører',
  'rf.group.team': 'Teamchat',
  'rf.group.other': 'Øvrig',
  'rf.nav.clients': 'Klientoversikt',
  'rf.nav.reconciliation': 'Avstemming',
  'rf.nav.control': 'Kontroll',
  'rf.nav.teamchat': 'Teamchat',
  'rf.nav.members': 'Medarbeidere',
  'rf.nav.clientList': 'Klienter',
  'rf.client.pageBody': 'Knytt byrået til klientene sine, og sett medarbeidere på oppdragene.',
  'rf.client.addTitle': 'Knytt til en klient',
  'rf.client.addBody': 'Klienten må ha en Plumme-konto for foretaket sitt. Byrået får tilgang først når klienten har akseptert.',
  'rf.client.billedTo': 'Hvem betaler',
  'rf.client.billedToClient': 'Klienten betaler selv',
  'rf.client.billedToFirm': 'Byrået betaler',
  'rf.client.request': 'Send forespørsel',
  'rf.client.requesting': 'Sender …',
  'rf.client.requested': 'Forespørselen er sendt til klienten',
  'rf.avst.noClient': 'Velg en klient først',
  'rf.avst.allClients': 'Alle klienter',
  'rf.avst.thisClient': 'Denne klienten',
  'rf.avst.noClientBody': 'Avstemming gjelder én klient om gangen. Åpne en klient fra klientoversikten, så følger avstemmingsmappa med.',
  'rf.client.requestedMailFailed': 'Forespørselen er sendt, men varselet på e-post kunne ikke sendes. Klienten ser den ved neste innlogging.',
  'rf.client.requestedNoRecipient': 'Forespørselen er sendt, men foretaket har ingen eier eller administrator å varsle. Ta kontakt med klienten selv.',
  'rf.client.noneTitle': 'Ingen klienter ennå',
  'rf.client.noneBody': 'Knytt byrået til en klient med organisasjonsnummeret. Klienten må godkjenne før dere får tilgang.',
  'rf.client.pendingBody': 'Klienten må godta forespørselen i sin egen Plumme-konto. Ingen i byrået har tilgang før det.',
  'rf.client.assignWho': 'Sett på oppdraget',
  'rf.client.assignPick': 'Velg medarbeider',
  'rf.client.assignRole': 'Rolle på oppdraget',
  'rf.client.assign': 'Sett på',
  'rf.client.assigned': 'Medarbeideren er satt på klienten',
  'rf.client.end': 'Avslutt oppdraget',
  'rf.client.ended': 'Oppdraget er avsluttet',
  'rf.client.endConfirm': 'Avslutt oppdraget for {name}? Tilgangen byrået har gitt medarbeiderne trekkes samtidig.',
  'fe.title': 'Et regnskapsbyrå ber om tilgang',
  'fe.theFirm': 'Byrået',
  'fe.body': 'Godtar du, får medarbeiderne byrået setter på oppdraget tilgang til regnskapet ditt. Du kan avslutte samarbeidet når som helst.',
  'fe.billedToFirm': 'Byrået betaler abonnementet',
  'fe.billedToClient': 'Du betaler abonnementet selv',
  'fe.accept': 'Gi tilgang',
  'fe.accepting': 'Godtar …',
  'fe.accepted': '{firm} har nå tilgang til regnskapet.',
  'fe.decline': 'Avslå',
  'fe.declined': 'Forespørselen er avslått.',
  'fi.title': 'Du er invitert som medarbeider',
  'fi.theFirm': 'byrået',
  'fi.body': 'Invitasjonen gir deg tilgang til selve byrået. Tilgang til den enkelte klienten får du først når byrået setter deg på et oppdrag.',
  'fi.verifyFirst': 'Bekreft e-postadressen din først. Vi har sendt en ny bekreftelseslenke.',
  'fi.accept': 'Bli med',
  'fi.accepting': 'Blir med …',
  'fi.accepted': 'Du er nå medarbeider i {firm}.',
  'fi.acceptFailed': 'Kunne ikke godta invitasjonen.',
  'fi.recheck': 'Jeg har bekreftet',
  'fi.stillUnverified': 'Adressen er fortsatt ikke bekreftet. Sjekk innboksen og søppelpost.',
  'fi.decline': 'Avslå',
  'fi.declined': 'Invitasjonen er avslått.',
  'set.firm.title': 'Regnskapsbyrå',
  'set.firm.sub': 'Byrået får tilgang til regnskapet først når du godtar, og mister den i det du avslutter samarbeidet.',
  'set.firm.none': 'Ingen regnskapsbyråer har tilgang til dette foretaket, og ingen har bedt om det.',
  'set.firm.pending': 'Venter på ditt svar',
  'set.firm.active': 'Har tilgang',
  'set.firm.end': 'Avslutt samarbeidet',
  'set.firm.endConfirm': 'Avslutt samarbeidet med {firm}? Medarbeiderne mister tilgangen til regnskapet med én gang.',
  'set.firm.ended': 'Samarbeidet er avsluttet, og tilgangen er trukket.',
  'set.firm.onlyManagers': 'Bare eier og administrator kan svare på en forespørsel.',
  'rf.create.title': 'Opprett regnskapsbyrå',
  'rf.create.eyebrow': 'Regnskapsbyrå',
  'rf.create.readyBody': 'Byrået er opprettet, og du er eier. Neste steg er å invitere medarbeiderne dine og knytte til klienter.',
  'rf.create.openSurface': 'Åpne byråflaten',
  'rf.create.body': 'Byrået hentes fra Enhetsregisteret. Du blir eier og kan invitere medarbeidere etterpå.',
  'rf.create.orgNumber': 'Organisasjonsnummer',
  'rf.create.hintDigits': 'Ni siffer. Byrået må være registrert i Enhetsregisteret.',
  'rf.create.hintReady': 'Nummeret hentes fra Enhetsregisteret når du oppretter.',
  'rf.create.hintDemo': 'Demokontoen kan bruke et oppdiktet nummer. Gi byrået et navn under.',
  'rf.create.firmName': 'Navn på byrået',
  'rf.create.nameRequired': 'Fant ikke foretaket i Enhetsregisteret. Skriv inn navnet på byrået for å fortsette.',
  'rf.create.unverifiedNote': 'Byrået opprettes uten registeroppslag og merkes som uverifisert. Det må verifiseres før ekte byråer tas i bruk.',
  'rf.create.demoNote': 'Demokontoen setter navnet selv. Vanlige kontoer får navnet fra Enhetsregisteret.',
  'rf.create.submit': 'Opprett byrå',
  'rf.create.working': 'Oppretter …',
  'rf.create.done': 'Regnskapsbyrået er opprettet',
  'rf.create.note': 'Oppslaget bekrefter at foretaket finnes. Det kontrollerer ikke om du kan opptre på vegne av det.',
  'rf.member.title': 'Stilling',
  'rf.member.email': 'E-post',
  'rf.member.person': 'Person',
  'rf.member.rights': 'Rettigheter',
  'rf.member.inviteTitle': 'Inviter en medarbeider',
  'rf.member.invite': 'Send invitasjon',
  'rf.member.inviting': 'Sender …',
  'rf.member.invited': 'Invitasjon sendt',
  'rf.member.inviteMailFailed': 'Invitasjonen er opprettet, men e-posten kunne ikke sendes.',
  'rf.member.listTitle': 'Medarbeidere',
  'rf.member.none': 'Ingen medarbeidere ennå.',
  'rf.member.updated': 'Stillingen er endret',
  'rf.member.remove': 'Fjern tilgang',
  'rf.member.removed': 'Tilgangen er fjernet',
  'rf.member.removedWithClients': 'Tilgangen er fjernet, også hos {count} klienter.',
  'rf.member.removeConfirm': 'Fjern tilgangen til {name}? All klienttilgang byrået har gitt denne personen trekkes samtidig.',
  'rf.member.removeNote': 'Når du fjerner en medarbeider, trekkes også all klienttilgang byrået har gitt personen — i alle klienter, i én operasjon.',
  'rf.member.ownerRights': 'Eier av byrået',
  'rf.member.canControl': 'Kan kontrollere',
  'rf.nav.backToApp': 'Til regnskapet mitt',
  'rf.nav.back': 'Tilbake',
  'app.nobusiness.openFirm': 'Åpne regnskapsbyrået',
  'rf.tab.close': 'Lukk fane',
  'rf.tab.assignFirst': 'Ingen er satt på oppdraget for denne klienten ennå. Tilgangen til regnskapet følger tildelingen — sett noen på oppdraget under Klienter.',
  'rf.tab.assignNeeded': 'Du er ikke satt på oppdraget for denne klienten. Be en administrator i byrået om å sette deg på det.',
  'rf.soon.clients': 'Klientoversikten kobles nå mot klientstatusen backend regner ut for hver klient.',
  'rf.soon.reconciliation': 'Avstemmingsflaten bygges nå. Tilgangsmodellen og klientstatusen den bygger på er på plass.',
  'rf.soon.control': 'Kontrollflaten kommer etter avstemming. Fire-øyne-regelen håndheves i backend når den lanseres.',
  'rf.noFirm.title': 'Du er ikke medlem av et regnskapsbyrå',
  'rf.noFirm.body': 'Du er ikke medlem av et byrå ennå. Opprett ditt eget under, eller be en administrator i byrået invitere deg — invitasjonen kommer på e-post.',
  'tc.title': 'Teamchat',
  'tc.rooms': 'Rom',
  'tc.dms': 'Direktemeldinger',
  'tc.newRoom': 'Nytt rom',
  'tc.roomName': 'Romnavn',
  'tc.roomNamePlaceholder': 'F.eks. Kontroll-teamet',
  'tc.createRoom': 'Opprett rom',
  'tc.noColleagues': 'Ingen andre i byrået ennå',
  'tc.commonRoom': 'Fellesrom',
  'tc.room': 'Rom',
  'tc.commonSubtitle': 'Felles rom for hele teamet',
  'tc.roomSubtitle': 'Rom i byrået',
  'tc.dm': 'Direktemelding',
  'tc.dmSubtitle': 'Direktemelding',
  'tc.empty': 'Ingen meldinger her ennå — skriv den første.',
  'tc.placeholder': 'Skriv en melding…',
  'tc.send': 'Send',
  'tc.unknown': 'Ukjent',
  'shell.client.clients': 'Dine klienter',
  'shell.client.signOutSub': 'Avslutt økten på denne enheten',
  'shell.client.signOutFailed': 'Kunne ikke logge ut. Prøv igjen.',
  'shell.client.none': 'Ingen foretak',
  'shell.client.noBusinesses': 'Ingen virksomheter',
  'shell.client.connecting': 'Kobler til Plumme backend',
  'shell.client.personalEconomy': 'Privatøkonomi',
  'shell.client.accountingClient': 'Regnskapsklient',
  'shell.client.org': 'Org. {org}',

  'shell.suggest.invoices': 'Fakturaer',
  'shell.suggest.customers': 'Kunder',
  'shell.suggest.vouchers': 'Bilag',

  'trial.title': 'Prøveperiode er aktiv',
  'trial.active': 'Prøveperioden er aktiv.',
  'trial.dayLeft': 'Du har {days} dag igjen.',
  'trial.daysLeft': 'Du har {days} dager igjen.',
  'trial.body': 'Alt funker - kos deg med å bli kjent med Plumme.',
  'trial.upgrade': 'Oppgrader',

  // ---------------------------------------------------- Hjem / dashboard
  'home.greeting': 'Hei igjen 👋',
  'home.registerSale': 'Registrer salg',
  'home.registerSaleHelp': 'Registrer et nytt salg eller lag en faktura til en kunde. Salget bokføres automatisk på riktig konto.',
  'home.registerPurchase': 'Registrer kjøp',
  'home.registerPurchaseHelp': 'Registrer et kjøp eller last opp et bilag. SuperPlumma foreslår konto og MVA-behandling for deg.',
  'home.aiHelp': 'Her ser du alt SuperPlumma og agentene hans har gjort automatisk – bokføring, MVA, lønn og mer. Du godkjenner med ett trykk.',
  'home.autopilot.active': 'Aktiv',
  'home.autopilot.followUp': 'Må følges opp',
  'home.autopilot.disabled': 'Deaktivert',

  'home.view.period': 'Periode',
  'home.view.analysis': 'Analyse',
  'home.view.cashflow': 'Nettoresultat',
  'home.viewLabel.period': 'Inntekt og kostnad per måned',
  'home.viewLabel.analysis': 'Fordeling inntekt vs. kostnad',
  'home.viewLabel.cashflow': 'Nettoresultat per måned',
  'home.ana.ring': 'Fordeling',
  'home.ana.gauge1': 'Nøkkeltall',
  'home.ana.gauge2': 'Finansielle nøkkeltall',
  'home.sub.yoyArrow': 'Pil viser endring fra i fjor.',
  'home.sub.exVat': 'Alle summer vises eks. MVA.',
  'home.legend.in': 'Inn',
  'home.legend.out': 'Ut',
  'home.legend.income': 'Inntekt',
  'home.legend.cost': 'Kostnad',
  'home.legend.result': 'Resultat',
  'home.legend.cashflow': 'Resultat',
  'home.selectedMonths': 'Valgte måneder:',
  'home.reset': 'Nullstill',
  'home.sumOfMonth': 'Sum av {n} måned',
  'home.sumOfMonths': 'Sum av {n} måneder',
  'home.noPrevPeriod': 'Ingen forrige periode',
  'home.fromPrevMonth': 'fra forrige måned',
  'home.fromLastYear': 'fra i fjor',
  'home.showDistribution': 'Vis fordeling',
  'home.noData': 'Ingen data',

  'home.donut.registeredIncome': 'Registrert inntekt',
  'home.donut.registeredCosts': 'Registrerte kostnader',
  'home.donut.income': 'Inntekter',
  'home.donut.costs': 'Kostnader',
  'home.donut.result': 'Resultat',
  'home.donut.breakdown': '{title} — fordeling',
  'home.donut.back': 'Tilbake',
  'home.donut.hint': 'Trykk på en del av ringen eller et KPI-kort under for å se fordelingen',

  'home.health.good': 'God',
  'home.health.balanced': 'Balansert',
  'home.health.weak': 'Svak',
  'home.gauge.explain': 'Forklar nøkkeltallet',
  'home.gauge.currentValue': 'Nåværende verdi',
  'home.gauge.assessment': 'Vurdering',
  'home.gauge.goodLevel': 'Bra nivå: {good}',
  'home.gauge.income': 'Inntekter',
  'home.gauge.income.info': 'Inntekter er summen av alt foretaket har solgt i perioden, uten merverdiavgift. Stigende inntekter over tid gir bedre handlingsrom.',
  'home.gauge.income.good': 'Stigende over tid',
  'home.gauge.costs': 'Kostnader',
  'home.gauge.costs.info': 'Kostnader er utgiftene som trengs for å drive foretaket, uten merverdiavgift. Lavere kostnader i forhold til inntekter gir bedre resultat.',
  'home.gauge.costs.good': 'Lavere enn inntektene',
  'home.gauge.result': 'Resultat',
  'home.gauge.result.info': 'Resultatet er det som er igjen når kostnadene trekkes fra inntektene. Positivt resultat betyr overskudd i perioden.',
  'home.gauge.result.good': 'Positivt og stabilt',
  'home.gauge.liquidity': 'Likviditet',
  'home.gauge.liquidity.info': 'Likviditet viser evnen til å betale regninger og kortsiktig gjeld når de forfaller. Høyere verdi gir bedre buffer.',
  'home.gauge.liquidity.good': 'Over 1,0x, helst over 2,0x',
  'home.gauge.profitability': 'Lønnsomhet',
  'home.gauge.profitability.info': 'Lønnsomhet viser hvor stor andel av inntektene som blir igjen som resultat. Jo høyere prosent, jo mer tjener foretaket per krone solgt.',
  'home.gauge.profitability.good': 'Positiv og stigende',
  'home.gauge.solidity': 'Soliditet',
  'home.gauge.solidity.info': 'Soliditet viser hvor stor del av foretaket som er finansiert med egenkapital. Høyere soliditet gjør foretaket mer robust.',
  'home.gauge.solidity.good': 'Høyere egenkapitalandel over tid',

  'home.assistant.sub': 'Regnskapsassistent',
  'home.assistant.intro': 'Hei! Jeg kan gjøre enkle handlinger for deg, lage fakturaer, registrere kjøp, forklare avgifter og bokføre bilag fra innboksen. Spør i vei. Ønsker du økonomisk rådgivning så er rådgiver tilgjengelig via AI Rådgiver siden.',
  'home.assistant.thinking': 'SuperPlumma tenker...',
  'home.assistant.placeholder': 'Spør SuperPlumma...',
  'home.assistant.noReply': 'SuperPlumma fikk ikke noe svar fra backend.',
  'home.assistant.errorReply': 'Kunne ikke hente svar fra assistenten akkurat nå.',
  'home.assistant.errorToast': 'Kunne ikke hente assistentsvar.',
  'home.assistant.cancel': 'Avbryt',
  'home.assistant.opened': 'Jeg åpnet riktig side med forslaget klart for kontroll.',
  'home.assistant.openedToast': 'Åpnet riktig flyt',
  'home.assistant.noAdapter': 'Denne handlingen har ikke en Plumme-adapter ennå.',
  'home.assistant.paymentNotConnected': 'Betalingsregistrering er ikke koblet til backend.',
  'home.assistant.paymentRegistered': 'Betaling på {sum} er registrert på faktura{number}.',
  'home.assistant.paymentToast': 'Betaling registrert',
  'home.assistant.paymentFailed': 'Kunne ikke registrere betalingen.',
  'home.assistant.cancelled': 'Greit, jeg gjorde ingen endring.',
  'home.assistant.sugg1': 'Hvor mye skylder jeg i avgifter?',
  'home.assistant.sugg2': 'Lag en faktura til en kunde',
  'home.assistant.sugg3': 'Hva er MVA?',

  'home.action.register_payment': 'Godkjenn betaling',
  'home.action.create_invoice': 'Åpne fakturautkast',
  'home.action.create_other_sale': 'Åpne annet salg',
  'home.action.create_expense': 'Åpne nytt kjøp',
  'home.action.register_purchase': 'Åpne nytt kjøp',
  'home.action.create_customer': 'Lagre kunde',
  'home.action.create_supplier': 'Lagre leverandør',
  'home.action.create_product': 'Lagre produkt',
  'home.action.suggest_accounting_entry': 'Åpne fri postering',
  'home.action.create_mileage_entry': 'Åpne kjørebok',
  'home.action.send_sales_document': 'Åpne fakturaliste',
  'home.action.book_bank_lines': 'Åpne bank',
  'home.action.link_bank_receipts': 'Åpne bank',
  'home.action.annul_bank_posting': 'Åpne bank',
  'home.action.reporting_preparation': 'Åpne innleveringer',
  'home.action.default': 'Åpne flyt',

  'home.followup.title': 'Oppfølging',
  'home.followup.allClear': 'Alt er under kontroll',
  'home.followup.allClearSub': 'Ingenting å følge opp akkurat nå. Plumme sier fra når noe trenger oppmerksomhet.',
  'home.followup.next': 'Gå videre',
  'home.followup.showMore': 'Vis mer',
  'home.followup.modalTitle': 'Oppgaver som må løses',
  'home.followup.sales': 'Salg',
  'home.followup.purchases': 'Kjøp',
  'home.followup.toInvoiceList': 'Gå til fakturaliste',
  'home.followup.toVoucherList': 'Gå til bilagsliste',
  'home.followup.draftInvoices': 'Du har {n} fakturautkast som ikke er ferdigstilt.',
  'home.followup.unsentInvoices': 'Du har {n} fakturaer som er klare, men ikke sendt.',
  'home.followup.overdueInvoices': 'Du har {n} uoppgjorte forfalte fakturaer.',
  'home.followup.openPurchases': 'Du har {n} uoppgjorte leverandørfakturaer.',
  'home.followup.missingAttachments': 'Du har {n} kjøp uten bilag.',
  'home.followup.bank': 'Bankavstemming',
  'home.followup.toBank': 'Gå til bankavstemming',
  'home.followup.missingBankStatements': 'Driftskonto mangler bankutskrift for {months}',

  'home.overview.sales': 'Salg',
  'home.overview.purchases': 'Kjøp',
  'home.overview.outstandingSales': 'Utestående salg',
  'home.overview.outstandingPurchases': 'Utestående kjøp',
  'home.overview.salesHelp': 'Utestående salg er fakturaer kundene dine ennå ikke har betalt. Grønt er innen forfall, gult er forfalt — følg opp de forfalte med en purring.',
  'home.overview.purchasesHelp': 'Utestående kjøp er leverandørfakturaer du ennå ikke har betalt. Grønt er innen forfall, gult er forfalt og bør betales snart.',
  'home.overview.importedSubledger': 'Herav importert reskontro: {amount}',
  'home.overview.inclVat': 'Beløpene er inkl. MVA.',
  'home.overview.helpTitle': 'Utestående {what}',
  'home.overview.withinDue': 'Innen frist',
  'home.overview.overdue': 'Forfalt',
  'home.overview.statusTitle': '{within} % innen frist · {over} % forfalt',

  'home.deadlines.title': 'Kommende frister',
  'home.deadlines.help': 'Kommende innleveringsfrister - MVA-melding, skattemelding, årsregnskap og aksjonærregisteroppgave, med status for hver.',
  'home.deadlines.none': 'Ingen frister funnet i backend-data.',
  'home.deadlines.seeStatus': 'Se status',
  'home.deadlines.helpTax': 'Skattemeldingen samler regnskap og skatteberegning for året. Plumme hjelper deg å kontrollere tallene før innsending.',
  'home.deadlines.helpAnnualAccounts': 'Årsregnskapet samler resultat, balanse og noter for regnskapsåret og sendes til Regnskapsregisteret når det er klart.',
  'home.deadlines.helpAnnualClosing': 'Årsavslutningen lukker regnskapsåret med kontroller, disponering og nødvendige avslutningsposteringer.',
  'home.deadlines.helpShareholderRegister': 'Aksjonærregisteroppgaven (RF-1086) leveres av aksjeselskaper innen 31. januar året etter inntektsåret. Plumme har ingen innsending for den — dette er en påminnelse.',
  'home.deadlines.helpVat': 'MVA-meldingen rapporterer utgående og inngående merverdiavgift for terminen.',
  'home.deadlines.helpFallback': 'Frist for {name}. Plumme varsler og hjelper deg videre fra statusvisningen.',
  'home.deadlines.fallbackName': 'innsending',
  'home.deadlines.name.shareholderRegister': 'Aksjonærregisteroppgaven',
  'home.fees.title': 'Offentlige avgifter',
  'home.fees.help': 'Oversikt over hva du skylder det offentlige akkurat nå - merverdiavgift (MVA), forskuddstrekk og arbeidsgiveravgift. Beregnes løpende fra bokføringen.',
  'home.fees.none': 'Ingen åpne offentlige avgifter funnet.',

  'home.balances.title': 'Saldo',
  'home.balances.help': 'Bokført saldo på bank-, kontant- og andre kontoer. Tallene kommer fra saldobalansen, så de viser hva regnskapet sier - ikke hva banken har rukket å oppdatere. Med tannhjulet velger du hvilke kontoer som vises, og kan søke opp flere fra kontoplanen. Driftskontoen og kontantkassa kan skjules, men ikke fjernes.',
  'home.balances.choose': 'Velg kontoer',
  'home.balances.total': 'Totalt',
  'home.balances.accountFallback': 'Konto {code}',
  'home.balances.noneSelected': 'Ingen kontoer valgt.',
  'home.balances.searchPlaceholder': 'Søk i kontoplanen …',
  'home.balances.noHits': 'Ingen treff',
  'home.balances.remove': 'Fjern fra kortet',
  'home.balances.saveFailed': 'Kunne ikke lagre kontovalget.',

  // ----------------------------------------------------- Innstillinger
  'set.account': 'Konto',
  'set.amount': 'Beløp',
  'set.page': 'Side',
  'set.debit': 'Debet',
  'set.credit': 'Kredit',
  'set.remove': 'Fjern',
  'set.ib.title': 'Inngående balanse',
  'set.ib.startWizard': 'Start veiviseren for å opprette inngående balanse',
  'set.ib.confirmDate': 'Bekreft oppstartsdatoen',
  'set.ib.setUp': 'Sett opp inngående balanse',
  'set.ib.confirmDateInPlumme': 'Bekreft oppstartsdatoen i Plumme',
  'set.ib.startDate': 'Oppstartsdato',
  'set.back': 'Tilbake',
  'set.ib.dateOk': 'Datoen stemmer, gå videre',
  'set.ib.draftEmpty': 'Utkastet er tomt.',
  'set.text': 'Tekst',
  'set.toDebit': 'Til (debet)',
  'set.fromCredit': 'Fra (kredit)',
  'set.editLine': 'Rediger linje',
  'set.removeLine': 'Fjern linje',
  'set.quickPick': 'Hurtigvalg',
  'set.addNewLine': 'Legg til ny linje',
  'set.saved': 'Lagret',
  'set.startOver': 'Start på nytt',
  'set.ib.finish': 'Fullfør inngående balanse',
  'set.ib.summary': 'Oppsummering - beløp inn og ut fra kontoer',
  'set.ib.openNote': 'Posteringen er åpen og kan endres fra denne visningen.',
  'set.ib.intoAccount': 'Inn på konto',
  'set.ib.outOfAccount': 'Ut fra konto',
  'set.sum': 'Sum',
  'set.ib.openEntry': 'Åpen postering',
  'set.accountNo': 'Kontonr.',
  'set.name': 'Navn',
  'set.vatCode': 'Mva-kode',
  'set.description': 'Beskrivelse',
  'set.relevantLinks': 'Relevante linker',
  'set.deleteCancel': 'Slett / annuller',
  'set.ib.edit': 'Endre inngående balanse',
  'set.ib.openingForAccount': 'Inngående saldo for konto',
  'set.cancel': 'Avbryt',
  'set.save': 'Lagre',
  'set.ib.postDescription': 'Beskrivelse av posten',
  'set.pickAccount': 'Velg konto ...',
  'set.accountDebit': 'Konto (debet)',
  'set.ib.cannotBeEmpty': 'Kan ikke opprette tom inngående balanse',
  'set.continueTitle': 'Fortsett?',
  'set.ib.post': 'Bokfør inngående balanse',
  'set.ib.draftTitle': 'Utkast for inngående balanse',
  'set.ib.draftHelp': 'Legg inn balansetall fra forrige system, så saldobalansen starter riktig i Plumme.',
  'set.noteOptional': 'Notat (valgfritt)',
  'set.notePh': 'For eksempel hva som ble importert og fra hvilken dato',
  'set.ib.lines': 'Balanselinjer',
  'set.ib.linesHelp': 'Balansetallene ved overgangsdatoen, fordelt på konto: eiendeler, egenkapital og gjeld fra det gamle systemet. Før én linje per konto så balansen starter med riktige tall i Plumme.',
  'set.ib.addLine': 'Legg til balanselinje',
  'set.startup.title': 'Oppstartstall',
  'set.startup.introText': 'Bruk denne hvis du flytter til Plumme midt i {year}. Du fører MVA og resultattall fra tidligere system, så rapportene og skattemeldingen fortsetter riktig fra overgangsdatoen.',
  'set.startup.startWizard': 'Start veiviseren for å legge inn oppstartstall',
  'set.startup.stepDate': 'Overgangsdato og MVA',
  'set.startup.stepLines': 'Salg og kostnader',
  'set.startup.confirmTitle': 'Bekreft overgangsdato og MVA så langt',
  'set.startup.linesTitle': 'Fordel tallene før {date}',
  'set.startup.save': 'Lagre oppstartstall',
  'set.startup.receiptTitle': 'Oppstartstall pr. {date}',
  'set.startup.receiptSub': 'Lagret for overgangen til Plumme',
  'set.startup.receiptLines': '{lines} linjer registrert - {sales} salg og {costs} kostnad.',
  'set.startup.edit': 'Endre oppstartstall',
  'set.transitionDate': 'Overgangsdato',
  'set.transitionDateHelp': 'Datoen du gikk over til Plumme. Oppstartstallene gjelder perioden fra årets start frem til denne datoen, ført i det gamle systemet.',
  'set.outputVatBefore': 'Utgående MVA før oppstart',
  'set.outputVatBeforeHelp': 'MVA du allerede har krevd inn på salg så langt i året, før overgangen. Legges til årets MVA-tall så mva-meldingen blir riktig.',
  'set.inputVatBefore': 'Inngående MVA før oppstart',
  'set.inputVatBeforeHelp': 'MVA du allerede har betalt på kjøp så langt i året (og har fradrag for), før overgangen.',
  'set.salesByAccount': 'Salg fordelt på konto',
  'set.salesByAccountHelp': 'Salgsinntektene så langt i året, fordelt på inntektskonto. Før én linje per salgskonto så resultatregnskapet starter med riktige tall.',
  'set.salesByAccountBefore': 'Salg fordelt på konto før oppstart',
  'set.addSalesLine': 'Legg til salgslinje',
  'set.noSalesLines': 'Ingen salgslinjer enda.',
  'set.costsByAccount': 'Kostnader fordelt på konto',
  'set.costsByAccountHelp': 'Kostnadene så langt i året, fordelt på kostnadskonto. Før én linje per kostnadskonto så resultatet blir riktig fra overgangsdatoen.',
  'set.costsByAccountBefore': 'Kostnader fordelt på konto før oppstart',
  'set.addCostLine': 'Legg til kostnadslinje',
  'set.noCostLines': 'Ingen kostnadslinjer enda.',
  'set.import.title': 'Importer komplett regnskap',
  'set.import.pickPackage': 'Velg eksportfiler',
  'set.import.shouldContain': 'Pakken bør inneholde',
  'set.import.saft': 'SAF-T Financial XML',
  'set.import.parties': 'Kunde- og leverandørregister, gjerne Excel eller CSV',
  'set.import.chart': 'Kontoplan',
  'set.import.vouchers': 'Bilag, kvitteringer og fakturaer som PDF eller bilder',
  'set.import.bankRecs': 'Bankavstemminger og fakturakopier',
  'set.import.firstStep': 'Første steg i Plumme',
  'set.import.readsStructure': 'Leser filstrukturen',
  'set.import.findsFiles': 'Finner SAF-T, Excel og bilagsfiler',
  'set.import.buildsAnalysis': 'Lager en importanalyse',
  'set.import.letsApprove': 'Lar deg godkjenne trygg import av kontoplan, kunder, leverandører og inngående balanse',
  'set.import.notAutomatic': 'Ikke automatisk ennå',
  'set.import.noPromise': 'Plumme lover ikke at alt blir eksakt identisk med forrige system',
  'set.import.noHistoric': 'Historiske posteringer bokføres ikke uten godkjenning',
  'set.import.nothingToAltinn': 'Ingenting sendes til Altinn',
  'set.import.noOverwrite': 'Eksisterende bilag slettes eller overskrives ikke uten bekreftelse',
  'set.close': 'Lukk',
  'set.import.approveBase': 'Godkjenn grunnlagsimport',
  'set.import.working': 'Jobber...',
  'set.import.uploading': 'Opplasting til Firebase Storage',
  'set.import.serverReading': 'Serveren leser importfilene nå',
  'set.import.importingBase': 'Importerer grunnlagsdata',
  'set.import.savedInAccounts': 'Importen er lagret i regnskapet',
  'set.import.checkBefore': 'Kontroller kontoplan, kunder, leverandører og inngående balanse før rapportering.',
  'set.import.dataOnlyTitle': 'Importer kun regnskapsdata (anbefalt)',
  'set.import.dataOnlyHelp': 'Plumme lager en filtrert kopi i nettleseren med SAF-T, CSV og Excel. PDF-er, bilder og andre dokumenter lastes ikke opp.',
  'set.import.dataOnlyKeepOriginal': 'Behold den originale ZIP-filen fra Fiken.',
  'set.import.dataOnlyFiltering': 'Fjerner dokumenter før opplasting',
  'set.import.dataOnlyFilteringHelp': 'Originalfilen endres ikke. Bare den nye, filtrerte datapakken sendes til Plumme.',
  'set.import.dataOnlyFiltered': '{count} dokument- og bilagsfiler ble utelatt fra opplastingen.',
  'set.import.dataOnlyLibraryFailed': 'Kunne ikke laste ZIP-filteret. Prøv igjen eller pakk ut SAF-T, CSV og Excel manuelt.',
  'set.import.dataOnlyNoFiles': 'Fant ingen SAF-T-, CSV- eller Excel-filer i ZIP-pakken.',
  'set.import.packages.title': 'Lagrede importpakker',
  'set.import.packages.help': 'Her ser du alle ZIP-filer og hvilken pakke som er aktiv kilde for importarkivet.',
  'set.import.packages.loading': 'Laster pakker...',
  'set.import.packages.empty': 'Ingen lagrede ZIP-filer.',
  'set.import.packages.statusImported': 'Aktiv import',
  'set.import.packages.statusDuplicate': 'Identisk duplikat',
  'set.import.packages.statusPrevious': 'Tidligere import',
  'set.import.packages.statusAnalyzed': 'Lest av',
  'set.import.packages.statusFailed': 'Avlesning feilet',
  'set.import.packages.statusAnalyzing': 'Leses av',
  'set.import.packages.statusUploaded': 'Lastet opp',
  'set.import.packages.uploadedAt': 'Lastet opp {date}',
  'set.import.packages.readAt': 'Sist lest av {date}',
  'set.import.packages.importedAt': 'Importert til regnskapet {date}',
  'set.import.packages.notAvailable': 'Ukjent tidspunkt',
  'set.import.packages.unknownSize': 'Ukjent størrelse',
  'set.import.packages.deleteConfirm': 'Slette {name}? ZIP-filen og midlertidige analysedata fjernes permanent. Ingen regnskapsdata er importert fra denne pakken.',
  'set.import.packages.deletePreviousConfirm': 'Slette den tidligere importpakken {name}? Importerte regnskapsdata blir stående. Dokumenter som bare finnes i denne eldre ZIP-filen, kan ikke åpnes etter sletting.',
  'set.import.packages.deleteDialogTitle': 'Slett importpakke?',
  'set.import.packages.deleteDialogBody': 'Du er i ferd med å slette {name}. ZIP-filen og tilhørende analysedata fjernes permanent fra backend.',
  'set.import.packages.deletePreviousBody': 'Du er i ferd med å slette den tidligere importpakken {name}. Regnskapsdata blir stående, men dokumenter som bare finnes i denne ZIP-filen, kan ikke åpnes etterpå.',
  'set.import.packages.deleteIrreversible': 'Denne handlingen kan ikke angres.',
  'set.import.packages.replaceTitle': 'Erstatt eksisterende importpakke?',
  'set.import.packages.replaceBody': 'Du har allerede importpakken {name}. Når den nye pakken er analysert og godkjent, blir den nye aktiv og alle eldre ZIP-pakker slettes fra backend.',
  'set.import.packages.replaceSafety': 'Den eksisterende pakken beholdes mens den nye lastes opp og analyseres. Hvis analysen feiler eller avbrytes, forblir dagens aktive pakke urørt.',
  'set.import.packages.replacePermanent': 'Etter godkjenning kan sletting av den gamle pakken ikke angres.',
  'set.import.packages.chooseReplacement': 'Velg ny ZIP',
  'set.import.packages.deleteProtected': 'Pakken er brukt i regnskapet og kan ikke slettes her.',
  'set.import.packages.protectedHelp': 'Dette er den aktive kilden for importerte bilagsdokumenter og kan derfor ikke slettes.',
  'set.import.packages.duplicateHelp': 'Filinnholdet er identisk med den aktive importpakken og kan slettes.',
  'set.import.packages.deleting': 'Sletter...',
  'set.import.packages.delete': 'Slett',
  'set.import.packages.deleted': 'Importpakken er slettet.',
  'set.import.packages.deleteFailed': 'Kunne ikke slette importpakken.',
  'set.import.packages.deleteMissing': 'Mangler lagringssti for importpakken.',
  'set.import.packages.download': 'Last ned ZIP',
  'set.import.packages.downloading': 'Klargjør...',
  'set.import.packages.downloadMissing': 'Mangler lagringssti for importpakken.',
  'set.import.packages.downloadStarted': 'Nedlasting av original ZIP er startet.',
  'set.import.packages.downloadFailed': 'Kunne ikke laste ned importpakken.',
  'set.import.years.title': 'Velg dataår',
  'set.import.years.help': 'Bare data og tall for valgte år importeres. Registre og dokumentarkivet behandles separat.',
  'set.import.years.recommended': 'Anbefalt periode',
  'set.import.years.previousOnly': 'Bare tidligere år',
  'set.import.years.all': 'Alle år',
  'set.import.years.current': 'gjeldende år',
  'set.import.years.retentionWarning': 'Du har valgt bort {years}, som kan være innenfor vanlig oppbevaringsperiode. Sørg for at materialet oppbevares et annet sted.',
  'set.import.years.documentsPreserved': 'Original-ZIP og dokumentarkiv beholdes komplett uavhengig av årsvalget.',
  'set.import.years.importedTitle': 'Importerte dataår',
  'set.import.years.importedHelp': 'Du kan fjerne importerte tall for ett år uten å slette ZIP, dokumentarkiv eller manuelt opprettede poster.',
  'set.import.years.removeYear': 'Fjern importerte data for {year}',
  'set.import.years.removeTitle': 'Fjern importerte data for {year}?',
  'set.import.years.removeBody': 'Importert inngående balanse, rapporthistorikk, årsspesifikke åpne poster og importerte kontrollstatuser for {year} fjernes.',
  'set.import.years.removePreserves': 'Manuelle fakturaer, kjøp, bilag, registre, original-ZIP og dokumentarkiv beholdes.',
  'set.import.years.removeConfirm': 'Fjern data',
  'set.import.years.removing': 'Fjerner...',
  'set.import.years.removed': 'Fjernet {count} importerte datapunkter for {year}.',
  'set.import.years.removeFailed': 'Kunne ikke fjerne importerte årsdata.',
  'set.import.years.invalid': 'Velg et gyldig importår.',
  'set.import.years.selectedLedgerRows': 'historikklinjer i valgte år',
  'set.showAll': 'Vis alle',
  'set.count.accounts': 'saldokontoer',
  'set.count.customers': 'kunder',
  'set.count.products': 'produkter',
  'set.count.openSalesInvoices': 'åpne kundefakturaer',
  'set.count.openPurchaseInvoices': 'åpne leverandørfakturaer',
  'set.count.suppliers': 'leverandører',
  'set.count.openingBalances': 'inngående balanser',
  'set.import.after': 'Etter import',
  'set.noMatches': 'Ingen treff.',
  'set.preview': 'Forhåndsvisning',
  'set.previewHeading': 'Slik ser dokumentet ut',
  'set.preview.sender': 'Avsender:',
  'set.preview.invoiceNo': 'Fakturanr.:',
  'set.preview.invoiceDate': 'Fakturadato:',
  'set.preview.dueDate': 'Forfallsdato:',
  'set.preview.accountNo': 'Kontonr.:',
  'set.preview.toPay': 'Å betale:',
  'set.preview.docType': 'FAKTURA',
  'set.preview.noCustomer': 'Ingen kunde valgt ennå',
  'set.preview.net': 'Netto',
  'set.preview.vat': 'MVA',
  'set.preview.toPayShort': 'Å betale',
  'set.menu.title': 'Sidemeny',
  'set.menu.help': 'Velg hvilke sider som vises i menyen til venstre. Kjernesider er alltid synlige.',
  'set.menu.showAll': 'Vis alle sider',
  'set.xlsx': 'XLSX',
  'set.csv': 'CSV',
  'set.import': 'Importer',
  'set.data.accountingTitle': 'Import / Eksport av Regnskap',
  'set.data.accountingSub': 'Importer fra annet regnskapssystem med én eller flere ZIP-, SAF-T-, CSV- eller Excel-filer, og eksporter backup og bokføringsoversikt.',
  'set.export': 'Eksporter',
  'set.data.invoiceCsv': 'Faktura CSV',
  'set.data.invoiceTemplate': 'Fakturaimport-mal',
  'set.data.bookkeepingCsv': 'Bokføring CSV',
  'set.data.reusePackage': 'Bruker den opplastede eksportfilen på nytt, uten ny opplasting.',
  'set.data.resetAll': 'Nullstill all data',
  'set.data.deleteBusiness': 'Slett foretak',
  'set.data.onlyOwnerSchedule': 'Bare eier kan planlegge sletting.',
  'set.doc.tab': 'Dokumenter',
  'svc.mcpMissingRedirect': 'MCP-tjenesten returnerte ingen sikker videresending.',
  'route.dailySettlements': 'Dagsoppgjør',
  'nav.dailySettlements': 'Dagsoppgjør',
  'navhelp.dailySettlements': 'Dagsoppgjør fra kassesystemer, bookingsystemer, utleieplattformer og nettbutikker. Kontroller og godkjenn før bokføring.',
  'dailySettlement.title': 'Dagsoppgjør',
  'dailySettlement.sub': 'Oppgjør fra kasse, booking, utleie og nettbutikk. Ingenting bokføres før du godkjenner det.',
  'dailySettlement.refresh': 'Oppdater',
  'dailySettlement.loadError': 'Kunne ikke hente dagsoppgjørene.',
  'dailySettlement.openSettings': 'Åpne integrasjoner',
  'dailySettlement.emptyTitle': 'Ingen dagsoppgjør her',
  'dailySettlement.emptyText': 'Når en kilde er koblet til og har levert et oppgjør, dukker det opp her til kontroll og godkjenning.',
  'dailySettlement.filter.open': 'Til behandling',
  'dailySettlement.filter.ready': 'Klar',
  'dailySettlement.filter.review': 'Må kontrolleres',
  'dailySettlement.filter.done': 'Ferdig',
  'dailySettlement.status.ready': 'Klar til godkjenning',
  'dailySettlement.status.review': 'Må kontrolleres',
  'dailySettlement.status.approved': 'Bokført',
  'dailySettlement.status.dismissed': 'Avsluttet uten bokføring',
  'dailySettlement.attentionTitle': 'Kilder som trenger oppmerksomhet',
  'dailySettlement.attentionStale': '{provider} har ikke levert oppgjør på {days} dager. Siste var {date}.',
  'dailySettlement.attentionNever': '{provider} er tilkoblet, men har aldri levert et oppgjør.',
  'dailySettlement.homeWaiting': '{ready} klar til godkjenning, {review} må kontrolleres.',
  'dailySettlement.homeAction': 'Se dagsoppgjør',
  'set.doc.title': 'Dokumenter',
  'set.doc.sub': 'Last opp og oppbevar egne dokumenter, f.eks. avtaler, forsikringer eller vedtekter.',
  'set.doc.drop': 'Dra filer hit',
  'set.doc.dropHint': 'Eller trykk for å velge fil',
  'set.doc.empty': 'Ingen dokumenter lastet opp ennå.',
  'set.doc.added': 'Lagt til',
  'set.doc.new': 'Nytt dokument',
  'set.doc.edit': 'Rediger dokument',
  'set.doc.remove': 'Fjern dokument',
  'set.doc.open': 'Åpne dokument',
  'set.doc.add': 'Legg til dokument',
  'set.doc.name': 'Navn',
  'set.doc.namePh': 'F.eks. Ansvarsforsikring 2026',
  'set.doc.nameRequired': 'Gi dokumentet et navn først',
  'set.doc.type': 'Type',
  'set.doc.attachTo': 'Legges ved som standard i',
  'set.doc.attachToHint': 'Dokumentet følger automatisk med disse dokumenttypene til kunde — kan fjernes per sending.',
  'set.doc.uploading': 'Laster opp...',
  'set.doc.uploaded': 'Dokument lastet opp',
  'set.doc.saved': 'Dokument oppdatert',
  'set.doc.deleted': 'Dokument fjernet',
  'set.doc.deleteConfirm': 'Slette dokumentet «{name}»?',
  'set.doc.fileHint': 'PDF, Word, Excel, JPG, PNG eller WEBP. Maks 10 MB.',
  'set.doc.unavailable': 'Dokumentsiden ble ikke lastet inn. Last siden på nytt — vises den fortsatt tom, er det en feil vi må se på.',
  'set.doc.target.offer': 'Tilbud',
  'set.doc.target.orderConfirmation': 'Ordrebekreftelser',
  'set.doc.target.invoice': 'Faktura',
  'set.doc.target.creditNote': 'Kreditnota',
  'set.doc.target.subscription': 'Abonnement og lister',
  'set.doc.target.subscriptionHint': 'Følger med e-post du sender fra et abonnement eller en kundeliste.',
  'set.doc.kind.agreement': 'Avtale',
  'set.doc.kind.insurance': 'Forsikring',
  'set.doc.kind.articles': 'Vedtekter / stiftelsesdokument',
  'set.doc.kind.authorization': 'Fullmakt',
  'set.doc.kind.certificate': 'Sertifikat',
  'set.doc.kind.standard_attachment': 'Standard vedlegg',
  'set.doc.kind.other': 'Annet',
  'sale.att.standard': 'Standard',
  'sale.att.removeStandard': 'Ikke ta med denne gangen',
  'sale.att.remove': 'Fjern vedlegg',
  'sub.standardDocs': 'Standarddokumenter som følger med: {names}',
  'set.data.saftXml': 'SAF-T XML (beta)',
  'set.acc.title': 'Regnskapsoppsett',
  'set.acc.sub': 'Grunninnstillinger for regnskapet: første regnskapsår, MVA-registrering, regnskapsmetode og lignende.',
  'set.acc.startYear': 'Startår',
  'set.acc.startYearHelp': 'Første regnskapsåret du fører i Plumme. Bilag og rapporter før dette året hører hjemme i et tidligere system.',
  'set.acc.startInvoiceNo': 'Start fakturanummer',
  'set.acc.startInvoiceNoHelp': 'Nummeret den første fakturaen din skal få. Kommer du fra et annet system, sett dette høyere enn siste brukte nummer så du får en sammenhengende nummerrekke (et lovkrav).',
  'set.acc.vatStatus': 'MVA-status',
  'set.acc.vatStatusHelp': 'Om foretaket er registrert i Merverdiavgiftsregisteret. Du blir MVA-pliktig når avgiftspliktig omsetning passerer 50 000 kr på 12 måneder. MVA-registrert betyr at du krever inn MVA på salg og får fradrag på kjøp.',
  'set.acc.vatRegistered': 'MVA-registrert',
  'set.acc.notVatRegistered': 'Ikke MVA-registrert',
  'set.acc.vatRegisteredFrom': 'MVA-registrert fra',
  'set.acc.vatRegisteredWhen': 'Var foretaket MVA-registrert allerede 1. januar {year}?',
  'set.acc.vatRegisteredWhenHelp': 'Regnskapet i Plumme starter {year}. Fra MVA-datoen beregnes MVA på salg og kjøp — før den, ingen. Svarer du «ja», settes datoen til 1. januar {year}.',
  'set.acc.vatRegisteredPick': 'Velg svar',
  'set.acc.vatRegisteredAtStart': 'Ja, registrert før {year}',
  'set.acc.vatRegisteredLater': 'Nei, registrert i løpet av {year} eller senere',
  'set.acc.vatRegisteredUnknown': 'Vet ikke',
  'set.acc.vatRegisteredFromHelp': 'Datoen foretaket ble MVA-registrert. Før denne datoen beregnes ingen MVA; fra og med den føres MVA på salg og kjøp.',
  'set.acc.standardVat': 'Forslag på nye salgslinjer',
  'set.acc.standardVatHelp': 'Dette er bare satsen Plumme foreslår når du lager en ny salgslinje. Foretaket kan bruke flere MVA-satser, og produktet eller fakturalinjen kan overstyre forslaget.',
  'set.acc.howFileVat': 'Hvordan leverer du MVA',
  'set.acc.vatPeriod': 'MVA-termin',
  'set.acc.vatPeriodHelp': 'Hvor ofte du leverer mva-melding. De fleste leverer annenhver måned (6 terminer i året). Små foretak under 1 mill. kr kan søke om årlig levering. Kvartalsvis og månedlig brukes i særtilfeller.',
  'set.acc.midYearTitle': 'Start midt i året (oppstartstall)',
  'set.acc.midYearHelp': 'Bruk denne hvis du tar i bruk Plumme midt i et regnskapsår. Da legger du inn oppstartstall — salg, kostnader og MVA så langt i året — fra det gamle systemet, slik at årsrapporter og mva-melding fortsetter med riktige tall.',
  'set.acc.midYear': 'Start midt i året',
  'set.acc.enterOpening': 'Legg inn oppstartstall',
  'set.acc.enterOpeningHelp': 'Åpner skjemaet der du fører overgangsdato, MVA så langt og salg/kostnader fordelt på konto fra det forrige systemet.',
  'set.acc.ibHelp': 'Inngående balanse er eiendelene, egenkapitalen og gjelden selskapet hadde ved årets begynnelse — altså utgående balanse fra fjoråret. Legg den inn når du starter et nytt regnskapsår i Plumme, så balansen stemmer fra dag én.',
  'set.acc.viewIb': 'Se / rediger inngående balanse',
  'set.acc.viewIbHelp': 'Åpner inngående balanse du har bokført, der du kan se linjene, redigere dem eller slette balansen.',
  'set.acc.addIb': 'Legg inn inngående balanse',
  'set.acc.addIbHelp': 'Åpner en veiviser som hjelper deg å sette opp inngående balanse — du bekrefter oppstartsdato og legger inn balanselinjene (debet/kredit) fra fjoråret.',
  'set.acc.extraAccountsHelp': 'Legg til ekstra kontoer bare når saldobalansen eller eksporten trenger dem.',
  'set.acc.searchPlaceholder': 'Søk i kontoplanen på nummer eller navn',
  'set.acc.searchNoHits': 'Ingen kontoer treffer «{query}».',
  'set.acc.addAccount': 'Legg til konto',
  'set.acc.addAccountHelp': 'Oppretter en egendefinert konto i kontoplanen. Bruk det bare når en konto du trenger mangler — de fleste standardkontoer finnes allerede.',
  'set.acc.accountNameHelp': 'Et beskrivende navn på kontoen, slik den vises i kontoplanen og rapportene — f.eks. «Programvare/abonnement».',
  'set.acc.accountNoHelp': 'Firesifret kontonummer. Første siffer bestemmer kontoklassen: 1 eiendeler, 2 egenkapital/gjeld, 3 inntekter, 4–7 kostnader, 8 finans og skatt.',
  'set.acc.accountClass': 'Kontoklasse',
  'set.acc.accountClassHelp': 'Hovedgruppen kontoen havner i, utledet automatisk fra første siffer i kontonummeret. Den styrer om kontoen er en eiendel, gjeld, inntekt eller kostnad.',
  'set.acc.equivalent': 'Tilsvarer konto',
  'set.acc.equivalentHelp': 'Kobler den egendefinerte kontoen til en standardkonto. Det forteller Plumme hvordan kontoen skal behandles i årsavslutning og skattemelding — så egne kontoer havner riktig i de offentlige skjemaene.',
  'set.acc.createAccount': 'Opprett konto',
  'set.acc.ownAccounts': 'Egne kontoer',
  'set.acc.ownAccountsHelp': 'Kontoene du selv har lagt til, ut over standardkontoplanen. Bare disse kan endres eller slettes.',
  'set.acc.noOwnAccounts': 'Ingen egne kontoer enda.',
  'set.acc.removeAccount': 'Fjern konto',
  'set.acc.deactivated': 'deaktivert',
  'set.acc.standardAccounts': 'Standardkontoer',
  'set.acc.standardAccountsHelp': 'Den innebygde standardkontoplanen (NS 4102). Disse er felles for alle og brukes automatisk når du bokfører — du trenger sjelden å legge til egne.',
  'set.bank.title': 'Bankavstemming',
  'set.bank.help': 'Bankavstemming hjelper deg å kontrollere at kjøp, salg og betalinger er bokført én gang og stemmer med driftskontoen.',
  'set.bank.activeFrom': 'Aktiv fra',
  'set.bank.accounts': 'Bankkontoer',
  'set.bank.primaryHelp': 'Den primære fakturakontoen er standardkontoen kundene betaler til.',
  'set.bank.disabled': 'Deaktivert',
  'set.bank.invoiceAccount': 'Fakturakonto',
  'set.bank.activate': 'Aktiver konto',
  'set.bank.setAsInvoice': 'Sett som fakturakonto',
  'set.bank.accountNumber': 'Kontonummer',
  'set.bank.ledgerAccount': 'Konto i regnskap',
  'set.bank.type': 'Type',
  'set.bank.typeOperating': 'Drift',
  'set.bank.typeTax': 'Skattetrekk',
  'set.bank.typeSavings': 'Sparing',
  'set.bank.typePrivate': 'Privat',
  'set.bank.typeOther': 'Annet',
  'set.bank.openingBalance': 'Startsaldo for bankavstemming',
  'set.bank.openingBalanceDate': 'Dato for startsaldo',
  'set.bank.reconcileIn': 'Avstem i Bank',
  'set.bank.mustReconcile': 'Må avstemmes',
  'set.bank.showInPayments': 'Vis i Betalt fra/til',
  'set.bank.none': 'Ingen bankkontoer er registrert ennå.',
  'set.bank.cards': 'Kort knyttet til kontoen',
  'set.bank.cardsHelp': 'Kvitteringer viser ofte bare de fire siste sifrene. Registrer kortet, så kjenner Plumme igjen betalingen uten å vente på bankutskriften. Kontotypen avgjør om kjøpet blir bedrift eller privat utlegg.',
  'set.bank.cardsNone': 'Kontoen har ikke kort',
  'set.bank.cardsNoneHelp': 'Kryss av her, eller registrer kortene, på hver betalingskonto. Når alle kontoene er avklart, vet Plumme hvilke kort foretaket har: en kvittering betalt med et annet kort foreslås da som privat utlegg, med merknad på bilaget.',
  'set.bank.cardPromptTitle': 'Kortene avgjør bedrift eller privat',
  'set.bank.cardPromptBody': 'Plumme leser kortnummeret av kvitteringen. Vet vi hvilke kort foretaket har, avgjøres hvert kortkjøp automatisk: kjenner vi kortet, blir det bedriftskjøp — er det et annet kort, blir det privat utlegg. Disse kontoene mangler svaret:',
  'set.bank.cardPromptSkipHelp': 'Hopper du over, blir kontoen stående som uavklart, og kortkvitteringer må få betalingskilde manuelt. Du kan fylle det inn når som helst.',
  'set.bank.cardPromptFill': 'Fyll inn nå',
  'set.bank.cardPromptSkip': 'Lagre uten',
  'set.bank.accountFallback': 'Bankkonto',
  'set.bank.receiptDefault': 'Standard betalingskilde for bilag',
  'set.bank.receiptDefaultSub': 'Brukes bare når hverken kort, bankutskrift eller historikk sier hvor kjøpet ble betalt fra.',
  'set.bank.receiptDefaultLabel': 'Betalingskilde',
  'set.bank.receiptDefaultHint': 'Bilaget blir klart for bokføring, men merkes oransje med at kilden er forhåndsvalgt og ikke lest av dokumentet.',
  'set.bank.receiptDefaultNone': 'Ingen – la bilaget stå til kontroll',
  'set.bank.cardLast4': 'Siste fire sifre',
  'set.bank.cardLabel': 'Navn på kortet',
  'set.bank.cardLabelPh': 'F.eks. Visa privat',
  'set.bank.cardAdd': 'Legg til kort',
  'set.bank.cardRemove': 'Fjern kort',
  'set.bank.cardLast4Invalid': 'Skriv de fire siste sifrene på kortet.',
  'set.bank.cardDuplicate': 'Kortet er allerede registrert. To kort med samme fire sifre kan ikke skilles på en kvittering.',
  'set.access.title': 'Tilgang',
  'set.access.sub': 'Inviter regnskapsfører eller samarbeidspartner med egen innlogging. Tilgang styres med roller.',
  'set.access.activeBusiness': 'Aktivt foretak',
  'set.access.active': 'Aktiv',
  'set.access.noBusinesses': 'Ingen foretak er koblet til brukeren ennå.',
  'set.access.newBusiness': 'Nytt foretak',
  'set.access.inviteTitle': 'Inviter samarbeidspartner',
  'set.access.inviteSub': 'Inviter regnskapsfører eller andre samarbeidspartnere, og se invitasjoner som venter.',
  'set.access.noAdmin': 'Du har ikke adminrolle på valgt foretak.',
  'set.access.noAdminSub': 'Bare eier og admin kan invitere nye brukere.',
  'set.access.email': 'E-post',
  'set.access.role': 'Rolle',
  'set.role.accountant': 'Regnskapsfører',
  'set.role.admin': 'Admin',
  'set.role.viewer': 'Lesetilgang',
  'set.access.sendInvite': 'Send invitasjon',
  'set.access.invites': 'Invitasjoner',
  'set.access.invitesSub': 'Ventende invitasjoner for det aktive foretaket.',
  'set.access.accept': 'Aksepter',
  'set.access.pending': 'Venter',
  'set.access.withdraw': 'Trekk tilbake',
  'set.access.noInvites': 'Ingen ventende invitasjoner.',
  'set.access.deleteNote': 'Sletter bare valgt foretak, ikke innloggingen din eller andre foretak.',
  'set.access.deleteBusiness': 'Slett dette foretaket',
  'set.access.onlyOwnerDelete': 'Bare eier kan slette foretak.',
  'set.saveChanges': 'Lagre endringer',
  'set.title': 'Innstillinger',
  'set.subtitle': 'Foretak, brukerprofil, tilgang, regnskap, bank, investeringer og data på ett sted.',
  'set.tabsTitle': 'Innstillingsfaner',
  'set.tabsHelp': 'Hver fane er ett innstillingsområde: Foretak (firmaopplysninger), Brukerprofil (deg), Tilgang (hvem som kan gjøre hva), Preferanser (varsler og visning), Regnskap (oppsett og kontoplan), Bank, Investeringer, Data (import/eksport), Dokumenter, Integrasjoner og Abonnement.',
  'set.company': 'Foretak',
  'set.country': 'Land',
  'set.companyName': 'Foretaksnavn',
  'set.orgNumber': 'Organisasjonsnummer',
  'set.phone': 'Telefon',
  'set.address': 'Adresse',
  'set.zip': 'Postnr',
  'set.city': 'Poststed',
  'set.companyType': 'Selskapsform',
  'set.logo': 'Firmalogo',
  'set.logoAlt': 'logo',
  'set.logoHelp': 'Logo til faktura. PNG, JPG eller WebP, maks 1 MB.',
  'set.uploadLogo': 'Last opp logo',
  'set.previewInvoice': 'Forhåndsvis faktura',
  'set.deleteLogo': 'Slett logo',
  'set.inboxEmail': 'Bilagsinnboks e-post',
  'set.inboxEmailHelp': 'Videresend leverandørfakturaer og kvitteringer hit for å legge bilag direkte i innboksen.',
  'set.copyEmail': 'Kopier e-post',
  'set.generateEmail': 'Generer ny e-post',
  'set.generateEmailHelp': 'Roter bare hvis adressen er lekket eller spammet. Eksisterende integrasjoner må oppdateres.',
  'set.profile': 'Brukerprofil',
  'set.profileSub': 'Opplysninger som hører til innloggingen din.',
  'set.loggedInEmail': 'Innlogget e-post',
  'set.mobile': 'Mobilnummer',
  'set.saveProfile': 'Lagre brukerprofil',
  'set.subscription': 'Abonnement',
  'set.subscriptionSub': 'Billing styres av backend og Stripe, ikke lokal mockplan.',
  'set.openPortal': 'Åpne kundeportal',
  'set.current': 'Nåværende',

  // ------------------------------------------------- AI Radgiver (aiinsikt)
  'adv.eyebrow': 'Økonomisk rådgiver',
  'adv.beta': 'Beta',
  'adv.updating': 'Oppdaterer',
  'adv.lead': 'SuperPlumma analyserer regnskapet ditt og gir deg råd som en erfaren finanssjef — for {year}.',
  'adv.tab.overview': 'Oversikt',
  'adv.tab.liquidity': 'Likviditet & risiko',
  'adv.tab.sales': 'Salg & lønnsomhet',
  'adv.tab.costs': 'Kostnader',
  // Sales profitability uses posted invoice cost snapshots when available.
  'adv.sales.title': 'Salg og lønnsomhet',
  'adv.sales.sub': 'Bokførte salgsfakturaer for {year}',
  'adv.sales.help': 'Alle tall her er regnet ut fra bokførte salgsfakturaer i valgt år, sammenlignet med samme tall året før. Utkast, kreditnotaer og tilbud er ikke med.',
  'adv.sales.emptyTitle': 'Ingen bokførte salgsfakturaer ennå',
  'adv.sales.emptyText': 'Når du har bokført salg, regner jeg ut kundelønnsomhet, betalingstid, rabattnivå og hvilke produkter som vokser.',
  'adv.sales.periodYear': 'i {year}',
  'adv.sales.periodVsPrev': 'mot {year}',
  'adv.sales.invoiceCount': '{count} fakturaer',
  'adv.sales.customerCount': '{count} kunder',
  'adv.sales.recurringCount': '{count} med gjentakende fakturering',
  'adv.sales.days': '{days} dager',
  'adv.sales.noPayments': 'Ingen betalt ennå',
  'adv.sales.kpi.revenue': 'Omsetning',
  'adv.sales.kpi.growth': 'Omsetningsvekst',
  'adv.sales.kpi.growthHelp': 'Endring i bokført salg mot samme periode året før. Vises som «—» hvis det ikke finnes fjorårstall å sammenligne med.',
  'adv.sales.kpi.avgInvoice': 'Snitt fakturabeløp',
  'adv.sales.kpi.discount': 'Snitt rabatt',
  'adv.sales.kpi.discountHelp': 'Samlet rabatt delt på hva fakturaene ville vært verdt uten rabatt. Stiger tallet uten at volumet stiger, gir du bort margin uten å få noe igjen.',
  'adv.sales.kpi.paymentDays': 'Betalingstid',
  'adv.sales.kpi.paymentDaysHelp': 'Snitt antall dager fra fakturadato til registrert betaling. Bare betalte fakturaer teller med — ubetalte trekker ikke snittet opp.',
  'adv.sales.kpi.repeat': 'Gjenkjøpsgrad',
  'adv.sales.kpi.repeatHelp': 'Andel kunder med mer enn én faktura i året. Høy gjenkjøpsgrad gir mer forutsigbar omsetning enn like mye salg spredt på engangskunder.',
  'adv.sales.kpi.concentration': 'Kundekonsentrasjon',
  'adv.sales.kpi.concentrationHelp': 'Hvor stor andel av omsetningen som kommer fra den største kunden. Over 40 % betyr at én kunde kan velte driften alene.',
  'adv.sales.kpi.recurring': 'Gjentakende inntekt',
  'adv.sales.kpi.recurringHelp': 'Andel av omsetningen som kommer fra fakturaer med gjentakende fakturering eller abonnement.',
  'adv.sales.customers': 'Kundelønnsomhet',
  'adv.sales.customersSub': 'Omsetning, betalingstid og rabattnivå per kunde',
  'adv.sales.customersHelp': 'Kundene er sortert etter omsetning i valgt år. Trenden sammenligner med fjoråret — en ny kunde uten fjorårstall får eget merke i stedet for en pil.',
  'adv.sales.col.customer': 'Kunde',
  'adv.sales.col.revenue': 'Omsetning',
  'adv.sales.col.grossProfit': 'Bruttofortjeneste',
  'adv.sales.col.paymentSpeed': 'Betalingstid',
  'adv.sales.col.discount': 'Rabatt',
  'adv.sales.col.jobs': 'Fakturaer',
  'adv.sales.col.trend': 'Trend',
  'adv.sales.partialProfit': 'Ikke beregnet',
  'adv.sales.trendNew': 'Ny kunde i år',
  'adv.sales.showAll': 'Vis alle {count} kunder',
  'adv.sales.showFewer': 'Vis færre',
  'adv.sales.profitNote': 'Bruttofortjeneste vises når alle fakturalinjer for kunden har registrert kostpris. Eldre fakturaer og linjer uten kostpris vises som «Ikke beregnet».',
  'adv.sales.products': 'Produkter og tjenester',
  'adv.sales.productsSub': 'Omsetning per produkt, og hva som vokser eller faller',
  'adv.sales.productsHelp': 'Produktene er hentet fra fakturalinjene. Linjer uten produktnavn samles under «Uten produktnavn». Vekst og fall er målt mot samme produkt året før.',
  'adv.sales.topRevenue': 'Størst omsetning',
  'adv.sales.growing': 'Størst vekst',
  'adv.sales.falling': 'Størst fall',
  'adv.sales.noComparison': 'Ingen fjorårstall å sammenligne med',
  // Salgsdom
  'adv.sales.verdictTag': 'Salg og lønnsomhet akkurat nå',
  'adv.sales.verdict.concentration': '{name} står for {pct} % av fakturasalget på {revenue}. Det er den største risikoen i salget ditt akkurat nå — faller den kunden fra, forsvinner mesteparten av omsetningen med den.',
  'adv.sales.verdict.slowPayers': 'Salget i seg selv ser greit ut, men {count} kunde(r) betaler tregt — den tregeste bruker {days} dager. Pengene er opptjent; de står bare ute lenger enn de trenger.',
  'adv.sales.verdict.discounts': 'Du gir i snitt {pct} % rabatt, til sammen {amount} i år. Det er penger du allerede har solgt for — verdt å sjekke at rabatten faktisk henter inn volum.',
  'adv.sales.verdict.growing': 'Salget vokser {pct} % mot fjoråret, og står nå på {revenue}. Ingenting i salgstallene krever et grep akkurat nå — det viktigste er å holde det gående.',
  'adv.sales.verdict.shrinking': 'Salget er ned {pct} % mot fjoråret og står på {revenue}. Det er det tydeligste signalet i salgstallene dine nå.',
  'adv.sales.verdict.steady': 'Salget står på {revenue} fordelt på {count} fakturaer. Jeg ser ingen røde flagg i salgstallene — grepene under er muligheter, ikke problemer.',
  // Dette ville jeg gjort først
  'adv.sales.moves.title': 'Dette ville jeg gjort først',
  'adv.sales.moves.sub': 'Prioriterte grep, sortert etter effekt',
  'adv.sales.moves.help': 'Hvert grep har et tall bak seg fra dine egne fakturaer. Effekttypen sier hva slags størrelse tallet er — dager, kroner eller andel — og de skal aldri legges sammen.',
  'adv.sales.move.chaseSlowPayers.title': 'Følg opp de tregeste betalerne',
  'adv.sales.move.chaseSlowPayers.text': '{count} kunde(r) betaler tregere enn resten. {name} bruker {days} dager i snitt.',
  'adv.sales.move.chaseSlowPayers.effectLbl': 'Mulig reduksjon i kredittid',
  'adv.sales.move.chaseSlowPayers.effectNote': 'ned mot ditt eget snitt — kroneeffekten avhenger av når kunden faktisk betaler',
  'adv.sales.move.chaseSlowPayers.action': 'Se fakturalisten',
  'adv.sales.move.reviewDiscounts.title': 'Gå gjennom rabattene',
  'adv.sales.move.reviewDiscounts.text': 'Du har gitt {amount} i rabatt i år, i snitt {pct} % per faktura.',
  'adv.sales.move.reviewDiscounts.effectLbl': 'Estimert effekt',
  'adv.sales.move.reviewDiscounts.effectNote': 'ved å halvere rabattnivået',
  'adv.sales.move.reviewDiscounts.action': 'Se fakturalisten',
  'adv.sales.move.spreadCustomers.title': 'Spre kundebasen',
  'adv.sales.move.spreadCustomers.text': '{name} står for {pct} % av salget. Én kunde bør ikke bære omsetningen alene.',
  'adv.sales.move.spreadCustomers.effectLbl': 'Andel fra største kunde',
  'adv.sales.move.spreadCustomers.effectNote': 'dette er risikoen, ikke en gevinst',
  'adv.sales.move.spreadCustomers.action': 'Se kunder',
  'adv.sales.move.testPriceIncrease.title': 'Vurder en prisøkning',
  'adv.sales.move.testPriceIncrease.text': 'Test hva {pct} % høyere pris gjør med omsetningen før du bestemmer deg.',
  'adv.sales.move.testPriceIncrease.effectLbl': 'Estimert årlig effekt',
  'adv.sales.move.testPriceIncrease.effectNote': 'med dagens volum',
  'adv.sales.move.testPriceIncrease.action': 'Se produkter',
  'adv.sales.move.growRecurring.title': 'Bygg mer gjentakende salg',
  'adv.sales.move.growRecurring.text': '{pct} % av salget er gjentakende. Kommer du opp mot {target} %, blir omsetningen langt mer forutsigbar.',
  'adv.sales.move.growRecurring.effectLbl': 'Omsetning som kan bli forutsigbar',
  'adv.sales.move.growRecurring.effectNote': 'om andelen når målet',
  'adv.sales.move.growRecurring.action': 'Se abonnement',
  // Salgsscenarioer
  'adv.sales.scn.title': 'Salgsscenarioer — Hva skjer hvis …',
  'adv.sales.scn.sub': 'Effekt på omsetning, resultat og likviditet',
  'adv.sales.scn.help': 'Velg et scenario for å se før/etter på omsetning, resultat, margin og likviditet, sammen med forutsetningene jeg har lagt til grunn. Tallene er beregninger, ikke garantier.',
  'adv.sales.scn.metric': 'Nøkkeltall',
  'adv.sales.scn.base': 'Basis',
  'adv.sales.scn.after': 'Etter scenario',
  'adv.sales.scn.change': 'Endring',
  'adv.sales.scn.row.revenue': 'Omsetning',
  'adv.sales.scn.row.result': 'Resultat',
  'adv.sales.scn.row.margin': 'Resultatmargin',
  'adv.sales.scn.row.liquidity': 'Beregnet plansaldo',
  'adv.sales.scn.points': '{points} pp',
  'adv.sales.scn.assumptions': 'Forutsetninger',
  'adv.sales.scn.showAssumptions': 'Vis forutsetninger',
  'adv.sales.scn.confidence': 'Sikkerhet',
  'adv.sales.scn.risk': 'Risiko',
  'adv.sales.scn.scope': 'Omfang',
  'adv.sales.scn.q.priceUp': 'Jeg øker prisene',
  'adv.sales.scn.q.volumeDown': 'Salgsvolumet faller',
  'adv.sales.scn.q.halveDiscounts': 'Jeg fjerner halvparten av rabattene',
  'adv.sales.scn.q.loseTopCustomer': 'Jeg mister {name}',
  'adv.sales.scn.q.growRecurring': 'Gjentakende salg øker {pct} %',
  'adv.sales.scn.summary.priceUp': 'Med dagens volum gir {pct} % prisøkning rundt {delta} mer i årlig omsetning. En prisøkning gir ingen ekstra vare- eller timekostnad, så hele beløpet slår gjennom på resultatet.',
  'adv.sales.scn.summary.volumeDown': 'Et volumfall på {pct} % tar rundt {delta} ut av omsetningen. Beregningen forutsetter at kostnadene står stille, så dette er det strengeste utfallet — faller varekjøpene med volumet, blir treffet mindre.',
  'adv.sales.scn.summary.halveDiscounts': 'Du har gitt {amount} i rabatt i år, i snitt {pct} %. Halverer du nivået, henter du rundt {delta} — forutsatt at kundene blir.',
  'adv.sales.scn.summary.loseTopCustomer': 'Faller {name} fra, mister du {delta} — {pct} % av salget. Dette er tallet som gjør kundespredning verdt å ta tak i før det skjer.',
  'adv.sales.scn.summary.growRecurring': 'Øker det gjentakende salget {pct} %, gir det rundt {delta} mer i året. Gjentakende inntekt er den mest forutsigbare omsetningen du har.',
  'adv.sales.scn.assumption.priceUp': 'Volumet holder seg. Gjelder alle produkter og tjenester.',
  'adv.sales.scn.assumption.volumeDown': 'Kostnadene står stille. Plumme har ingen kostpris per produkt, så jeg kan ikke regne ut hvor mye av kostnaden som faller med volumet.',
  'adv.sales.scn.assumption.halveDiscounts': 'Kundene kjøper like mye til lavere rabatt. Beregnet av faktisk gitt rabatt i år.',
  'adv.sales.scn.assumption.loseTopCustomer': 'Ingen av omsetningen erstattes av andre kunder. Beregnet av kundens faktiske bokførte salg.',
  'adv.sales.scn.assumption.growRecurring': 'Veksten kommer i tillegg til dagens salg, ikke i stedet for.',
  'adv.sales.scn.riskText.priceUp': 'Faller volumet mer enn prisøkningen, forsvinner effekten. Følg salgsvolumet de første to månedene.',
  'adv.sales.scn.riskText.volumeDown': 'Faller volumet på de mest lønnsomme kundene først, blir treffet større enn dette.',
  'adv.sales.scn.riskText.halveDiscounts': 'Kunder som kjøper på grunn av rabatten kan falle fra. Test på noen få først.',
  'adv.sales.scn.riskText.loseTopCustomer': 'Faste kostnader forsvinner ikke med kunden, så resultatet treffes hardere enn omsetningen.',
  'adv.sales.scn.riskText.growRecurring': 'Gjentakende avtaler binder deg til pris og leveranse over tid.',
  'adv.sales.scn.scopeText.all': 'Alle produkter og tjenester',
  'adv.sales.scn.scopeText.discounted': 'Bare fakturaer med rabatt',
  'adv.sales.scn.scopeText.topCustomer': 'Bare største kunde',
  'adv.sales.scn.scopeText.recurring': 'Bare gjentakende salg',
  'adv.sales.closerTag': 'Dette ville jeg gjort',
  'adv.tab.tax': 'Skatt',
  'adv.tab.budget': 'Budsjett',
  'adv.tab.insight': 'Innsikt',
  // Budsjett mot faktisk. Bokførte tall er hittil i år, budsjettet er for hele året —
  // derfor sammenlignes det alltid mot budsjettet fram til og med inneværende måned.
  'adv.plan.title': 'Budsjett mot faktisk',
  'adv.plan.sub': '{year} — bokført hittil mot budsjettet for de første {months} månedene',
  'adv.plan.help': 'Bokførte tall er hittil i år, mens budsjettet gjelder hele året. Jeg sammenligner derfor med budsjettet fram til og med inneværende måned — ellers ville alt sett ut som det lå langt under budsjett i januar.',
  'adv.plan.tableTitle': 'Avvik per kategori',
  'adv.plan.tableSub': 'Budsjett for de første {months} månedene mot bokført',
  'adv.plan.tableHelp': 'Radene er sortert etter størrelsen på avviket. Kontoer det er bokført på uten at de er budsjettert vises også — de er ofte de mest interessante.',
  'adv.plan.col.category': 'Kategori',
  'adv.plan.col.budget': 'Budsjett hittil',
  'adv.plan.col.actual': 'Bokført',
  'adv.plan.col.variance': 'Avvik',
  'adv.plan.unbudgeted': 'Ikke budsjettert',
  'adv.plan.incomeVariance': 'Inntektsavvik',
  'adv.plan.costVariance': 'Kostnadsavvik',
  'adv.plan.abovePlan': 'over plan',
  'adv.plan.belowPlan': 'under plan',
  'adv.plan.overPlan': 'over plan',
  'adv.plan.underPlan': 'under plan',
  'adv.plan.separateNote': 'Inntekts- og kostnadsavviket vises hver for seg. Slås de sammen, kan et tap på inntekten og en innsparing på kostnaden nulle hverandre ut og se ut som at alt går etter planen.',
  'adv.plan.noteWorse': '{name} avviker {amount} i feil retning etter {months} måneder. Verdt å se på før avviket vokser resten av året.',
  'adv.plan.noteBetter': '{name} ligger {amount} bedre an enn budsjettert etter {months} måneder.',
  'adv.plan.noteUnbudgeted': 'Det er bokført {amount} på {name} uten at kontoen er budsjettert.',
  'adv.plan.editBudget': 'Endre budsjettet',
  'adv.plan.noBudgetTitle': 'Ingen budsjett for dette året',
  'adv.plan.noBudgetText': 'Uten et budsjett har jeg ingenting å måle de bokførte tallene mot. Legger du inn ett, viser jeg avvik per kategori og sier fra når noe drar fra planen.',
  'adv.plan.goToBudget': 'Lag budsjett',
  'adv.plan.notStartedTitle': 'Året har ikke begynt ennå',
  'adv.plan.notStartedText': 'Det er ingen bokførte måneder i {year} å sammenligne budsjettet mot.',
  // Mål. Brukeren eier målet; Plumme eier målingen — nåverdien hentes alltid fra bokførte tall.
  'adv.plan.goalsTitle': 'Mål',
  'adv.plan.goalsSub': 'Dine egne mål, målt mot bokførte tall',
  'adv.plan.goalsHelp': 'Målet vises fra året du oppretter det for og videre til du markerer det fullført. Et mål med passert frist blir stående til du vurderer det på nytt. Inntekt, resultat og margin måles for hvert regnskapsår, mens buffer følger saldoen.',
  'adv.plan.goalsEmptyTitle': 'Ingen mål satt ennå',
  'adv.plan.goalsEmptyText': 'Sett et mål med en frist — for eksempel en kontantbuffer eller en resultatmargin — så følger jeg med på fremdriften og sier fra hvis du sakker akterut.',
  'adv.plan.goalNew': 'Nytt mål',
  'adv.plan.goalEdit': 'Endre mål',
  'adv.plan.goalSave': 'Lagre mål',
  'adv.plan.goalSaved': 'Målet er lagret',
  'adv.plan.goalSaveFailed': 'Kunne ikke lagre målet',
  'adv.plan.goalDeleted': 'Målet er slettet',
  'adv.plan.goalTitleLabel': 'Hva er målet?',
  'adv.plan.goalTitlePh': 'F.eks. Bygg kontantbuffer før nyttår',
  'adv.plan.goalMetricLabel': 'Hva skal måles?',
  'adv.plan.goalMetricHint': 'Nåverdien hentes fra regnskapet, ikke fra noe du skriver inn.',
  'adv.plan.goalTargetAmount': 'Måltall (kr)',
  'adv.plan.goalTargetPct': 'Måltall (%)',
  'adv.plan.goalNow': 'Nå',
  'adv.plan.goalTarget': 'Mål',
  'adv.plan.goalDeadline': 'Frist',
  'adv.plan.goalDaysLeft': 'Dager igjen',
  'adv.plan.goalMeasured': 'Måles mot: {metric}', 'adv.plan.goalFromYear': 'Fra {year}',
  'adv.plan.goalReached': 'Nådd',
  'adv.plan.goalCompleted': 'Fullført', 'adv.plan.goalNeedsReview': 'Frist passert – vurder målet',
  'adv.plan.goalComplete': 'Marker mål fullført',
  'adv.plan.goalReopen': 'Gjenåpne mål',
  'adv.plan.goalOverdue': 'Fristen er passert',
  'adv.plan.goalOnTrack': 'På plan',
  'adv.plan.goalBehind': 'Bak planen',
  'adv.plan.goalTracking': 'Følger med',
  'adv.plan.metric.buffer': 'Kontantbeholdning ved årsslutt',
  'adv.plan.metric.income': 'Bokført omsetning',
  'adv.plan.metric.result': 'Bokført resultat',
  'adv.plan.metric.margin': 'Resultatmargin',
  'adv.plan.saving': 'Lagrer …',
  // Planlagte hendelser. Disse er det som gjør kontantstrømkurven til en faktisk prognose.
  'adv.plan.eventsTitle': 'Planlagte hendelser',
  'adv.plan.eventsSub': 'Kjente inn- og utbetalinger som ennå ikke er bokført',
  'adv.plan.eventsHelp': 'Hendelser vises i året datoen tilhører. De flyttes ikke automatisk til neste år; endre datoen hvis betalingen er utsatt. Bare kommende, ubokførte hendelser legges inn i kontantstrømprognosen.',
  'adv.plan.eventsEmptyTitle': 'Ingen planlagte hendelser',
  'adv.plan.eventsEmptyText': 'Uten registrerte hendelser står kontantstrømkurven flat etter inneværende måned, fordi den bare kjenner bokførte tall.',
  'adv.plan.eventsNote': 'Hendelser i tidligere måneder tas ikke med i kurven. Fjern en hendelse når betalingen er bokført, så den ikke telles to ganger.',
  'adv.plan.eventNew': 'Ny hendelse',
  'adv.plan.eventEdit': 'Endre hendelse',
  'adv.plan.eventSave': 'Lagre hendelse',
  'adv.plan.eventSaved': 'Hendelsen er lagret',
  'adv.plan.eventSaveFailed': 'Kunne ikke lagre hendelsen',
  'adv.plan.eventDeleted': 'Hendelsen er slettet',
  'adv.plan.eventLabel': 'Hva gjelder det?',
  'adv.plan.eventLabelPh': 'F.eks. Feriepenger til ansatte',
  'adv.plan.eventKind': 'Type',
  'adv.plan.eventDate': 'Dato',
  'adv.plan.eventDirection': 'Retning',
  'adv.plan.eventDirectionHint': 'Ut senker kontantbeholdningen, inn øker den.',
  'adv.plan.directionOut': 'Ut av kontoen',
  'adv.plan.directionIn': 'Inn på kontoen',
  'adv.plan.eventAmount': 'Beløp',
  'adv.plan.kind.salary': 'Lønn og bonus',
  'adv.plan.kind.tax': 'Skatt og avgift',
  'adv.plan.kind.supplier': 'Leverandørbetaling',
  'adv.plan.kind.investment': 'Investering',
  'adv.plan.kind.loan': 'Lån og avdrag',
  'adv.plan.kind.other': 'Annet',
  'adv.tab.reports': 'Rapporter',
  'adv.tab.benchmark': 'Sammenligning',
  // Sammenligningsgrunnlag. Plumme har ingen bransjedata: to av linjene måles mot
  // fjorårets egne tall, to mot en fast terskel. Kortet sier det rett ut, så «0 %»
  // ikke leses som et bransjesnitt.
  'adv.basisCmp.title': 'Sammenligningsgrunnlag',
  'adv.basisCmp.sub': 'Hva tallene faktisk måles mot',
  'adv.basisCmp.help': 'Nøkkeltallene under sammenlignes ikke med andre selskaper. To av dem måles mot bedriftens egne tall fra året før, og to mot en fast terskel. Hver linje er merket med hvilken av delene det er.',
  'adv.basisCmp.year': 'Regnskapsår',
  'adv.basisCmp.against': 'Sammenlignet med',
  'adv.basisCmp.againstValue': 'Egne tall fra {year}',
  'adv.basisCmp.source': 'Datakilde',
  'adv.basisCmp.sourceValue': 'Bokførte tall i Plumme',
  'adv.basisCmp.industry': 'Bransjedata',
  'adv.basisCmp.industryValue': 'Ikke tilgjengelig',
  'adv.basisCmp.row.previousYear': 'mot {year}',
  'adv.basisCmp.row.threshold': 'mot fast terskel',

  'adv.hero.tag': 'SuperPlummas innsikt denne måneden',
  'adv.hero.empty': 'AI Rådgiver trenger bokførte inntekter, kostnader og åpne poster før den kan gi konkrete råd.',
  'adv.hero.freeCapital': 'Ledig kapital',
  'adv.hero.notCalculated': 'ikke beregnet',
  'adv.hero.healthScore': 'Helsescore',
  'adv.hero.waiting': 'venter',
  'adv.hero.ask': 'Spør SuperPlumma',
  'adv.hero.chatTitle': 'Chat med SuperPlumma',
  'adv.hero.chatHint': 'Chat med meg',
  // Morgenbrief-hero
  'adv.hero.briefTag': 'Månedsinnsikt fra SuperPlumma · {year}',
  'adv.hero.healthLead': 'Økonomisk helse:',
  'adv.hero.greeting.morning': 'God morgen.',
  'adv.hero.greeting.day': 'Hei.',
  'adv.hero.greeting.evening': 'God kveld.',
  'adv.hero.greetingNamed.morning': 'God morgen, {name}.',
  'adv.hero.greetingNamed.day': 'Hei, {name}.',
  'adv.hero.greetingNamed.evening': 'God kveld, {name}.',
  'adv.hero.tasksToday': '{count} ting å gjøre i dag',
  'adv.hero.seeAnalysis': 'Se analyse',
  'adv.hero.effectNote.earlierIn': 'tidligere inn',
  'adv.hero.effectNote.overduePayables': 'forfalt til leverandør',
  'adv.hero.effectNote.vatToCover': 'må dekkes',
  'adv.hero.effectNote.vouchersAtRisk': 'kjøp uten bilag',
  'adv.overnight.title': 'SuperPlumma har gått gjennom',
  'adv.overnight.transactions': '{count} transaksjoner analysert',
  'adv.overnight.vouchers': '{count} bilag kontrollert',
  'adv.overnight.risks': '{count} risikoer vurdert',
  'adv.overnight.recommendations': '{count} anbefalinger funnet',
  'adv.overnight.updated': 'Sist oppdatert {time}',
  'adv.analysis.title': 'Åpen AI-analyse av regnskapet',
  'adv.analysis.empty': 'Analysen er ikke tilgjengelig akkurat nå.',
  // Hendelsesstrøm — «SuperPlumma fulgte med»
  'adv.feed.title': 'SuperPlumma fulgte med',
  'adv.feed.sub': 'Det jeg har lagt merke til i det siste',
  'adv.feed.help': 'Endringer jeg har oppdaget i regnskapet — ikke anbefalinger. Rødt haster, gult bør følges opp, grønt er bare til info.',
  'adv.feed.seeDetails': 'Se detaljer',
  'adv.feed.marginDown.title': 'Resultatmarginen har falt {points} prosentpoeng',
  'adv.feed.marginDown.body': 'Målt mot fjoråret. Verdt å se nærmere på før det blir en trend.',
  'adv.feed.marginUp.title': 'Resultatmarginen har steget {points} prosentpoeng',
  'adv.feed.marginUp.body': 'Målt mot fjoråret. Ingen tiltak nødvendig — bare hyggelig å vite.',
  'adv.feed.costLineJump.title': '{name} har økt {pct} %',
  'adv.feed.costLineJump.body': 'Kostnadsposten vokser raskere enn resten mot fjoråret.',
  'adv.feed.overdueSales.title': '{amount} i kundefordringer er forfalt',
  'adv.feed.overdueSales.body': 'Pengene er allerede opptjent — de mangler bare å komme inn.',
  'adv.feed.overduePurchases.title': '{amount} i leverandørkrav er forfalt',
  'adv.feed.overduePurchases.body': 'Forfalte leverandørkrav kan gi forsinkelsesrente og purregebyr.',
  'adv.feed.concentration.title': 'Én kunde står for {pct} % av salget',
  'adv.feed.concentration.body': 'Høy kundeavhengighet gjør omsetningen sårbar hvis kunden faller fra.',
  'adv.feed.costsDown.title': 'Kostnadene er ned {pct} % mot fjoråret',
  'adv.feed.costsDown.body': 'Ingen tiltak nødvendig — bare hyggelig å vite.',
  'adv.feed.incomeUp.title': 'Omsetningen er opp {pct} % mot fjoråret',
  'adv.feed.incomeUp.body': 'Veksten er beregnet av bokførte inntekter i samme periode.',
  'adv.feed.vouchersComplete.title': 'Alle kjøp har bilag',
  'adv.feed.vouchersComplete.body': 'Ingenting her krever din oppmerksomhet akkurat nå.',
  // Betinget modul: Ansatte & lønn
  'adv.employees.title': 'Ansatte & lønn',
  'adv.employees.help': 'Modulen vises bare fordi bedriften har ansatte eller lønnskjøringer. Tallene er hentet fra bokførte lønnskostnader og lønnskjøringene dine.',
  'adv.employees.count': 'Ansatte',
  'adv.employees.share': 'Lønnskostnad / omsetning',
  'adv.employees.cost': 'Bokført lønnskostnad',
  'adv.employees.runs': 'Lønnskjøringer i år',
  'adv.employees.note': 'Lønnsandelen er beregnet av bokførte kontoer i 5000-serien mot årets omsetning.',
  'adv.employees.go': 'Se lønn',
  // Oppgavesenter
  'adv.taskcenter.title': 'Mine oppgaver fra SuperPlumma',
  'adv.taskcenter.all': 'Alle',
  'adv.taskcenter.empty': 'Ingen oppgaver i denne kategorien.',
  'adv.status.bucket.now': 'Trenger handling nå',
  // Rådgiverprofil
  'adv.profile.title': 'Rådgiverprofil',
  'adv.profile.help': 'Alt SuperPlumma vet om hvordan du vil ha råd — buffer, mål, risikonivå og frekvens — samlet ett sted. Du kan endre alt her.',
  'adv.profile.intro': 'Dette bruker jeg for å gjøre rådene mer treffsikre. Endrer du noe her, endrer det hvordan jeg prioriterer — ikke hvordan regnskapet føres.',
  'adv.profile.buffer': 'Ønsket buffer',
  'adv.profile.mainGoal': 'Viktigste mål',
  'adv.profile.mainGoal.revenue': 'Øke omsetningen',
  'adv.profile.mainGoal.profitability': 'Øke lønnsomheten',
  'adv.profile.mainGoal.buffer': 'Bygge kontantbuffer',
  'adv.profile.mainGoal.hiring': 'Ansette',
  'adv.profile.mainGoal.investment': 'Investere',
  'adv.profile.mainGoal.workload': 'Redusere arbeidspress',
  'adv.profile.mainGoal.dividend': 'Gjøre bedriften klar for utbytte',
  'adv.profile.risk': 'Foretrukket risikonivå',
  'adv.profile.risk.cautious': 'Trygg og forsiktig',
  'adv.profile.risk.balanced': 'Balansert',
  'adv.profile.risk.offensive': 'Åpen for risiko',
  'adv.profile.cadence': 'Hvor ofte du ønsker råd',
  'adv.profile.cadence.daily': 'Daglig',
  'adv.profile.cadence.weekly': 'Ukentlig',
  'adv.profile.cadence.monthly': 'Månedlig',
  'adv.profile.accountantInvolved': 'Regnskapsfører skal involveres i forslag som krever vurdering',
  'adv.profile.investments': 'Planlagte hendelser',
  'adv.profile.noInvestments': 'Ingen registrert',
  'adv.profile.season': 'Sesongmønster',
  'adv.profile.seasonText': 'Sterke måneder: {strong}. Svake måneder: {weak}.',
  'adv.profile.noSeason': 'For lite bokført til å se et mønster ennå.',
  'adv.profile.learned': 'Hva jeg har lært av dine valg',
  'adv.profile.nothingLearned': 'Ingenting lært ennå.',
  'adv.profile.saveFailed': 'Kunne ikke lagre rådgiverprofilen',
  'adv.buffer.recommended': 'Anbefalt buffer',
  'adv.buffer.chosen': 'Valgt buffer',
  'adv.buffer.edit': 'Juster likviditetsbuffer',
  'adv.buffer.editAria': 'Juster likviditetsbuffer på {amount}',
  'adv.buffer.title': 'Likviditetsbuffer',
  'adv.buffer.auto': 'Automatisk anbefaling',
  'adv.buffer.autoHelp': 'SuperPlumma bruker det høyeste beregnede behovet. Akkurat nå er anbefalingen {amount}.',
  'adv.buffer.custom': 'Egendefinert beløp',
  'adv.buffer.customHelp': 'Bruk dette beløpet som fast grense i råd, risiko og kontantstrøm.',
  'adv.buffer.amount': 'Ønsket buffer i kroner',
  'adv.buffer.basisTitle': 'Grunnlag for automatisk anbefaling',
  'adv.buffer.basisMinimum': 'Minstenivå',
  'adv.buffer.basisMonthlyCosts': 'Én måneds kostnader',
  'adv.buffer.basisTax': 'Beregnet skattereserve',
  'adv.buffer.basisVat': 'Kommende MVA',
  'adv.buffer.basisHelp': 'Automatisk buffer bruker det høyeste av disse beløpene. Dette er en styringsgrense, ikke penger som står på en egen konto.',
  'adv.buffer.saving': 'Lagrer …',
  'adv.buffer.saved': 'Likviditetsbuffer lagret',
  'adv.buffer.invalid': 'Skriv inn et beløp større enn 0 kr.',
  'adv.buffer.unavailable': 'Bufferinnstillingen er ikke tilgjengelig akkurat nå.',
  'adv.buffer.saveFailed': 'Kunne ikke lagre likviditetsbufferen.',
  'adv.generated.kicker': 'Åpen AI-analyse av regnskapet',
  'adv.generated.daily': 'Dagsråd',
  'adv.generated.monthly': 'Denne måneden',
  'adv.generated.previousMonthly': 'Forrige måned',
  'adv.generated.loading': 'SuperPlumma leser det oppdaterte rådgivergrunnlaget …',
  'adv.generated.updated': 'Oppdatert {date}',
  'adv.generated.topOpportunity': 'Din største oppside',
  'adv.generated.changes': 'Hva skjer akkurat nå?',
  'adv.generated.actions': 'Dette ville jeg gjort nå',
  'adv.generated.opportunities': 'Muligheter',
  'adv.generated.taxChecks': 'Skatt og MVA – kontrollpunkter',
  'adv.generated.more': 'Se flere muligheter og kontrollpunkter',
  'adv.generated.nextStep': 'Neste steg',
  'adv.generated.readOnly': 'Analysen er kun rådgivende og utfører ingen handlinger.',
  'adv.generated.importCoverage': 'Basert på importerte summer og reskontro. Kontroll av enkeltføringer og bilagsfullstendighet er begrenset.',
  'adv.generated.refresh': 'Oppdater råd',
  'adv.generated.failed': 'Kunne ikke oppdatere AI-rådet nå.',
  'adv.generated.unavailable': 'Ingen AI-råd er klare ennå',
  'adv.generated.empty': 'Det finnes ingen ferdige råd å vise ennå. Prøv å oppdatere rådene.',
  'adv.generated.limitReached': 'Månedsgrensen for nye AI-råd er nådd. Eksisterende råd er fortsatt tilgjengelige, og grensen nullstilles neste måned.',
  'adv.generated.todayCurrent': 'Dagens råd er klart',
  'adv.generated.monthCurrent': 'Månedsrådet er oppdatert i dag',
  'adv.generated.previousMonthCurrent': 'Tilbakeblikket er oppdatert i dag',
  'adv.generated.noDataChanges': 'Ingen nye data',
  'adv.generated.monthCooldown': 'Oppdateres ukentlig',
  'adv.generated.todayAlreadyCurrent': 'Dagens råd er allerede tilgjengelig. Du får et nytt dagsråd tidligst neste dag.',
  'adv.generated.monthAlreadyCurrent': 'Månedsrådet er oppdatert i dag. Det kan oppdateres igjen i morgen hvis regnskapsgrunnlaget endrer seg.',
  'adv.generated.previousMonthAlreadyCurrent': 'Tilbakeblikket er oppdatert i dag. Det kan oppdateres igjen i morgen hvis det bokføres nye data i perioden.',
  'adv.generated.noDataChangesInfo': 'Ingen nye regnskapsdata siden forrige råd. Ingen AI-kall ble brukt.',
  'adv.generated.monthCooldownInfo': 'Månedsrådet kan oppdateres én gang per uke når regnskapsgrunnlaget har endret seg.',
  'adv.generated.previousKept': 'Det forrige rådet blir stående.',
  'adv.generated.type.booked': 'Bokført faktum',
  'adv.generated.type.calculated': 'Beregnet',
  'adv.generated.type.scenario': 'Scenario',
  'adv.generated.type.opportunity': 'Mulighet',
  'adv.generated.type.control': 'Kontrollpunkt',
  'adv.generated.confidence.high': 'Godt grunnlag',
  'adv.generated.confidence.medium': 'Middels grunnlag',
  'adv.generated.confidence.low': 'Tynt grunnlag',

  'adv.health.title': 'Økonomisk helsescore',
  'adv.health.sub': 'Samlet vurdering av bedriftens finansielle tilstand',
  'adv.health.help': 'Samlet score vises bare når alle fire nøkkeltall kan beregnes. Ukjente verdier gir ingen poeng. Se datagrunnlaget for hva som mangler.',
  'adv.health.badge.good': 'Frisk',
  'adv.health.badge.stable': 'Stabil',
  'adv.health.badge.weak': 'Svak',
  'adv.health.badge.none': 'Ikke nok data',
  'adv.health.word.good': 'God økonomisk helse',
  'adv.health.word.stable': 'Stabil økonomi',
  'adv.health.word.weak': 'Trenger oppfølging',
  'adv.health.word.none': 'Foreløpig vurdering',
  'adv.health.emptyTitle': 'Ikke nok data til helsescore',
  'adv.health.emptyText': 'Bokfør salg, kjøp og åpne poster for å aktivere analysen.',
  'adv.health.summaryFallback': 'SuperPlumma vurderer likviditet, vekst, lønnsomhet og stabilitet ut fra regnskapet ditt.',
  'vat.wordMva': 'MVA', 'vat.wordMoms': 'moms', 'vat.exemptMva': 'Utenfor MVA-loven', 'vat.exemptMoms': 'Utenfor moms', 'vat.rateLabel': '{{rate}} % {{word}}', 'vat.zeroRated': '0 % {{suffix}}', 'vat.zeroRatedSuffixMva': 'fritatt', 'vat.zeroRatedSuffixMoms': 'momsfritt', 'vat.salesReverseCharge51': '51 - Omvendt avgiftsplikt på salg', 'vat.export52': '52 - Eksport/utførsel',
  'adv.health.category.likviditet': 'Likviditet',
  'adv.health.category.vekst': 'Vekst',
  'adv.health.category.lonnsomhet': 'Lønnsomhet',
  'adv.health.category.stabilitet': 'Stabilitet',
  'adv.health.note.noOpenPayables': 'Ingen åpne leverandørkrav registrert',
  'adv.health.note.noDebt': 'Ingen gjeld',
  'adv.health.note.unknown': 'Ukjent',
  'adv.health.note.receivablesVsPayables': 'Kundefordringer målt mot åpne leverandørkrav',
  'adv.health.note.zeroPrevYearRevenue': 'Fjorårets omsetning er 0; prosentvis vekst kan ikke beregnes',
  'adv.health.note.needsPrevYear': 'Trenger fjorårstall for sammenligning',
  'adv.health.note.revenueChangeVsPrevYear': 'Omsetningsendring mot samme år i fjor',
  'adv.health.note.marginFromReport': 'Resultatmargin fra resultatrapporten',
  'adv.health.note.noBookedRevenue': 'Ingen bokført omsetning i valgt år',
  'adv.health.note.largestCustomerShare': 'Andel av salg fra største kunde',
  'adv.health.note.needsInvoicesPerCustomer': 'Trenger fakturasalg per kunde',
  'adv.help.healthCard': 'Helsescore er en enkel totalsum fra 0 til 100. Den ser på flere ting samtidig, som penger på konto, inntekter, kostnader og risiko. Det er en pekepinn, ikke en dom.',
  'adv.help.liquidity': 'Dette beløpet er åpne kundefordringer minus åpne leverandørkrav. Det viser ikke hvor mye penger som står på bankkontoen.',
  'adv.help.expectedBalance': 'Beregnet plansaldo ved slutten av perioden. Tallene bygger ikke på avstemt banksaldo eller sikre betalingsdatoer.',
  'adv.help.expectedIn': 'Bokførte inntekter i det viste vinduet, ikke bekreftede innbetalinger.',
  'adv.help.expectedOut': 'Bokførte kostnader i det viste vinduet, ikke bekreftede utbetalinger.',
  'adv.help.cashBalance': 'Saldo er pengene som står tilgjengelig akkurat nå i beregningen.',
  'adv.help.bookedIn': 'Bokført inn er inntekter eller innbetalinger som allerede ligger i regnskapet for perioden.',
  'adv.help.bookedOut': 'Bokført ut er kostnader eller utbetalinger som allerede ligger i regnskapet for perioden.',
  'adv.help.endBalance': 'Sluttsaldo er saldo i dag pluss penger inn, minus penger ut. Den viser hvor kontantbeholdningen ender i denne beregningen.',
  'adv.help.buffer': 'Likviditetsbuffer er en ønsket sikkerhetsgrense. Det er ikke en egen konto, men et beløp Plumme bruker for å varsle når kontantbeholdningen blir for lav.',
  'adv.help.bufferMinimum': 'Minstenivå er Plummes laveste anbefalte buffer. Den hindrer at anbefalingen blir altfor lav når bedriften har lite historikk.',
  'adv.help.monthlyCosts': 'Én måneds kostnader betyr omtrent hva bedriften vanligvis bruker på en måned. Det hjelper deg å tåle en treg måned.',
  'adv.help.taxReserve': 'Skattereserve er penger du bør holde av til skatt, slik at skatteregningen ikke kommer som en overraskelse.',
  'adv.help.vatDue': 'Kommende MVA er merverdiavgift som ser ut til å måtte betales ved neste MVA-frist.',
  'adv.help.buildsOn': 'Dette er tall Plumme faktisk har funnet i regnskapet ditt og derfor kan bruke som grunnlag for rådene.',
  'adv.help.missingData': 'Dette er opplysninger som mangler eller er tynne. Når du fyller dem inn, kan rådene bli mer presise.',
  'adv.help.dataBasis': 'Datagrunnlag sier hvor mye Plumme vet akkurat nå. Godt grunnlag gir tryggere råd enn tynt grunnlag.',
  'adv.help.riskCard': 'Risiko betyr ikke at noe er feil. Det betyr at Plumme ser et forhold du bør følge med på før det blir et problem.',
  'adv.help.statutoryDeadline': 'Lovpålagt frist betyr en dato myndighetene krever at du leverer eller betaler innen, for eksempel MVA eller skattemelding.',
  'adv.help.effect.liquidity': 'Dette handler om penger tilgjengelig på konto, ikke nødvendigvis høyere overskudd.',
  'adv.help.effect.cost': 'Dette er penger du kan spare ved å redusere eller kontrollere kostnader.',
  'adv.help.effect.tax': 'Dette handler om skatt, MVA eller fradrag. Det påvirker ofte hva du bør sette av, men er ikke bindende skatteråd.',
  'adv.help.effect.risk': 'Dette er en mulig kostnad eller et tap du kan unngå ved å følge opp tidlig.',
  'adv.help.effect.income': 'Dette er mulig økt salg eller inntekt. Det er ikke penger du allerede har fått.',
  'adv.help.effect.time': 'Dette er tid spart i arbeid eller oppfølging, ikke et regnskapsbeløp.',
  'adv.help.effect.other': 'Effekten passer ikke i én av standardgruppene, så den vises separat og summeres ikke med andre tall.',
  'adv.help.income': 'Inntekt er det bedriften har solgt for, før kostnader trekkes fra.',
  'adv.help.costs': 'Kostnader er det bedriften bruker penger på for å drive, for eksempel varer, programvare, leie eller utstyr.',
  'adv.help.result': 'Resultat er inntekter minus kostnader. Positivt resultat betyr overskudd; negativt betyr underskudd.',
  'adv.help.profitMargin': 'Resultatmargin viser hvor stor del av inntektene som blir igjen som resultat. 20 % betyr at 20 kroner står igjen for hver 100 kroner i inntekt.',
  'adv.help.movement': 'Bevegelse viser endringen fra sammenligningsperioden. Positivt og negativt må leses ut fra hva raden handler om.',
  'adv.help.revenue': 'Omsetning er salg før kostnader trekkes fra. Det sier hvor mye du selger for, ikke hvor mye du sitter igjen med.',
  'adv.help.grossProfit': 'Bruttofortjeneste er inntekt minus direkte kostnader for det du solgte. Når Plumme mangler kostpris, kan tallet ikke beregnes trygt.',
  'adv.help.paymentSpeed': 'Betalingshastighet viser hvor raskt kundene betaler fakturaene sine. Færre dager er vanligvis bedre for kontantstrømmen.',
  'adv.help.discount': 'Rabatt er prisreduksjon du har gitt kunden. Høy rabatt kan spise av fortjenesten selv om salget ser høyt ut.',
  'adv.help.avgInvoice': 'Snittfaktura er gjennomsnittlig størrelse på fakturaene dine. Den hjelper deg å se om salget består av få store eller mange små salg.',
  'adv.help.topRevenue': 'Mest omsetning viser hvilke produkter eller tjenester som har solgt for høyest beløp.',
  'adv.help.growingSales': 'Vokser betyr at salget av dette har økt sammenlignet med tidligere periode.',
  'adv.help.fallingSales': 'Faller betyr at salget av dette har gått ned sammenlignet med tidligere periode.',
  'adv.help.taxLine.tax': 'Skatt er penger bedriften eller eieren må betale av resultatet. For enkeltpersonforetak henger dette sammen med din personlige skatt.',
  'adv.help.taxLine.liquidity': 'Likviditet i skattevalget betyr hvordan valget påvirker penger tilgjengelig på konto.',
  'adv.help.taxLine.netCost': 'Netto kostnad er hva et kjøp koster etter at skattefordelen er tatt med i beregningen.',
  'adv.help.taxFig.taxBaseReduction': 'Skattegrunnlag er beløpet skatten beregnes av. Lavere skattegrunnlag kan gi lavere skatt, men bare hvis fradraget er riktig dokumentert.',
  'adv.help.taxFig.taxSaving': 'Skattebesparelse er et estimat på hvor mye lavere skatten kan bli. Det er ikke penger du får utbetalt med en gang.',
  'adv.help.taxFig.liquidityEffect': 'Likviditetseffekt viser hvordan valget påvirker penger på konto. Et kjøp kan spare skatt, men likevel svekke kontantbeholdningen.',
  'adv.help.taxFig.netCost': 'Netto kostnad etter skatteeffekt viser omtrent hva kostnaden blir når anslått skattefordel er trukket fra.',
  'adv.help.recommendWait': 'Vent betyr at Plumme ser en fordel, men at tidspunktet kan være dårlig fordi kontantbeholdningen eller risikoen er for stram.',
  'adv.help.goalNow': 'Nå er dagens målte verdi, hentet fra bokførte tall.',
  'adv.help.goalTarget': 'Mål er verdien du ønsker å komme til innen fristen.',
  'adv.help.incomeVariance': 'Inntektsavvik viser om inntektene ligger over eller under budsjettet så langt i året.',
  'adv.help.costVariance': 'Kostnadsavvik viser om kostnadene ligger over eller under budsjettet så langt i året.',
  'adv.help.budgetToDate': 'Budsjett hittil er planen for perioden som allerede har gått, ikke hele årsbudsjettet.',
  'adv.help.actual': 'Faktisk er det som er bokført i regnskapet.',
  'adv.help.variance': 'Avvik er forskjellen mellom budsjett og faktisk tall.',
  'adv.help.industry.basis.industry': 'Bransjekode forteller hvilken type virksomhet foretaket er registrert som. Den brukes for å finne riktige sammenlignbare foretak.',
  'adv.help.industry.basis.size': 'Bedriftsstørrelse grupperer foretak etter antall ansatte, slik at du ikke sammenlignes med mye større selskaper.',
  'adv.help.industry.basis.region': 'Region sier hvilket geografisk område sammenligningen gjelder.',
  'adv.help.industry.basis.year': 'Ditt regnskapsår er året nøkkeltallene fra Plumme gjelder. Bransjeåret kan være eldre.',
  'adv.help.industry.basis.source': 'Datakilde sier hvor sammenligningstallene kommer fra.',
  'adv.help.industry.basis.peers': 'Sammenlignet med viser hvilken type foretak som ligger i gruppen, for eksempel alle foretak eller bare regnskapspliktige selskaper.',
  'adv.help.industry.basis.companies': 'Foretak i hovedutvalget viser hvor mange foretak hovedkilden bygger på. Utvalget kan variere mellom nøkkeltall.',
  'adv.help.industry.metric.revenueGrowth': 'Omsetningsvekst viser hvor mye salget har økt eller falt sammenlignet med tidligere periode.',
  'adv.help.industry.metric.liquidityRatio': 'Likviditetsgrad er et mål på om kortsiktige verdier dekker kortsiktig gjeld. Høyere betyr ofte bedre betalingsevne.',
  'adv.help.industry.metric.costShare': 'Kostnadsandel viser hvor stor del av inntektene som går til kostnader. Lavere er ofte bedre, men ikke hvis nødvendige kostnader er kuttet for hardt.',
  'adv.help.industry.metric.resultMargin': 'Resultatmargin viser hvor mye av inntektene som blir igjen som resultat.',
  'adv.help.industry.metric.payrollShare': 'Lønnsandel viser bokførte kostnader på kontoer i 5000-serien som andel av driftsinntektene. Bransjetallet er et vektet snitt fra SSB.',
  'adv.help.industry.metric.operatingMargin': 'Driftsmargin viser driftsinntekter minus driftskostnader, delt på driftsinntekter. Sammenligningen bruker årsregnskap fra Regnskapsregisteret.',

  'adv.prio.title': 'Oppgaver du kan gjøre i dag',
  'adv.prio.sub': 'Konkrete oppgaver med fakturaer, bilag og bank',
  'adv.prio.help': 'Her vises oppfølging du kan utføre i Plumme. Økonomiske observasjoner, som budsjettavvik og lav buffer, vises i analysen og de andre fanene. Åpne en oppgave for veiledning og arbeidsflate.',
  'adv.prio.why': 'Hvorfor?',
  // Effekttyper: hva slags okonomisk effekt tallet pa anbefalingen er. Vises alltid
  // hver for seg, aldri summert — en likviditetseffekt er ikke det samme som en inntekt.
  'adv.effect.liquidity': 'Likviditetseffekt',
  'adv.effect.cost': 'Kostnadsbesparelse',
  'adv.effect.tax': 'Skatte-/avgiftseffekt',
  'adv.effect.risk': 'Unngått kostnad',
  'adv.effect.income': 'Økt inntekt',
  'adv.effect.time': 'Tid spart',
  // Sikkerhetsnivaa per anbefaling — erstatter en samlet prosent.
  'adv.confLevel.high': 'Høy sikkerhet',
  'adv.confLevel.medium': 'Middels sikkerhet',
  'adv.confLevel.low': 'Trenger opplysninger',
  'adv.confLevel.highHelp': 'Bygger på bokførte, bekreftede tall for perioden. Beløpet endrer seg bare hvis regnskapet endres.',
  'adv.confLevel.mediumHelp': 'Delvis avledet — for eksempel beregnet fra terminen så langt eller sammenlignet med fjoråret. Kan justere seg når mer blir bokført.',
  'adv.confLevel.lowHelp': 'Det er ikke nok bokførte tall til å tallfeste dette ennå.',
  'adv.basis.title': 'Datagrunnlag',
  'adv.basis.sub': 'Så mye vet jeg når jeg gir deg råd',
  'adv.basis.help': 'Hva analysen faktisk bygger på akkurat nå. Jeg viser ikke en sikkerhetsprosent, fordi jeg bare ser det som er bokført i Plumme — aldri hele bildet. Fyller du inn det som mangler, blir rådene mer treffsikre.',
  'adv.basis.good': 'Godt',
  'adv.basis.medium': 'Middels',
  'adv.basis.thin': 'Tynt',
  'adv.prio.emptyTitle': 'Ingen konkrete oppgaver nå',
  'adv.prio.emptyText': 'Ingen åpne oppgaver er funnet i de registrerte tallene. Se analysen og de andre fanene for økonomisk utvikling og råd.',

  'adv.cal.title': 'Din økonomiske kalender',
  'adv.cal.sub': 'Det viktigste som venter framover',
  'adv.cal.help': 'Frister for MVA, skattemelding og årsoppgjør med eksakt dato, dager igjen og beløp der det er kjent. Grønt betyr levert, gult at fristen er nær, rødt at den er passert.',
  'adv.cal.statutory': 'Lovpålagt frist',
  'adv.cal.daysLeft': '{days} dager igjen',
  'adv.cal.overdue': '{days} dager på overtid',
  'adv.cal.done': 'Levert',
  'adv.cal.open': 'Åpne',
  // Muligheter, skilt fra det som haster. Verdien er oppdaget, ikke hentet inn.
  'adv.opp.title': 'Din største oppside',
  'adv.opp.sub': 'Ikke problemer — muligheter jeg mener du bør se på',
  'adv.opp.help': 'Her ser jeg ikke etter feil, men etter muligheter. Beløpene er merket «mulig verdi»: de er oppdaget, ikke gjennomført, og skal ikke legges sammen med det du allerede har tjent.',
  'adv.opp.possible': 'Mulig verdi',
  // Status per anbefaling. Dette er brukerens egne notater — SuperPlumma utfører
  // ingenting, derfor finnes det ingen «igangsatt».
  'adv.status.new': 'Ny',
  'adv.status.snoozed': 'Utsatt',
  'adv.status.done': 'Merket gjort',
  'adv.status.dismissed': 'Ikke relevant',
  'adv.status.more': 'Flere valg',
  'adv.status.snooze7': 'Minn meg om en uke',
  'adv.status.snooze30': 'Minn meg om en måned',
  'adv.status.markDone': 'Marker som gjort',
  'adv.status.notRelevant': 'Ikke relevant',
  'adv.status.reopen': 'Ta opp igjen',
  'adv.status.whyNotRelevant': 'Hvorfor er dette ikke relevant?',
  'adv.status.reason.alreadyDone': 'Allerede gjort',
  'adv.status.reason.planChanged': 'Planen er endret',
  'adv.status.reason.wrongAmount': 'Beløpet er feil',
  'adv.status.reason.notNow': 'Ikke viktig akkurat nå',
  'adv.status.reason.notWanted': 'Jeg ønsker ikke denne typen råd',
  'adv.status.stale': 'Tallene har endret seg siden du tok stilling til dette, så jeg tar det opp igjen.',
  'adv.status.saveFailed': 'Kunne ikke lagre statusen',
  'adv.status.allHandledTitle': 'Ingenting venter på deg',
  'adv.status.allHandledText': 'Alle rådene er merket som gjort, utsatt eller ikke relevante. De ligger nedenfor hvis du vil ta dem opp igjen.',
  'adv.status.bucket.planned': 'Utsatt',
  'adv.status.bucket.closed': 'Ferdig med',
  'adv.status.handoff': 'Sendt til godkjenning',
  'adv.status.bucket.waiting': 'Venter på godkjenning',
  // Overlevering til plattform-routeren. Radgiveren utforer ingenting selv.
  'adv.handoff.start': 'Åpne',
  'adv.handoff.note': 'Sendt til SuperPlumma for godkjenning.',
  'adv.handoff.confirmLead': 'Dette utfores ikke automatisk. Trykk under for a kontrollere og fullfore.',
  'adv.handoff.noAdapter': 'Denne handlingen har ingen side a fullfore pa enna.',
  'adv.handoff.request.overdueSales': 'Lag purringer pa de forfalte kundefakturaene mine.',
  'adv.handoff.request.missingVouchers': 'Hjelp meg a rydde kjopene som mangler bilag.',
  // Utfall og læring. Måles mot bokførte tall, aldri summert på tvers av effekttyper,
  // og sier eksplisitt fra der noe ikke lar seg måle.
  'adv.outcome.title': 'Hva rådene førte til',
  'adv.outcome.sub': 'Anslag mot det som faktisk skjedde',
  'adv.outcome.help': 'Når du merker et råd som gjort, låser jeg tallet i regnskapet som skulle endre seg. Senere sammenligner jeg med hva det tallet er nå. Effektene står hver for seg — frigjort likviditet, spart kostnad og sikret fradrag er ulike størrelser og legges aldri sammen.',
  'adv.outcome.marked': 'Merket gjort',
  'adv.outcome.wentRight': 'Gikk riktig vei',
  'adv.outcome.didNot': 'Traff ikke',
  'adv.outcome.notMeasurable': 'Kan ikke måles',
  'adv.outcome.estimated': 'Anslått',
  'adv.outcome.actual': 'Faktisk',
  'adv.outcome.fromCount': 'fra {count} råd',
  'adv.outcome.otherEffect': 'Uten effekttype',
  'adv.outcome.reason.noMetric': 'Dette rådet har ingen fasit i regnskapet å måles mot.',
  'adv.outcome.reason.tooEarly': 'For tidlig å måle — regnskapet må rekke å endre seg først.',
  'adv.outcome.reason.noData': 'Mangler måletall fra tidspunktet det ble merket.',
  'adv.outcome.note': 'Et råd som ikke traff er den mest nyttige tilbakemeldingen jeg får, så det vises like tydelig som de som gikk bra. Målingen viser hva tallet i regnskapet gjorde — den beviser ikke at rådet var årsaken.',
  'adv.rec.overdueSales': 'Følg opp forfalte kundefakturaer',
  'adv.rec.vatDue': 'Sett av til MVA',
  'adv.rec.missingVouchers': 'Last opp manglende bilag',
  'adv.rec.costGrowth': 'Se på kostnadsveksten',
  'adv.rec.allClear': 'Ingen tiltak nødvendig',

  'adv.docs.default': 'Vis dokumentasjon',
  'adv.docs.hint': 'Grafer og tabeller som støtter analysen',
  'adv.docs.hide': 'Skjul',
  'adv.docs.liquidity': 'Kontantstrømprognose',
  'adv.docs.costs': 'Vis dokumentasjon — kostnader i detalj',
  'adv.docs.tax': 'Vis dokumentasjon — skattegrep og satser',
  // Bransjesammenligning
  'adv.industry.title': 'Sammenligning med lignende selskaper',
  'adv.industry.sub': 'Dine nøkkeltall mot bransjen',
  'adv.industry.help': 'Sammenligningen måler foretaket mot andre i samme bransjekode og størrelsesgruppe. Gruppene er ikke-overlappende, så hvert foretak hører til nøyaktig én.',
  'adv.industry.basisTitle': 'Sammenligningsgrunnlag',
  'adv.industry.basisSub': 'Hva tallene sammenlignes mot',
  'adv.industry.basisHelp': 'Grunnlaget vises alltid, også når selve bransjetallene mangler — da ser du hvorfor sammenligningen ikke kan gjøres, i stedet for et tomt kort.',
  'adv.industry.basis.industry': 'Bransjekode',
  'adv.industry.basis.size': 'Bedriftsstørrelse',
  'adv.industry.basis.region': 'Region',
  'adv.industry.basis.year': 'Ditt regnskapsår',
  'adv.industry.basis.source': 'Datakilde',
  'adv.industry.basis.companies': 'Foretak i hovedutvalget',
  'adv.industry.source': 'Enhetsregisteret / Regnskapsregisteret',
  'adv.industry.unknown': 'Ikke registrert',
  'adv.industry.unavailableShort': 'Ikke tilgjengelig',
  'adv.industry.wholeCountry': 'Hele landet',
  'adv.industry.size.micro': '1–4 ansatte',
  'adv.industry.size.small': '5–19 ansatte',
  'adv.industry.size.medium': '20–49 ansatte',
  'adv.industry.size.large': '50+ ansatte',
  'adv.industry.median': 'Bransjemedian',
  'adv.industry.above': 'Høyere enn bransjetallet',
  'adv.industry.below': 'Lavere enn bransjetallet',
  'adv.industry.equal': 'På nivå med bransjetallet',
  'adv.industry.empty.noCompanyData.title': 'Dine tall kan ikke sammenlignes ennå',
  'adv.industry.empty.noCompanyData.text': 'Bransjetall finnes, men regnskapet ditt mangler gyldige nøkkeltall for det valgte året. Kontroller bokføringen og prøv igjen.',
  'adv.industry.measure.median': 'Bransjemedian',
  'adv.industry.measure.weightedAverage': 'Bransjesnitt',
  'adv.industry.sourceNote': 'Tallene kommer fra to kilder. Regnskapsregisteret gir median av faktiske årsregnskap, men dekker bare foretak med regnskapsplikt. SSBs strukturstatistikk dekker alle foretak, også enkeltpersonforetak, men gir et vektet snitt for hele gruppen. Hver rad viser hvilken av dem den bygger på.',
  'adv.industry.updated': 'Bransjetallene er sist oppdatert {date}.',
  'adv.industry.periodNote': 'Bransjetallene kan gjelde et eldre regnskapsår enn ditt valgte år. Sammenligningen er veiledende, særlig før året er avsluttet.',
  'adv.industry.metric.revenueGrowth': 'Omsetningsvekst',
  'adv.industry.metric.liquidityRatio': 'Likviditetsgrad',
  'adv.industry.metric.costShare': 'Kostnadsandel',
  'adv.industry.metric.resultMargin': 'Resultatmargin',
  'adv.industry.metric.payrollShare': 'Lønnsandel',
  'adv.industry.basis.peers': 'Sammenlignet med',
  'adv.industry.peers.limitedCompanies': 'Foretak med regnskapsplikt',
  'adv.industry.peers.allEnterprises': 'Alle foretak i bransjen',
  'adv.industry.metric.operatingMargin': 'Driftsmargin',
  'adv.industry.measure.median.help': 'Median av årsregnskapene til foretak med regnskapsplikt.',
  'adv.industry.measure.weightedAverage.help': 'Vektet snitt for hele bransjegruppen, fra SSBs strukturstatistikk.',
  'adv.industry.crossFormNote': 'De fleste nøkkeltallene under måles mot alle foretak i bransjen, hentet fra SSBs strukturstatistikk. Noen få finnes bare i årsregnskapene til foretak med regnskapsplikt — i praksis aksjeselskaper. De radene er merket, fordi de ikke er direkte sammenlignbare med ditt foretak.',
  'adv.industry.skewed': 'ikke direkte sammenlignbar',
  'adv.industry.skewedHelp': 'Dette nøkkeltallet påvirkes av at du tar privat uttak i stedet for lønn.',
  'adv.industry.skewedNote': 'Du tar privat uttak i stedet for lønn, så din egen arbeidsinnsats ligger ikke i kostnadene. Et aksjeselskap fører eierlønn som kostnad. Det gjør at tallet ditt ser bedre ut enn det er reelt grunnlag for — se på retningen over tid, ikke på avstanden til medianen.',
  'adv.industry.empty.noIndex.title': 'Bransjetallene er ikke bygget ennå',
  'adv.industry.empty.noIndex.text': 'Bransjekoden din er registrert, men Plumme har ennå ingen bransjeindeks å måle deg mot. Indeksen må bygges ved å hente årsregnskap for foretak i samme bransje fra Regnskapsregisteret og regne ut median — det er ikke et oppslag som kan gjøres i det øyeblikket du åpner siden.',
  'adv.industry.empty.noIndustryCode.title': 'Vi mangler bransjekoden din',
  'adv.industry.empty.noIndustryCode.text': 'Bransjekoden hentes fra Enhetsregisteret når foretaket verifiseres med organisasjonsnummer. Uten den vet jeg ikke hvilke foretak du skal sammenlignes med.',
  'adv.industry.empty.noIndustryCode.action': 'Gå til innstillinger',
  'adv.industry.empty.countryUnsupported.title': 'Bransjetall finnes bare for Norge ennå',
  'adv.industry.empty.countryUnsupported.text': 'Bransjesammenligningen bygger på norske registre. For svenske og danske foretak er tilsvarende kilder ikke koblet på ennå.',
  'adv.report.monthly': 'Månedlig',
  'adv.report.yearly': 'Årlig',
  'adv.report.tag.mnd': 'Måneden oppsummert',
  'adv.report.tag.aar': '{year} hittil oppsummert',
  'adv.docs.reports.mnd': 'Vis dokumentasjon — månedsrapport',
  'adv.docs.reports.aar': 'Vis dokumentasjon — årsrapport',
  'adv.recap.title': 'Perioden oppsummert',
  'adv.recap.sub': 'Det viktigste fra regnskapet, uten å lese hele rapporten',
  'adv.recap.help': 'Samme observasjoner som hendelsesstrømmen på Oversikt, satt opp som en oppsummering. Grønt har gått bra, gult og rødt bør følges opp. Jeg utleder ikke nye funn her — da kunne to sider sagt ulike ting om samme regnskap.',
  'adv.recap.good': '{count} ting gikk bra',
  'adv.recap.watch': '{count} ting bør følges',
  'adv.recap.reco': 'Én anbefaling',
  'adv.recap.noGood': 'Ingenting å skryte av i tallene ennå.',
  'adv.recap.noWatch': 'Ingenting krever oppfølging akkurat nå.',
  'adv.recap.noReco': 'Ingen anbefaling venter på deg.',
  'adv.docs.reports': 'Vis dokumentasjon — måneds- og årsrapport',
  'adv.docs.benchmark': 'Vis dokumentasjon — alle nøkkeltall mot sammenligningen',


  'adv.cf.title': 'Likviditetsplan',
  'adv.cf.sub': 'Beregnet plansaldo fra åpne poster, bokførte tall og planlagte hendelser',
  'adv.cf.help': 'Plansaldoen er en beregning, ikke en banksaldo. Netto åpne poster er utgangspunktet, og bokførte inntekter og kostnader samt planlagte hendelser endrer kurven. Negative beløp viser underskudd i planen.',
  'adv.cf.months': '{count} mnd',
  'adv.cf.buffer': 'Netto åpne poster',
  'adv.cf.notCalculated': 'Ikke beregnet',
  'adv.cf.expectedBalance': 'Plansaldo (t.o.m. {month})',
  'adv.cf.expectedIn': 'Bokførte inntekter',
  'adv.cf.expectedOut': 'Bokførte kostnader',
  'adv.cf.emptyTitle': 'Ingen kontantstrømprognose ennå',
  'adv.cf.emptyText': 'Saldo-kurven krever avstemte kontant- og bankbevegelser. Åpne fakturaer er ikke kontanter.',
  'adv.cf.legendBalance': 'Beregnet plansaldo',
  'adv.cf.legendBuffer': 'Ønsket buffer',
  'adv.cf.tipBalance': 'Saldo',
  'adv.cf.tipIn': 'Inn',
  'adv.cf.tipOut': 'Ut',
  'adv.cf.tipBelowBuffer': 'Under ønsket buffer',
  // Kurven er en løpende saldo av bokførte tall, ikke en prognosemodell. Tekstene
  // under sier det rett ut, så en flat linje etter dagens måned ikke leses som en spådom.
  'adv.cf.certConfirmed': 'Bokførte måneder',
  'adv.cf.certExpected': 'Inneværende måned',
  'adv.cf.certPlanned': 'Planlagte hendelser',
  'adv.cf.certUncertain': 'Ingen bilag ennå',
  'adv.cf.certNote': 'De siste {count} månedene har ingen bokførte bilag ennå, så linjen holder seg flat der. Den viser hva saldoen blir hvis ingenting mer skjer — ikke hva jeg tror kommer til å skje.',
  'adv.cf.mathTitle': 'Slik regner jeg ut sluttsaldoen',
  'adv.cf.mathStart': 'Planens utgangspunkt',
  'adv.cf.mathIn': 'Bokførte inntekter',
  'adv.cf.mathOut': 'Bokførte kostnader',
  'adv.cf.mathAdjust': 'Avrunding og justeringer',
  'adv.cf.mathEnd': 'Beregnet plansaldo',
  'adv.cf.simBase': 'Uten tiltak',
  'adv.cf.simAfter': 'Etter tiltak',
  'adv.cf.simDiff': 'Forskjell',
  'adv.cf.simScenarios': '{count} scenarioer',
  'adv.sim.note': 'Bare grep som faktisk flytter penger inn eller ut kan simuleres. Å sette av MVA flytter penger mellom egne kontoer, og «bygg buffer» er et mål — ingen av dem endrer kontantbeholdningen.',
  'adv.scn.title': 'Hva skjer hvis …',
  'adv.scn.sub': 'Prøv anbefalte grep eller juster kostnader og inntekter. Se utslaget i prognosen under.',
  'adv.scn.help': 'Velg ett anbefalt grep eller flere scenarioer. Scenarioene kan kombineres med hverandre, mens et anbefalt grep vises alene. Tallene sammenlignes med basisprognosen, og kurven under oppdateres. Ingenting gjennomføres.',
  'adv.scn.note': 'Dette er beregninger. Valgene bokfører, sender eller lagrer ingenting.',
  'adv.scn.movesTitle': 'Anbefalte grep',
  'adv.scn.costTitle': 'Kostnader og investeringer',
  'adv.scn.revenueTitle': 'Inntekter og kunder',
  'adv.scn.noRevenueData': 'Inntektsscenarioer vises når det finnes inntektsgrunnlag.',
  'adv.scn.endBalance': 'Saldo ved periodens slutt',
  'adv.scn.lowBalance': 'Laveste saldo i perioden',
  'adv.scn.monthsBelowBuffer': 'Måneder under buffergrensen',
  'adv.scn.turnOff': 'Skru av scenarioet',
  'adv.scn.q.hire': 'Jeg ansetter',
  'adv.scn.q.invest': 'Jeg investerer i …',
  'adv.scn.q.fixedCost': 'Jeg får en ny fast kostnad',
  'adv.scn.q.reduceFixedCosts': 'Jeg senker faste kostnader',
  'adv.scn.q.priceUp': 'Jeg øker prisene',
  'adv.scn.q.revenueDown': 'Omsetningen faller',
  'adv.scn.q.loseTopCustomer': 'Jeg mister største kunde',
  'adv.scn.row.hire': 'Ansatt {n}',
  'adv.scn.row.invest': 'Investering {n}',
  'adv.scn.row.fixedCost': 'Kostnad {n}',
  'adv.scn.addRow.hire': 'Legg til en ansatt til',
  'adv.scn.addRow.invest': 'Legg til en investering til',
  'adv.scn.addRow.fixedCost': 'Legg til en kostnad til',
  'adv.scn.removeRow': 'Fjern linjen',
  'adv.scn.placeholder.costLabel': 'F.eks. varelager eller kontorleie',
  'adv.scn.slider.priceUp': 'Prisøkning',
  'adv.scn.slider.reduceFixedCosts': 'Reduksjon',
  'adv.scn.slider.revenueDown': 'Omsetningsfall',
  'adv.scn.fixedBasis': 'Valgt grunnlag: {amount} per måned fra opptil {months} kalendermåneder',
  'adv.scn.fixedBasisHelp': 'Kontoene er hentet fra resultatrapporten. Fjern kontoer som ikke er faste for din bedrift. Månedssnittet er et anslag; betalingstidspunkt og MVA kan avvike.',
  'adv.scn.noFixedBasis': 'Ingen bokførte beløp på utvalgte kontoer i perioden. Se resultatrapporten og kontooppsettet hvis du forventer faste kostnader her.',
  'adv.scn.field.startDate': 'Startdato',
  'adv.scn.field.monthlySalary': 'Månedslønn',
  'adv.scn.field.socialPct': 'Sosiale kostnader (%)',
  'adv.scn.field.extraRevenue': 'Forventet meromsetning/mnd',
  'adv.scn.field.amount': 'Beløp',
  'adv.scn.field.payDate': 'Betalingsdato',
  'adv.scn.field.financing': 'Finansieringsform',
  'adv.scn.field.equityPct': 'Egenkapitalandel (%)',
  'adv.scn.field.termMonths': 'Nedbetalingstid (måneder)',
  'adv.scn.field.interestPct': 'Rente (% per år)',
  'adv.scn.field.loanType': 'Lånetype',
  'adv.scn.field.costLabel': 'Hva gjelder det?',
  'adv.scn.field.monthlyAmount': 'Beløp per måned',
  'adv.scn.option.cash': 'Kontant',
  'adv.scn.option.loan': 'Lån',
  'adv.scn.option.annuity': 'Annuitetslån',
  'adv.scn.option.serial': 'Serielån',
  'adv.scn.loan.open': 'Lånevilkår',
  'adv.scn.loan.summary': '{rate} % · {type} · {months} mnd',
  'adv.scn.loan.title': 'Lånevilkår for investering {n}',
  'adv.scn.loan.done': 'Ferdig',
  'adv.scn.loan.monthsUnit': 'mnd',
  'adv.scn.loan.equityNow': 'Egenkapital nå',
  'adv.scn.loan.principal': 'Lånebeløp',
  'adv.scn.loan.firstPayment': 'Første termin',
  'adv.scn.loan.lastPayment': 'Siste termin',
  'adv.scn.loan.totalInterest': 'Renter totalt',
  'adv.scn.loan.totalPaid': 'Betalt totalt',
  'adv.scn.loan.showPlan': 'Se nedbetalingsplan',
  'adv.scn.loan.hidePlan': 'Skjul nedbetalingsplan',
  'adv.scn.loan.typeHelp.annuity': 'Annuitetslån har fast terminbeløp. Du betaler mest rente i starten, og belastningen er den samme hver måned.',
  'adv.scn.loan.typeHelp.serial': 'Serielån har fast avdrag. Terminbeløpet er høyest i starten og synker — tyngre nå, men lavere renter totalt.',
  'adv.scn.loan.note': 'Renten er ditt eget anslag. Nedbetalingsplanen er en beregning fra den, ikke et lånetilbud.',
  'adv.scn.plan.month': 'Termin',
  'adv.scn.plan.payment': 'Terminbeløp',
  'adv.scn.plan.interest': 'Renter',
  'adv.scn.plan.principal': 'Avdrag',
  'adv.scn.plan.remaining': 'Restgjeld',
  'adv.scn.summary.hire': 'En ny ansatt fra {date} koster rundt {cost} per måned inkludert sosiale kostnader. Med forventet meromsetning på {extra} per måned endrer kontantbeholdningen seg med {net} per måned fra startdatoen. Kurven under viser hvor bufferen havner.',
  'adv.scn.summary.hireMany': '{count} nye ansatte koster til sammen rundt {cost} per måned inkludert sosiale kostnader, med første start {date}. Med forventet meromsetning på {extra} per måned endrer kontantbeholdningen seg med {net} per måned når alle er på plass. Kurven under viser hvor bufferen havner.',
  'adv.scn.summary.investCash': 'Betaler du {amount} kontant, faller kontantbeholdningen med hele beløpet i den måneden. Kurven under viser om bufferen tåler det.',
  'adv.scn.summary.investLoan': 'Av totalt {amount} betaler du {equity} med egne midler og låner resten over inntil {termMonths} måneder. Første termin blir rundt {monthly}, og rentene utgjør {interest} over hele nedbetalingen. Beløpene følger renten du har satt selv — de er ikke et lånetilbud.',
  'adv.scn.summary.fixedCost': 'En ny fast kostnad på {cost} per måned fra {date} tar {yearly} i året. Kurven under viser om bufferen tåler den.',
  'adv.scn.summary.fixedCostMany': '{count} nye faste kostnader utgjør {cost} per måned fra {date}, altså {yearly} i året. Kurven under viser om bufferen tåler dem.',
  'adv.scn.summary.reduceFixedCosts': '{pct} % av {base} på de valgte kostnadskontoene gir anslagsvis {delta} mindre ut per måned fra nå. Prognosen viser virkningen hvis reduksjonen varer.',
  'adv.scn.summary.priceUp': 'En prisøkning på {pct} % gir rundt {delta} mer inn per måned, målt mot snittet av månedene som faktisk har bokført inntekt.',
  'adv.scn.summary.revenueDown': 'Et omsetningsfall på {pct} % gir rundt {delta} mindre inn per måned, målt mot snittet av månedene som faktisk har bokført inntekt.',
  'adv.scn.summary.loseTopCustomer': 'Største kunde står for {pct} % av salget. Faller den bort, mister du rundt {delta} per måned. Kurven under viser hvor lavt bufferen går.',
  'adv.cf.commentaryFallback': 'Kontantstrømmen bygger på avstemte kontant- og bankbevegelser.',

  'adv.cost.title': 'Kostnadsanalyse',
  'adv.cost.changeUp': 'opp {pct} %',
  'adv.cost.changeDown': 'ned {pct} %',
  'adv.cost.changeFlat': 'uendret',
  'adv.cost.flagged': ' SuperPlumma har markert denne fordi økningen er uvanlig stor og bør sjekkes.',
  'adv.cost.emptyTitle': 'Ingen kostnader å analysere',
  'adv.cost.flagTitle': 'SuperPlummas kostnadsvarsel',
  'adv.cost.flagHelp': 'Når en kostnad skiller seg tydelig ut — for eksempel ved å øke mye raskere enn de andre — løfter SuperPlumma den fram her med en konkret anbefaling, slik at du kan reagere før den vokser seg stor.',
  'adv.cost.flagFallback': 'De største kostnadene',

  'adv.tax.title': 'Skatt og MVA',
  'adv.tax.sub': 'Konservative kontrollpunkter for inntektsåret',
  'adv.tax.help': 'Kontrollpunkter basert på bokførte tall. Dette er ikke bindende skatteråd, men hjelper deg å se hva som bør avsettes, kontrolleres eller diskuteres med rådgiver.',
  'adv.tax.rowHelp': '{desc} Effekt: {effect}. Status: {saving}.',
  'adv.tax.effect': 'Skatteeffekt',
  'adv.tax.saving': 'Forventet besparelse',
  'adv.tax.emptyTitle': 'Ingen skattepunkter beregnet',
  'adv.tax.emptyText': 'Skatt og MVA vises når regnskapet har resultat, MVA eller offentlige krav å følge opp.',
  'adv.tax.disclaimerTitle': 'Hvem har ansvaret?',
  'adv.tax.disclaimerHelp': 'Forslagene er automatisk genererte estimater og ikke bindende skatteråd. Det endelige ansvaret for hva som føres og sendes inn ligger alltid hos bedriften og regnskapsføreren. Bruk forslagene som utgangspunkt for en samtale med rådgiveren din.',
  'adv.tax.disclaimer': 'Forslagene er automatisk genererte estimater basert på regnskapsdataene dine og gjeldende satser. SuperPlumma anbefaler aldri et kjøp bare for å spare skatt — likviditet og faktisk behov veies alltid inn først. Endelig ansvar for vurdering og innsending ligger hos bedriften og regnskapsføreren.',
  'adv.tax.checklist.button': 'Huskeliste',
  'adv.tax.checklist.title': 'Huskeliste for fradrag',
  'adv.tax.checklist.note': 'Dette er en praktisk kontrolliste for vanlige fradrag små selskaper ofte overser. Fradrag krever alltid dokumentasjon, riktig formål og vurdering mot gjeldende regler.',
  'adv.tax.checklist.footer': 'Tips: Bruk listen sammen med bilagene dine før MVA, skattemelding og årsavslutning. Usikre poster bør avklares med regnskapsfører eller Skatteetatens veiledning.',
  'adv.tax.checklist.operations': 'Drift og administrasjon',
  'adv.tax.checklist.operations.1': 'Kontorrekvisita, programvare, abonnementer og fagsystemer som brukes i virksomheten.',
  'adv.tax.checklist.operations.2': 'Regnskap, juridisk bistand, bankgebyrer, betalingsløsninger og andre profesjonelle tjenester.',
  'adv.tax.checklist.operations.3': 'Telefon, internett og hjemmekontorandel når kostnaden kan dokumenteres og fordeles saklig.',
  'adv.tax.checklist.sales': 'Salg, marked og kunder',
  'adv.tax.checklist.sales.1': 'Annonser, nettside, foto, grafisk arbeid, domene, trykksaker og annet salgsarbeid.',
  'adv.tax.checklist.sales.2': 'Kurs, konferanser, medlemskap og faglig oppdatering som har tydelig sammenheng med inntekten.',
  'adv.tax.checklist.sales.3': 'Representasjon innenfor fradragsreglene, med deltaker, formål og bilag på plass.',
  'adv.tax.checklist.travel': 'Reise og bil',
  'adv.tax.checklist.travel.1': 'Yrkesreise, parkering, bom, kollektiv, fly, hotell og diett etter gjeldende satser.',
  'adv.tax.checklist.travel.2': 'Kjørebok for næringskjøring med dato, formål, fra/til og kilometer.',
  'adv.tax.checklist.travel.3': 'Varebil, leasing, forsikring, drivstoff og vedlikehold der bilen faktisk brukes i virksomheten.',
  'adv.tax.checklist.assets': 'Utstyr og lokaler',
  'adv.tax.checklist.assets.1': 'PC, mobil, verktøy, inventar og andre driftsmidler. Store kjøp kan måtte aktiveres og avskrives.',
  'adv.tax.checklist.assets.2': 'Leie av lokale, verksted, lager, coworking eller andel av lokaler brukt i virksomheten.',
  'adv.tax.checklist.assets.3': 'Reparasjon, vedlikehold, renhold, strøm og andre lokalkostnader som hører til driften.',
  'adv.tax.checklist.finance': 'Finans og tap',
  'adv.tax.checklist.finance.1': 'Renter, purregebyrer og finansieringskostnader knyttet til virksomheten.',
  'adv.tax.checklist.finance.2': 'Tap på kundefordringer når kravet er reelt forsøkt inndrevet og tapet er dokumentert.',
  'adv.tax.checklist.finance.3': 'Valutatap, kortgebyrer og provisjoner som gjelder salg eller kjøp i virksomheten.',
  'adv.tax.checklist.people': 'Ansatte og hjelpere',
  'adv.tax.checklist.people.1': 'Lønn, arbeidsgiveravgift, OTP, forsikringer og personaltiltak innenfor reglene.',
  'adv.tax.checklist.people.2': 'Honorar til frilansere, underleverandører og innleid hjelp med riktig dokumentasjon.',
  'adv.tax.checklist.people.3': 'Arbeidsklær og verneutstyr når det er yrkesmessig behov, ikke vanlig privat bekledning.',
  // Skatt — valgkort og forslag
  'adv.tax.insights.backToAdvisor': 'Tilbake til AI Rådgiver',
  'buy.editPurchase': 'Rediger kjøp',
  'buy.editPurchaseHelp': 'Lagrer endringene i det bokførte kjøpet.',
  'adv.tax.choices.title': 'Hvis dette var mitt selskap',
  'adv.tax.myRecommendation': 'Min anbefaling:',
  'adv.tax.wait': 'Vent',
  'adv.tax.recommendWait': 'Anbefaling: vent',
  'adv.tax.showCalculation': 'Vis beregning',
  'adv.tax.line.tax': 'Skatt',
  'adv.tax.line.liquidity': 'Likviditet',
  'adv.tax.line.netCost': 'Netto kostnad',
  'adv.tax.fig.taxBaseReduction': 'Reduksjon i skattegrunnlag',
  'adv.tax.fig.taxSaving': 'Estimert skattebesparelse',
  'adv.tax.fig.liquidityEffect': 'Likviditetseffekt',
  'adv.tax.fig.netCost': 'Netto kostnad etter skatteeffekt',
  'adv.tax.rateNote.corporate': 'Skattebesparelsen er regnet med {pct} % selskapsskatt.',
  'adv.tax.rateNote.soleTrader': 'Skattebesparelsen er regnet med {pct} %, som er Plummes veiledende skattesats for enkeltpersonforetak. Faktisk marginalskatt avhenger av trinnskatt, trygdeavgift og dine personlige forhold.',
  'adv.tax.proposal.taxReserve.title': 'Sett av til skatt',
  'adv.tax.proposal.taxReserve.desc': 'Resultatet så langt tilsier at du bør reservere {amount} før privat uttak eller større kjøp. Dette senker ikke skatten — det sørger for at pengene finnes når regningen kommer.',
  'adv.tax.proposal.vatDue.title': 'MVA som må dekkes',
  'adv.tax.proposal.vatDue.desc': 'Beregnet MVA fra bokførte salg og kjøp er {amount}. Kontroller terminen før innsending.',
  'adv.tax.proposal.buyAssets.title': 'Kjøp av driftsmidler før årsslutt',
  'adv.tax.proposal.buyAssets.desc': 'Du har {count} planlagt(e) investering(er) på til sammen {amount}. Skattetallene under er en illustrasjon; type driftsmiddel, bruk og levetid må kontrolleres for hvert kjøp.',
  'adv.tax.proposal.missingVouchers.title': 'Bilag du mangler',
  'adv.tax.proposal.missingVouchers.desc': '{count} bokførte kjøp på til sammen {amount} mangler bilag. Kontroller om hvert kjøp gir fradrag eller inngående MVA.',
  'adv.tax.calc.taxReserveBase': 'Skattebufferen er {pct} % av resultatet så langt, minus innbetalt forskuddsskatt: {amount}.',
  'adv.tax.calc.vatDueBase': 'Utgående MVA minus inngående MVA i terminen: {amount}.',
  'adv.tax.calc.assetCapitalize': 'Illustrasjonen behandler {amount} som ett kvalifiserende driftsmiddel over grensen for direkte utgiftsføring ({limit}).',
  'adv.tax.calc.assetDirect': 'Illustrasjonen forutsetter at kjøpet på {amount} kvalifiserer for direkte utgiftsføring under grensen ({limit}).',
  'adv.tax.calc.assetDepreciation': 'Illustrasjon hvis driftsmidlet hører til saldogruppe d: {pct} % første år = {amount}.',
  'adv.tax.calc.assetSaving': '{reduction} lavere skattegrunnlag × {pct} % = {saving} i spart skatt.',
  'adv.tax.calc.voucherBase': '{count} bokførte kjøp uten bilag, til sammen {amount} eksklusiv MVA. Beløpet er ikke et beregnet fradrag.',
  'adv.tax.calc.voucherSaving': '{amount} i fradrag × {pct} % = {saving} i spart skatt, forutsatt at bilagene kommer på plass.',
  'adv.tax.calc.voucherVat': 'I tillegg står {vat} i inngående MVA i fare uten dokumentasjon.',
  'adv.tax.choice.buyAssets.q': 'Kjøpe driftsmidlene før nyttår?',
  'adv.tax.choice.buyAssets.reco.wait': 'Vent med kjøpet. Prognosen viser at bufferen ikke tåler uttaket på {amount} nå. Kontroller behov og skattemessig behandling per driftsmiddel før du velger tidspunkt.',
  'adv.tax.choice.buyAssets.reco.do': 'Bufferen tåler uttaket på {amount}. Gjennomfør bare hvis driftsmidlet trengs, og kontroller skattebehandlingen per kjøp. En mulig skattefordel er ikke alene grunn til å kjøpe.',
  'adv.tax.choice.buyAssets.reco.consider': 'Vurder det sammen med regnskapsfører. Jeg har ikke nok likviditetsdata til å si om bufferen tåler uttaket på {amount} i år.',
  'adv.tax.choice.taxReserve.q': 'Sette av til skatt nå?',
  'adv.tax.choice.taxReserve.reco.do': 'Gjør det. {amount} er penger du allerede skylder — de er bare ikke skilt ut ennå. Setter du dem av nå, slipper du å finne dem når fristen kommer.',
  'adv.tax.choice.taxReserve.reco.wait': 'Vent litt. Bufferen er stram akkurat nå — men {amount} må være på plass før fristen.',
  'adv.tax.choice.taxReserve.reco.consider': 'Vurder å sette av {amount} nå, så pengene finnes når fristen kommer.',
  'adv.tax.choice.missingVouchers.q': 'Rydde de manglende bilagene?',
  'adv.tax.choice.missingVouchers.reco.do': 'Gjør det før terminslutt. Finn de {count} bilagene som mangler, og kontroller hvilke kjøp som faktisk kan gi fradrag eller inngående MVA.',
  'adv.tax.choice.missingVouchers.reco.wait': 'Ta det før terminslutt. {count} bilag mangler; vurder fradragsretten for hvert kjøp.',
  'adv.tax.choice.missingVouchers.reco.consider': 'Skaff de {count} bilagene som mangler, og vurder om kjøpene er fradragsberettiget.',

  'adv.report.emptyTitle': 'Rapporter kommer her',
  'adv.report.emptyText': 'Rapportvisningen kobles på når AI-rådgiveren får backend-data.',

  'adv.bench.title': 'Sammenligning med tidligere tall',
  'adv.bench.sub': 'Dine nøkkeltall mot valgt sammenligningsgrunnlag',
  'adv.bench.help': 'Her ser du egne nøkkeltall mot fjorår eller anbefalt intern terskel. Merket til høyre forteller om utviklingen peker riktig vei for hvert tall.',
  'adv.bench.rowHelp': 'Din bedrift: {you} · sammenligning: {avg}. {verdict}{direction}',
  'adv.bench.rowBetter': 'Utviklingen er bedre på dette målet.',
  'adv.bench.rowWorse': 'Dette er et område du kan se nærmere på.',
  'adv.bench.higherBetter': ' Her er høyere bedre.',
  'adv.bench.lowerBetter': ' Her er lavere bedre.',
  'adv.bench.stronger': 'Sterkere',
  'adv.bench.weaker': 'Svakere',
  'adv.bench.you': 'Din bedrift',
  'adv.bench.comparison': 'Sammenligning',
  'adv.bench.emptyTitle': 'Ingen sammenligning ennå',
  'adv.bench.emptyText': 'Sammenligning krever nøkkeltall for valgt år og et tidligere år eller intern terskel.',
  // Narrativlaget: modellen sender { key, vars }, teksten bor her.
  'adv.verdict.tag': 'Hva skjer akkurat nå?',
  'adv.verdict.liquidityBufferBreach': 'Beregnet saldo fra bokførte tall ligger {shortfall} under bufferen på {buffer} i {month}. Sjekk kommende betalinger før du velger tiltak.',
  'adv.verdict.liquidityOverdue': 'Forfalte kundefakturaer på {amount} er ikke registrert som innbetalt. Det kan påvirke likviditeten selv om beregnet saldo er over bufferen.',
  'adv.verdict.liquidityNoForwardData': 'Denne visningen har ingen kommende måneder med beregnet saldo. Åpne poster og bufferen kan fortsatt følges opp.',
  'adv.verdict.liquidityOk': 'Beregnet saldo ligger over bufferen i månedene som vises. Åpne poster og betalinger som ikke er registrert, kan endre bildet.',
  'adv.verdict.costSpike': '{name} har økt {pct} % mot sammenligningsperioden. Det er den kostnaden jeg ville sett nærmere på først.',
  'adv.verdict.costUp': 'Kostnadene har økt {pct} % mot fjoråret. Ingen enkeltpost stikker ut, men samlet er utviklingen verdt et blikk.',
  'adv.verdict.costDown': 'Kostnadene er ned {pct} % mot fjoråret. Det er god kostnadskontroll.',
  'adv.verdict.costFlat': 'Kostnadene ligger stabilt på {amount}. Ingenting som krever handling nå.',
  'adv.verdict.costNoComparison': 'Du har bokført {amount} i kostnader. Jeg mangler fjorårstall, så jeg kan ikke si om utviklingen peker riktig vei ennå.',
  'adv.verdict.taxBoth': 'Du har {vat} i MVA og {buffer} som bør settes av til skatt. Sørg for at pengene finnes når fristene kommer.',
  'adv.verdict.taxVat': 'Du har {vat} i MVA som skal dekkes. Sett av beløpet før forfall.',
  'adv.verdict.taxBuffer': 'Resultatet tilsier at du bør sette av {buffer} til skatt før du tar ut penger privat.',
  'adv.verdict.taxNothingDue': 'Jeg finner ingen MVA eller skatteavsetning som forfaller nå. Bruk fanen som sjekkliste før levering.',
  'adv.verdict.reportProfit': 'Perioden gir et overskudd på {result} — {income} inn og {costs} ut.',
  'adv.verdict.reportLoss': 'Perioden gir et underskudd på {result} — {income} inn og {costs} ut.',
  'adv.verdict.benchAllStronger': 'Du ligger sterkere på alle {total} nøkkeltall jeg sammenligner. Det er solid.',
  'adv.verdict.benchMixed': 'Du ligger sterkere på {better} av {total} nøkkeltall. Resten er der jeg ville lett etter forbedring.',
  'adv.verdict.benchAllWeaker': 'Du ligger svakere på alle {total} nøkkeltall jeg sammenligner. Start med det som betyr mest for kontantstrømmen.',
  'adv.verdict.benchNoData': 'Jeg mangler grunnlag for å sammenligne nøkkeltallene dine ennå.',
  'adv.why.title': 'Hvorfor skjer det?',
  'adv.why.liquiditySub': 'Åpne poster og avsetninger du bør se sammen med beregnet saldo',
  'adv.liquidity.watchTitle': 'Dette følger jeg også med på',
  'adv.liquidity.watchBelowBuffer': 'Mangler til bufferen i {month}',
  'adv.liquidity.watchAboveBuffer': 'Margin over bufferen i {month}',
  'adv.liquidity.watchNoBalance': 'Ingen kommende måned med beregnet saldo',
  'adv.liquidity.watchReceivables': 'Kundefakturaer som ikke er forfalt',
  'adv.liquidity.watchPayables': 'Leverandørfakturaer som ikke er forfalt',
  'adv.liquidity.scope': 'Vurderingen bygger på bokførte inntekter og kostnader, åpne poster og buffergrensen. Planlagte betalinger som ikke er registrert i Plumme, er ikke med.',
  'adv.why.costTitle': 'Dette la jeg merke til',
  'adv.why.whyOverdueSales': 'Forfalte kundefakturaer',
  'adv.why.whyOverduePurchases': 'Forfalte leverandørfakturaer',
  'adv.why.whyPublicDues': 'MVA og skatteavsetning som forfaller',
  'adv.why.whyCostUp': '{name} — opp {pct} % mot sammenligningsperioden',
  'adv.why.whyCostLargest': '{name} — din største kostnadspost',
  'adv.moves.title': 'Hvis dette var mitt selskap',
  'adv.moves.liquiditySub': 'Forfalte poster, kommende MVA, prognosebuffer og salgsdokumenter som trenger oppfølging.',
  'adv.moves.costTitle': 'Muligheter',
  'adv.moves.costSub': 'Penger du kan hente inn eller slutte å bruke',
  'adv.moves.go': 'Åpne',
  'adv.moves.showAll': 'Se alle {count}',
  'adv.moves.count': '{count} stk.',
  'adv.moves.followup': 'Til oppfølging',
  'adv.moves.amount': 'Beløp',
  'adv.moves.moveAcceptedOffer': 'Følg opp aksepterte tilbud ({count})',
  'adv.moves.moveAcceptedOffer.note': 'Ingen tilknyttet faktura eller fakturautkast',
  'adv.moves.moveFollowUpOffer': 'Følg opp sendte tilbud ({count})',
  'adv.moves.moveFollowUpOffer.note': 'Venter på svar eller nærmer seg gyldighetsdato',
  'adv.moves.moveSendOffer': 'Send usendte tilbud ({count})',
  'adv.moves.moveSendOffer.note': 'Opprettet, men ikke sendt til kunden',
  'adv.moves.moveOfferDrafts': 'Fullfør tilbudsutkast ({count})',
  'adv.moves.moveOfferDrafts.note': 'Utkast som ikke er opprettet og sendt',
  'adv.moves.moveInvoiceDrafts': 'Gå gjennom fakturautkast ({count})',
  'adv.moves.moveInvoiceDrafts.note': 'Utkast som har ligget i minst syv dager',
  'adv.moves.moveChaseOverdue': 'Purr de forfalte kundefakturaene',
  'adv.moves.moveSetAsideVat': 'Sett av MVA før forfall',
  'adv.moves.moveBuildBuffer': 'Bygg bufferen før {month}',
  'adv.moves.movePayOverdue': 'Betal de forfalte leverandørfakturaene',
  'adv.moves.moveReviewCost': 'Gå gjennom {name}',
  'adv.moves.moveFixVouchers': 'Last opp {count} manglende bilag',
  'adv.moves.moveWatchCosts': 'Ingen kostnadsgrep nødvendig nå',
  'adv.gain.gainCashflow': 'bedre kontantstrøm',
  'adv.gain.gainAvoidInterest': 'du unngår forsinkelsesrente',
  'adv.gain.gainToBuffer': 'mangler til bufferen',
  'adv.gain.gainAvoidFees': 'du unngår gebyr og purringer',
  'adv.gain.gainCostIncrease': 'økningen mot sammenligningsperioden',
  'adv.gain.gainDeductionRisk': 'fradrag du risikerer å miste uten bilag',
  'adv.gain.gainNoActionNeeded': 'kostnadene er under kontroll',
  'adv.monitor.title': 'SuperPlumma overvåker',
  'adv.monitor.sub': 'Dette sjekker jeg hver gang tallene endrer seg',
  'adv.monitor.help': 'Kontrollene SuperPlumma kjører automatisk mot regnskapet. Grønt betyr at kontrollen er i orden nå, gult at noe bør ses på.',
  'adv.monitor.monitorLiquidity': 'Likviditetsbuffer',
  'adv.monitor.monitorOverdueSales': 'Forfalte kundefakturaer',
  'adv.monitor.monitorOverduePurchases': 'Forfalte leverandørfakturaer',
  'adv.monitor.monitorVat': 'MVA som forfaller',
  'adv.monitor.monitorVouchers': 'Bilag på kjøp',
  'adv.monitor.monitorConcentration': 'Kundeavhengighet',
  'adv.monitor.group.liquidity': 'Likviditet',
  'adv.monitor.group.receivables': 'Innbetalinger',
  'adv.monitor.group.costs': 'Kostnader og leverandører',
  'adv.monitor.group.tax': 'Skatt og frister',
  'adv.monitor.group.quality': 'Bokføringskvalitet',
  'adv.monitor.group.sales': 'Salg og lønnsomhet',
  'adv.monitor.detail.liquidityBelow': 'Beregnet saldo fra bokførte tall ligger under buffer på {amount} i måned {month}.',
  'adv.monitor.detail.liquidityOk': 'Beregnet saldo fra bokførte tall holder seg over valgt buffer i kommende måneder.',
  'adv.monitor.detail.liquidityNoData': 'Ingen kommende måneder med beregnet saldo i valgt periode.',
  'adv.monitor.detail.receivablesOld': '{amount} er forfalt; eldste krav er {days} dager.',
  'adv.monitor.detail.receivablesOverdue': '{amount} i kundefordringer er forfalt.',
  'adv.monitor.detail.receivablesSlower': 'Kundene bruker i snitt {days} dager mer på å betale.',
  'adv.monitor.detail.receivablesOk': 'Ingen forfalte kundefordringer krever oppfølging.',
  'adv.monitor.detail.receivablesNoData': 'Det finnes ikke nok salgsdata til å vurdere innbetalingene.',
  'adv.monitor.detail.costsSupplierOverdue': '{amount} i leverandørkrav er forfalt.',
  'adv.monitor.detail.costsSupplierDependency': '{name} står for {pct} % av årets kostnader.',
  'adv.monitor.detail.costsBudgetOver': 'Kostnadene ligger {pct} % over budsjett hittil.',
  'adv.monitor.detail.costsIncrease': 'Kostnadene er opp {pct} % mot sammenlignbar periode.',
  'adv.monitor.detail.costsOk': 'Ingen vesentlige kostnads- eller leverandøravvik.',
  'adv.monitor.detail.costsNoData': 'Det finnes ikke nok kostnadsdata til å vurdere avvik.',
  'adv.monitor.detail.taxDeadline': 'Antall frister som bør følges opp: {count}.',
  'adv.monitor.detail.taxVat': 'Beregnet MVA som må dekkes er {amount}.',
  'adv.monitor.detail.taxOk': 'Ingen beregnede MVA-beløp eller nære frister krever handling.',
  'adv.monitor.detail.taxNoData': 'Det finnes ikke nok regnskapsdata til å vurdere MVA og skatt.',
  'adv.monitor.detail.qualityVouchers': '{count} bokførte kjøp mangler bilag.',
  'adv.monitor.detail.qualityBank': '{count} banklinjer er ikke ferdig avstemt.',
  'adv.monitor.detail.qualityStale': 'Siste regnskapsaktivitet er {days} dager gammel.',
  'adv.monitor.detail.qualityImportedAggregate': 'Importerte summer kan analyseres, men bilagsfullstendighet kan ikke kontrolleres uten enkeltføringene.',
  'adv.monitor.detail.qualityNoData': 'Det finnes ikke nok aktivitet i valgt år til å vurdere kvaliteten.',
  'adv.monitor.detail.qualityOk': 'Bilag og eventuelle banklinjer ser ryddige ut.',
  'adv.monitor.detail.salesBudgetBelow': 'Omsetningen ligger {pct} % under budsjett hittil.',
  'adv.monitor.detail.salesRevenueDrop': 'Omsetningen er ned {pct} % mot sammenlignbar periode.',
  'adv.monitor.detail.salesNegativeMargin': 'Resultatmarginen er {pct} %.',
  'adv.monitor.detail.salesCustomerDependency': '{name} står for {pct} % av årets omsetning.',
  'adv.monitor.detail.salesOk': 'Ingen vesentlige avvik i salg eller lønnsomhet.',
  'adv.monitor.detail.salesNoData': 'Det finnes ikke nok salgsdata til å vurdere utviklingen.',
  'adv.conf.buildsOn': 'Bygger på',
  'adv.conf.missing': 'Mangler',
  'adv.conf.nothingYet': 'Ingen bokførte tall ennå',
  'adv.conf.nothingMissing': 'Ingenting mangler',
  'adv.conf.postedIncome': 'Bokførte inntekter',
  'adv.conf.postedCosts': 'Bokførte kostnader',
  'adv.conf.openItems': 'Åpne poster',
  'adv.conf.previousYear': 'Fjorårstall',
  'adv.conf.customerSplit': 'Salg per kunde',
  'adv.conf.completeVouchers': 'Komplette bilag',
  'adv.conf.importedVoucherDetails': 'Detaljgrunnlag for importerte bilag',
  'adv.why.recWhyOverdueCash': 'Pengene er allerede opptjent — de står bare ubetalt',
  'adv.why.recWhyOverdueBuffer': 'Prognosen faller under bufferen din uten disse innbetalingene',
  'adv.why.recWhyVatDeadline': 'MVA forfaller på fast termin og kan ikke utsettes',
  'adv.why.recWhyVatInterest': 'Forsinket betaling gir forsinkelsesrente og gebyr',
  'adv.why.recWhyVoucherDeduction': 'Uten bilag kan fradraget bli strøket ved kontroll',
  'adv.why.recWhyVoucherAudit': 'Bokføringsloven krever dokumentasjon på hver føring',
  'adv.why.recWhyCostGrowth': 'Kostnadene vokser {pct} % mot fjoråret',
  'adv.chat.placeholder': 'Skriv en melding …',
  'adv.chat.send': 'Send',
  'adv.chat.fallbackToast': 'SuperPlumma svarte med lokal fallback.',
  'adv.chat.limitReached': 'Denne samtalen har nådd grensen på {max} spørsmål. Start en ny samtale for å fortsette.',
  'adv.chat.limitNear': '{left} spørsmål igjen i denne samtalen.',
  'adv.chat.newChat': 'Start ny samtale',
  'adv.chat.business.intro': 'Hei! Jeg er SuperPlumma, din økonomiske rådgiver. Jeg har gått gjennom regnskapet til bedriften din og kan svare på det du lurer på — likviditet, kostnader, skatt eller helsescoren. Hva vil du se nærmere på?',
  'adv.chat.business.sugg1': 'Hvordan kan jeg forbedre likviditeten?',
  'adv.chat.business.sugg2': 'Hvor kan jeg kutte kostnader?',
  'adv.chat.business.sugg3': 'Forklar helsescoren min',
  'adv.chat.business.sugg4': 'Når forfaller MVA?',
  'adv.chat.private.intro': 'Hei! Jeg er SuperPlumma, din private rådgiver. Jeg har sett på økonomien din og kan hjelpe deg med sparing, lån, fradrag, pensjon og skattemeldingen. Hva har du på hjertet?',
  'adv.chat.private.sugg1': 'Hvor kan jeg spare penger?',
  'adv.chat.private.sugg2': 'Bør jeg refinansiere boliglånet?',
  'adv.chat.private.sugg3': 'Hvilke fradrag kan jeg få?',
  'adv.chat.private.sugg4': 'Hvordan ligger jeg an til pensjon?',
  'adv.reply.private.saving': 'Jeg trenger koblet privatøkonomi-data før jeg kan peke på konkrete besparelser. Når data er klare, kan jeg vise faste trekk, abonnementer og uvanlige kostnader.',
  'adv.reply.private.loan': 'Jeg kan vurdere lån og rente når lånedata er koblet inn. Foreløpig bør konkrete låneråd kontrolleres mot banktilbud og faktisk låneavtale.',
  'adv.reply.private.tax': 'Jeg kan hjelpe med skatt når relevante private transaksjoner og fradragsgrunnlag er koblet inn. Bruk svaret som kontrollpunkt, ikke som bindende skatteråd.',
  'adv.reply.private.pension': 'Pensjonsråd krever inntekts-, pensjons- og sparedata. Når det er tilgjengelig, kan jeg vise utvikling og mulige justeringer.',
  'adv.reply.private.score': 'Privat helsescore beregnes når privatøkonomi-modellen har nok data.',
  'adv.reply.private.default': 'Godt spørsmål! Jeg kan hjelpe deg med sparing, lån, fradrag, pensjon og skattemeldingen. Hva vil du starte med?',
  'adv.reply.business.liquidity': 'Jeg trenger tilgang til backend-rådgiveren for å gi konkrete likviditetstall. Når den er tilgjengelig, bruker jeg åpne kundefordringer, leverandørkrav og rapporterte månedsdata.',
  'adv.reply.business.costs': 'Kostnadsråd bør bygge på bokførte kostnadslinjer og sammenligning mot tidligere år. Prøv igjen når SuperPlumma-backend er tilgjengelig.',
  'adv.reply.business.tax': 'Skatt og MVA må beregnes fra bokførte tall. Jeg gir ikke konkrete beløp i lokal fallback, men backend-rådgiveren kan hente dette fra rapportmodellen.',
  'adv.reply.business.score': 'Helsescoren beregnes fra faktisk likviditet, vekst, lønnsomhet og stabilitet når rådgivermodellen er tilgjengelig.',
  'adv.reply.business.invoices': 'Fakturaoppfølging krever åpne fakturaer fra backend. Når data er klare, kan jeg vise hvilke poster som bør følges opp først.',
  'adv.reply.business.default': 'Godt spørsmål. Jeg kan svare konkret når SuperPlumma-backend er tilgjengelig; lokal fallback viser bare generelle råd uten regnskapstall.',
  // ------------------------- Reiser, leverandorer, bankveiviser
  'trv.sub': 'Reiseregninger, kjøregodtgjørelse og utlegg sendt inn fra ansattportalen. Private utlegg går til neste lønnsutbetaling — firmakort/driftskonto bokføres direkte og holdes utenfor lønn.',
  'trv.allEmployees': 'Alle ansatte',
  'trv.searchPh': 'Søk på reise, formål eller ansatt',
  'trv.noTravel': 'Ingen reiser her ennå',
  'trv.noTravelHelp': 'Når ansatte sender inn reiser eller utlegg fra ansattportalen vises de her.',
  'trv.backToOverview': 'Tilbake til oversikt',
  'trv.approveTravel': 'Godkjenn reise',
  'trv.trips': 'Kjøringer',
  'trv.tripsHelp': 'Kilometergodtgjørelse etter statens sats.',
  'trv.noTrips': 'Ingen kjøringer registrert.',
  'trv.expenseHelp': 'Privat utlegg refunderes via lønn. Firmakort/driftskonto bokføres direkte.',
  'trv.noExpenses': 'Ingen utlegg registrert.',
  'trv.toPayroll': 'Til lønnsutbetaling',
  'trv.mileageAllowance': 'Kjøregodtgjørelse',
  'trv.tollsPrivate': 'Bompenger (privat)',
  'trv.privateExpenses': 'Private utlegg',
  'trv.postingSuggestion': 'Forslag til bokføring',
  'trv.owedToEmployee': 'Skyldig lønn / refusjon ansatt',
  'trv.previewComing': 'Forhåndsvisning av reiseregning og vedlegg kommer her.',
  'trv.privateRefundOf': 'Privat refusjon på',
  'trv.reasonShownToEmployee': 'Begrunnelsen vises til den ansatte i ansattportalen.',
  'trv.reason': 'Begrunnelse',
  'trv.whatMustBeFixed': 'Hva må rettes før reisen eller utlegget kan godkjennes?',
  'trv.subShort': 'Reiseregninger, kjøregodtgjørelse og utlegg knyttet til ansatte. Private utlegg går til neste lønnsutbetaling - firmakort/driftskonto bokføres direkte og holdes utenfor lønn.',
  'trv.newTravel': 'Ny reise',
  'trv.getStarted': 'Registrer en reise eller et utlegg for å komme i gang.',
  'trv.submitTravel': 'Send inn reise',
  'trv.reject': 'Avvis',
  'trv.accommodation': 'Overnatting',
  'trv.subsistenceHelp': 'Diett (kostgodtgjørelse) ved overnatting beregnes etter statens satser og utbetales trekkfritt til den ansatte.',
  'trv.noAccommodation': 'Ingen overnatting registrert.',
  'trv.subsistenceOvernight': 'Diett (overnatting)',
  'trv.optionalNotePh': 'Valgfritt notat, prosjekt eller referanse',
  'trv.editTravel': 'Endre reise',
  'trv.pickDate': 'Velg dato',
  'trv.route': 'Strekning',
  'trv.kilometreCount': 'Antall kilometer',
  'trv.sameRouteReturn': 'Bruk samme strekning på retur',
  'trv.pickVehicle': 'Velg kjøretøy',
  'trv.tollsNok': 'Bompenger (NOK)',
  'trv.paymentMethod': 'Betalingsmetode',
  'trv.companyCardOperating': 'Firmakort (Driftskonto)',
  'trv.vatOnReceipt': 'Mva på kvitteringen',
  'trv.vatNone': 'Ingen / ikke fradrag',
  'trv.enterPassengerName': 'Legg inn navn på passasjer',
  'trv.enterKilometres': 'Fyll inn antall kilometer',
  'trv.kmWithTrailer': 'Kilometer med henger',
  'trv.kmForestRoad': 'Kilometer på skog- og anleggsvei',
  'trv.newStay': 'Nytt opphold',
  'trv.stayType': 'Type opphold',
  'trv.otherAccommodationCooking': 'Annen overnatting m/kokemuligheter',
  'trv.mealsPaidYourself': 'Måltider du betalte selv',
  'trv.pickForWholeStay': 'Velg for hele oppholdet',
  'trv.breakfast': 'Frokost',
  'trv.lunch': 'Lunsj',
  'trv.dinner': 'Middag',
  'trv.vehicle': 'Kjøretøy',
  'trv.paymentMethod2': 'Betalingsmåte',
  'trv.requiredBeforeRegister': 'Beskrivelse, beløp og minst ett vedlegg kreves før du kan registrere.',
  'trv.companyCardDirectHelp': 'Firmakort/driftskonto bokføres direkte og holdes utenfor lønnsutbetalingen.',
  'registry.toggle': 'Søk i Brreg',
  'registry.toggleHelp': 'Foreslår foretak mens du skriver. Slå av for privatkunder.',
  'registry.searching': 'Søker i Brreg...',
  'registry.needNineDigits': 'Skriv 9 siffer for å søke org.nr. i Brreg.',
  'registry.noHits': 'Ingen treff i Brreg.',
  'registry.failed': 'BRREG-oppslag feilet.',
  'sup.invoices': 'Leverandørfakturaer',
  'sup.invoicesHelp': 'Alle fakturaer og kreditnotaer fra denne leverandøren. «Ikke betalt» er åpen leverandørgjeld, «Betalt» er oppgjort, og en kreditnota er en tilbakebetaling/korreksjon fra leverandøren.',
  'sup.noInvoicesMatch': 'Ingen leverandørfakturaer passet filteret.',
  'sup.seeVoucher': 'Se bilag',
  'sup.goTo': 'Gå til',
  'sup.number': 'Leverandørnr.',
  'sup.numberShort': 'Lev.nr.',
  'sup.numberPh': 'F.eks. 20001',
  'sup.name': 'Leverandørnavn',
  'sup.emailPh': 'faktura@leverandor.no',
  'sup.addressPh': 'Gateadresse, postnr og poststed',
  'sup.searchPh': 'Søk i leverandører ...',
  'sup.searchListPh': 'Søk på leverandør eller beløp',
  'sup.searchHelp': 'Søk opp en leverandør på nummer, navn, organisasjonsnummer, kontaktinformasjon, samlet kjøp eller utestående beløp.',
  'sup.totalPurchases': 'Total kjøp',
  'sup.mergeTitle': 'Slå sammen leverandører',
  'sup.mergeIntro': 'Har du opprettet samme leverandør to ganger?',
  'sup.mergeSwap': 'Bytt hvilken leverandør som beholdes',
  'sup.sameInvoiceNumber': 'Samme fakturanummer er registrert på begge leverandørene.',
  'sup.checkDuplicates': 'Kontroller at kjøpene ikke er duplikater før du slår sammen.',
  'sup.exportCsv': 'Leverandører CSV',
  'sup.exportExcel': 'Leverandører Excel',
  'sup.ledgerCsv': 'Leverandørreskontro CSV',
  'sup.ledgerExcel': 'Leverandørreskontro Excel',
  'sup.whoYouBuyFrom': 'Hvem du kjøper fra',
  'sup.outstandingHelp': 'Hvor mye du skylder leverandøren akkurat nå — summen av ubetalte leverandørfakturaer (leverandørgjeld). Står det 0, har du ingen åpne fakturaer til denne leverandøren.',
  'sup.totalPurchasesHelp': 'Samlet beløp du har kjøpt fra denne leverandøren totalt — både betalte og ubetalte fakturaer.',
  'sup.balance.youOwe': 'Du skylder leverandøren {amount}',
  'sup.balance.supplierOwes': 'Leverandøren skylder deg {amount}',
  'sup.ledger.empty': 'Ingen reskontrolinjer ennå.',
  'sup.status.posted': 'Bokført',
  'sup.status.partial': 'Delbetalt',
  'sup.status.unpaid': 'Ikke betalt',
  'sup.status.credit': 'Kreditnota',
  'sup.status.invoice': 'Faktura',
  'sup.filter.all': 'Alle',
  'sup.sheet.suppliers': 'Leverandører',
  'sup.sheet.ledger': 'Leverandørreskontro',
  'sup.export.internalId': 'Intern ID',
  'sup.ledger.type.supplierInvoice': 'Leverandørfaktura',
  'sup.ledger.type.payment': 'Leverandørbetaling',
  'sup.ledger.type.importedInvoice': 'Importert leverandørfaktura',
  'sup.excelUnavailable': 'Excel-eksport er ikke tilgjengelig ennå.',
  'sup.voucherUnderTransactions': 'Bilaget ligger under Transaksjoner.',
  'sup.voucherFallbackName': 'Bilag',
  'sup.voucherViewNotConnected': 'Visning av bilag er ikke koblet til backend.',
  'sup.cannotShowVoucher': 'Kunne ikke vise bilaget.',
  'sup.cannotFetchVoucher': 'Kunne ikke hente bilaget fra backend.',
  'sup.previewVoucher': 'Forhåndsvis bilaget',
  'sup.noVoucherUploaded': 'Ingen bilag lastet opp',
  'sup.nameRequired': 'Leverandørnavn må fylles ut.',
  'sup.saveFailed': 'Kunne ikke lagre leverandøren.',
  'sup.editTitle': 'Oppdater leverandør',
  'sup.updateAction': 'Oppdater',
  'sup.saveAction': 'Lagre',
  'sup.defaultDueDaysLabel': 'Standard betalingsfrist (dager)',
  'sup.defaultCostAccountLabel': 'Standard kostnadskonto',
  'sup.defaultSettlementAccountLabel': 'Standard betalingskonto',
  'sup.costAccountPh': 'f.eks. 6300',
  'sup.settlementAccountPh': 'f.eks. 1920',
  'sup.mergePickerPlaceholder': 'Velg leverandør ...',
  'sup.mergeKeep': 'Beholdes',
  'sup.mergeRemove': 'Slås sammen og fjernes',
  'sup.mergeSuccess': 'Leverandørene ble slått sammen',
  'sup.mergeBackendNotReady': 'Backend-merge er ikke klar.',
  'sup.mergeFailed': 'Kunne ikke slå sammen leverandørene.',
  'sup.merging': 'Slår sammen...',
  'sup.mergeAction': 'Slå sammen leverandører',
  'sup.mergeModalIntro': 'Velg duplikatet. Kjøp og fakturaer flyttes til leverandøren som beholdes, og den andre leverandøren fjernes.',
  'sup.mergeFieldLabel': 'Hvilken leverandør er det samme som {name}?',
  'sup.mergeMoreInvoiceNumbers': '+ {count} flere fakturanummer',
  'sup.noSuppliersToExport': 'Ingen leverandører å eksportere',
  'sup.exportListFailed': 'Kunne ikke eksportere leverandørlisten.',
  'sup.exportListDone': 'Leverandørliste lastet ned',
  'sup.noLedgerRowsToExport': 'Ingen reskontrolinjer å eksportere',
  'sup.exportLedgerFailed': 'Kunne ikke eksportere leverandørreskontro.',
  'sup.exportLedgerDone': 'Leverandørreskontro lastet ned',
  'sup.updated': 'Leverandør oppdatert',
  'sup.saved': 'Leverandør lagret',
  'sup.archived': 'Leverandør flyttet til arkiv',
  'sup.archiveFailed': 'Kunne ikke arkivere leverandøren.',
  'sup.reopened': 'Leverandøren er åpnet igjen',
  'sup.reopenFailed': 'Kunne ikke åpne leverandøren igjen.',
  'sup.titleHelp': 'Leverandørregisteret samler alle du kjøper fra — navn, org.nr., kontaktinfo og kontonummer for utbetalinger. Når du registrerer kjøp og leverandørfakturaer, knyttes de til riktig leverandør her.',
  'sup.downloadHelp': 'Last ned leverandørlisten eller leverandørreskontro som CSV eller Excel.',
  'sup.addHelp': 'Opprett en ny leverandør manuelt. Fyll inn navn og org.nr., så kan du knytte kjøp og fakturaer til den. Nye leverandører opprettes ofte automatisk når du bokfører et kjøp.',
  'sup.col.name': 'Leverandør',
  'sup.reopenAction': 'Åpne igjen',
  'sup.archiveAction': 'Arkiver',
  'sup.mergeHelp': 'Slå sammen to leverandører til én. Nyttig når samme leverandør er registrert flere ganger. All historikk og alle fakturaer flyttes til leverandøren du beholder.',
  'sup.enterName': 'Skriv inn leverandørnavn.',
  'sup.registryNotConnected': 'Leverandørregisteret er ikke koblet til backend.',
  'sup.saveSuccess': 'Leverandøren er lagret.',
  'sup.saveSupplierAction': 'Lagre leverandør',
  'bg.stepsHelp': 'Stegene leder deg gjennom én oppgave om gangen. En hake betyr at kontrollen er ferdig; et tall viser hva som fortsatt trenger oppmerksomhet.',
  'bg.balanceDiscrepancy': 'Saldoavvik',
  'bg.notCorrect': 'Ikke riktig',
  'bg.reconciliationDone': 'Bankavstemmingen er fullført',
  'bg.reconciliationDoneHelp': 'Kontoutskriften er kontrollert, bokført og flyttet til arkivet.',
  'bg.bankLines': 'Banklinjer',
  'bg.reconciled': 'Avstemt',
  'bg.backToBank': 'Tilbake til Bank',
  'bg.reopenReconciliation': 'Åpne avstemmingen igjen',
  'bg.bankAccountCaps': 'BANKKONTO',
  'bg.periodCaps': 'PERIODE',
  'bg.balanceAtStart': 'Saldo ved periodens start',
  'bg.balanceAtEnd': 'Saldo ved periodens slutt',
  'bg.balancesMatch': 'Saldoene stemmer.',
  'bg.roundingHelp': 'Dette kan bokføres på avrundingskonto 7770 uten å endre beløpet fra bankutskriften.',
  'bg.balancesMatchContinue': 'Saldoene stemmer – fortsett',
  'bg.suggestionsHeading': 'SuperPlumma har matchet og foreslått bokføring — du bestemmer',
  'bg.noSuggestions': 'Ingen forslag venter på godkjenning.',
  'bg.continueToRest': 'Fortsett til resten',
  'bg.noPostedDiscrepancies': 'Ingen bokførte poster skaper avvik.',
  'bg.checkAndFix': 'Kontroller og rett postene før perioden fullføres.',
  'bg.allPaymentsHandled': 'Alle betalinger er behandlet.',
  'bg.continueToVouchers': 'Fortsett til bilag',
  'bg.allPurchasesDocumented': 'Alle kjøp har nødvendig dokumentasjon eller er merket uten bilag.',
  'bg.seePurchase': 'Se kjøpet',
  'bg.withoutVoucher': 'Uten bilag',
  'bg.linkSuggested': 'Koble foreslått',
  'bg.pickVoucher': 'Velg bilag',
  'bg.continueToFinish': 'Fortsett til fullføring',
  'bg.bankLinesTotal': 'Banklinjer totalt',
  'bg.linkedPosted': 'Koblet/bokført',
  'bg.privateMovements': 'Private bevegelser',
  'bg.reconcileAndArchive': 'Avstem og arkiver',
  'bg.backAndCheck': 'Tilbake og kontroller',
  'bg.stepModeHelp': 'Steg for steg leder deg gjennom én oppgave om gangen. Full oversikt viser alt samlet.',

  // ------------------------- Min side, budsjett, AI Radgiver
  'acc.sub': 'Din profil og virksomhetene du har tilgang til.',
  'acc.signOutHelp': 'Logger deg ut av Plumme. Du må logge inn igjen med e-post og passord for å fortsette.',
  'acc.yourRole': 'Din rolle',
  'acc.yourRoleHelp': 'Rollen styrer hva du kan gjøre: Eier har full tilgang, Administrator styrer drift, Regnskapsfører fører regnskapet, og Leser kan bare se. Rollen kan være ulik fra foretak til foretak.',
  'acc.editProfile': 'Rediger profil',
  'acc.myBusinesses': 'Mine virksomheter',
  'acc.myBusinessesHelp': 'Foretakene du har tilgang til i Plumme. Merkelappen viser rollen din i hvert foretak. Trykk på et foretak for å åpne regnskapet.',
  'acc.personalFinanceHelp': 'Privatøkonomi er en egen klienttype for personlig økonomi og husholdning, adskilt fra foretakenes regnskap.',
  'acc.goToPersonalFinance': 'Gå til privatøkonomi',
  'acc.ownPersonalClient': 'Egen privatøkonomi-klient',
  'acc.myEmployers': 'Mine arbeidsgivere',
  'acc.myEmployersHelp': 'Virksomheter du er ansatt i (ikke nødvendigvis fører regnskap for). Her finner du etter hvert lønnsslipper, kontrakter og din egen ansattside.',
  'acc.employerPortalAccess': 'Virksomheter du har ansattportal-tilgang til.',
  'acc.changePicture': 'Bytt bilde',
  'acc.removePicture': 'Fjern bilde',
  'acc.photoUploading': 'Laster opp …',
  'acc.photoRemoving': 'Fjerner …',
  'acc.photoSaved': 'Profilbildet er oppdatert.',
  'acc.photoRemoved': 'Profilbildet er fjernet.',
  'acc.photoWrongType': 'Velg et bilde i PNG, JPG eller WebP.',
  'acc.photoEmpty': 'Bildefilen er tom.',
  'acc.photoTooLarge': 'Bildet er for stort. Maks 2 MB.',
  'acc.photoUploadFailed': 'Kunne ikke laste opp profilbildet.',
  'acc.photoRemoveFailed': 'Kunne ikke fjerne profilbildet.',
  'acc.photoUnavailable': 'Profilbilde er ikke tilgjengelig akkurat nå.',
  'acc.fullName': 'Fullt navn',
  'acc.phoneFromLogin': 'Telefon fra innlogging',
  'acc.changePassword': 'Endre passord',
  'acc.changes': 'Endringer',
  'acc.noChangeDetails': 'Ingen ekstra endringsdetaljer er lagret for denne hendelsen.',
  'acc.logSub': 'Hva som er gjort i regnskapet - og av hvem.',
  'acc.logFilterHelp': 'Filtrer loggen på periode, område (f.eks. Faktura, Lønn, MVA) og hvilken bruker som utførte handlingen.',
  'acc.area': 'Område',
  'acc.areaHelp': 'Hvilken del av regnskapet handlingen gjelder - f.eks. Faktura, Kjøp, Lønn eller MVA. En handling kan berøre flere områder.',
  'acc.user': 'Bruker',
  'acc.userHelp': 'Personen som utførte handlingen, med rollen sin. Slik ser du hvem som står bak hver endring.',
  'acc.sentLinkTo': 'Vi har sendt en lenke til',
  'bud.annualBudget': 'Årsbudsjett',
  'bud.suggestion': 'Budsjettforslag',
  'bud.createSuggestion': 'Lag forslag',
  'bud.startSimpleQuestions': 'Start med enkle spørsmål',
  'bud.fillRelevant': 'Fyll ut bare det som er relevant. Månedsbeløp gjøres om til årsbudsjett.',
  'bud.businessDescription': 'Beskrivelse av virksomheten',
  'bud.businessDescriptionPh': 'F.eks. Transportbyrå for 2027 med 2 varebiler, 2 ansatte, kontorleie 8 000/mnd og mer inntekt om sommeren.',
  'bud.howToBudget': 'Hvordan lage budsjett',
  'bud.howToBudgetHelp': 'Velg metode: «Manuelt» legger du inn kontoene selv, «Forslag» svarer du på noen enkle spørsmål og får et utkast, og «AI-forslag» beskriver du virksomheten med egne ord så lager Plumme et utkast.',
  'bud.budgetedResult': 'Budsjettert resultat',
  'bud.budgetedResultHelp': 'Resultatet du har budsjettert for hele året — summen av budsjetterte inntekter minus budsjetterte kostnader. Dette er målet du styrer mot.',
  'bud.actualResult': 'Faktisk resultat',
  'bud.actualResultHelp': 'Det faktiske resultatet som er bokført hittil i år — reelle inntekter minus reelle kostnader. Sammenlign med budsjettet for å se om du ligger an som planlagt.',
  'bud.postedSoFar': 'bokført hittil',
  'bud.varianceToPeriod': 'Avvik mot periode',
  'bud.varianceToPeriodHelp': 'Forskjellen mellom faktisk og budsjettert resultat hittil. Negativt avvik betyr at du ligger under budsjett, positivt at du ligger over.',
  'bud.incomeTarget': 'Inntektsmål',
  'bud.incomeTargetHelp': 'Hvor stor andel av de budsjetterte inntektene for året du har nådd så langt — faktisk fakturert inntekt delt på budsjettert inntekt.',
  'bud.ofTargetReached': 'oppnådd av målet',
  'bud.viewHelp': 'Bytt visning: «Oversikt» viser akkumulert resultat og største avvik, «Analyse» viser inntekt mot kostnad og resultat per måned, og «Budsjett per kategori» er der du legger inn og endrer beløpene.',
  'bud.accumulatedResult': 'Akkumulert resultat',
  'bud.accumulatedResultHelp': 'Grafen viser resultatet som bygger seg opp måned for måned gjennom året. Den stiplede linjen er budsjettet, den heltrukne er faktisk bokført — slik ser du om du følger planen.',
  'bud.budgetAtYearEnd': 'Budsjett ved årsslutt',
  'bud.accumulated': 'akkumulert',
  'bud.actualSoFar': 'Faktisk hittil',
  'bud.posted': 'bokført',
  'bud.varianceSoFar': 'Avvik hittil',
  'bud.largestVariance': 'Største avvik',
  'bud.largestVarianceHelp': 'Kontoen som avviker mest fra budsjettet hittil i år. Nyttig for å se raskt hvor det går mest over eller under det du planla.',
  'bud.soFarThisYear': 'hittil i år',
  'bud.incomeVsCost': 'Inntekt vs. kostnad per måned',
  'bud.incomeVsCostHelp': 'Søylene viser inntekt (grønn) mot kostnad (oransje) for hver måned. Bytt mellom faktiske tall, budsjetterte tall, eller begge. Trykk på en måned for å summere et utvalg.',
  'bud.resultPerMonth': 'Resultat per måned',
  'bud.resultPerMonthHelp': 'Viser resultatet (inntekt minus kostnad) for hver enkelt måned, budsjett mot faktisk. Søyler over midtlinjen er overskudd, under er underskudd.',
  'bud.actual': 'Faktisk',
  'bud.actualByCategory': 'Faktisk per kategori',
  'bud.actualByCategoryHelp': 'Bokførte inntekter og kostnader per konto, fordelt på måned. Tallene kommer fra regnskapet ditt — både bilag du har registrert i Plumme og tall fra en import — og oppdateres av seg selv.',
  'bud.noActuals': 'Ingen bokførte tall for {year} ennå.',
  'bud.actualOnlyHint': 'Dette er faktiske tall. Legg inn et budsjett under Budsjett hvis du vil måle deg mot en plan.',
  'bud.byCategory': 'Budsjett per kategori',
  'bud.addIncome': 'Legg til inntekt',
  'bud.addIncomeHelp': 'Legg til en inntektskategori med et årsbeløp — f.eks. forventet salg. Beløpet fordeles på måneder, som du kan justere.',
  'bud.addCost': 'Legg til kostnad',
  'bud.addCostHelp': 'Legg til en kostnadskategori med et årsbeløp — f.eks. husleie, varekjøp eller programvare. Beløpet fordeles på måneder, som du kan justere.',
  'bud.noCategories': 'Ingen budsjettkategorier ennå. Legg til inntekt eller kostnad.',
  'bud.useLastYear': 'Bruk fjorår',
  'bud.simpleQuestions': 'Enkle spørsmål',
  'bud.byCategoryHelp': 'Hver rad er en budsjettkategori. Beløpene for hver av de 12 månedene er alltid synlige og redigerbare direkte i tabellen, med totalen for året til høyre.',
  'bud.total': 'Total',
  'bud.annualTotal': 'Årstotal',
  'bud.annualTotalHelp': 'Endrer du dette tallet direkte, fordeles det nye årsbeløpet jevnt utover alle 12 månedene.',
  'bud.save': 'Lagre',
  'bud.methodManual': 'Manuelt',
  'bud.methodSuggestion': 'Forslag',
  'bud.methodAi': 'AI-forslag',
  'bud.modeBudgeted': 'Budsjettert',
  'bud.modeBoth': 'Begge',
  'bud.forWholeYear': 'for hele {year}',
  'bud.underBudget': 'under budsjett',
  'bud.overBudget': 'over budsjett',
  'bud.legendBudgetDashed': '- - Budsjett',
  'bud.legendBudgetSolid': '— Budsjett',
  'bud.legendActual': '— Faktisk',
  'bud.noVarianceYet': 'Ingen avvik ennå',
  'bud.savedToast': 'Budsjett lagret',
  'bud.saveFailedToast': 'Kunne ikke lagre budsjett',
  'bud.aiModalTitle': 'AI-budsjett for {year}',
  'bud.aiDraftBusy': 'Lager utkast...',
  'bud.aiDraftCreate': 'Lag utkast med AI',
  'bud.aiDescription': 'Beskriv virksomheten med egne ord: ansatte, lønn, eiendeler, faste kostnader og sesongvariasjon. Jo mer detaljer, jo bedre utkast.',
  'bud.aiDraftFailedGeneric': 'Jeg klarte ikke å lage et budsjettutkast fra beskrivelsen. Legg til mer detaljer, eller bruk Forslag.',
  'bud.aiDraftAppliedToast': 'AI-utkast lagt inn. Trykk Lagre når det ser riktig ut.',
  'bud.aiDraftFailed': 'AI-budsjettutkast feilet.',
  'bud.suggestionIntro': 'Lag et forslag fra faktiske tall i fjor, eller svar på noen enkle spørsmål for et startbudsjett.',
  'bud.catSales': 'Salg av varer og tjenester',
  'bud.catPurchases': 'Varekjøp og direkte kostnader',
  'bud.catPremises': 'Lokaler',
  'bud.catSoftware': 'Programvare og utstyr',
  'bud.catAccounting': 'Regnskap og rådgivning',
  'bud.catTravel': 'Reise',
  'bud.catMarketing': 'Markedsføring',
  'bud.catCommunication': 'Telefon, porto og kommunikasjon',
  'bud.otherCosts': 'Andre kostnader',
  'bud.customCategory': 'Egen kategori',
  'bud.q.expectedIncome.label': 'Hvor mye skal du tjene?',
  'bud.q.expectedIncome.hint': 'Forventet fakturert inntekt for hele året.',
  'bud.q.goodsAnnual.label': 'Varekjøp',
  'bud.q.goodsAnnual.hint': 'Varer eller materiell du kjøper inn for salg.',
  'bud.q.officeMonthly.label': 'Kontor/lokale per måned',
  'bud.q.officeMonthly.hint': 'Husleie, kontorplass eller lokale.',
  'bud.q.softwareMonthly.label': 'Programvare per måned',
  'bud.q.softwareMonthly.hint': 'Abonnementer, verktøy og apper.',
  'bud.q.accountingMonthly.label': 'Regnskap/rådgivning per måned',
  'bud.q.accountingMonthly.hint': 'Regnskapsfører, rådgiver eller hjelp.',
  'bud.q.travelAnnual.label': 'Bil/reise i året',
  'bud.q.travelAnnual.hint': 'Kjøring, reise, hotell eller transport.',
  'bud.q.marketingAnnual.label': 'Markedsføring i året',
  'bud.q.marketingAnnual.hint': 'Annonser, profilering og salgskostnader.',
  'bud.q.otherAnnual.hint': 'Legg inn en buffer for det du ikke vet ennå.',
  // Det som er igjen av aii.*: delte SuperPlumma-etiketter som brukes fra Hjem
  // og Privatøkonomi. Selve AI Rådgiver-siden ligger under adv.*. Legg ikke nye
  // rådgiver-nøkler her.
  'aii.superPlumma': 'SuperPlumma',
  'aii.askSuperPlumma': 'Spør SuperPlumma',
  'aii.chatWithSuperPlumma': 'Chat med SuperPlumma',
  'aii.chatWithMe': 'Chat med meg',
  'aii.healthScore': 'Økonomisk helsescore',

  // ------------------------------- Privatokonomi (kjerne)
  'po.title': 'Privat økonomi',
  'po.backToBusiness': 'Tilbake til bedrift',
  'po.yourAdvisor': 'Din private rådgiver',
  'po.intro': 'Privatøkonomi er din personlige økonomi — helt adskilt fra bedriftsregnskapet. SuperPlumma analyserer inntekt, forbruk, sparing, lån, pensjon og skatt for husholdningen, og gir råd slik en privat finansrådgiver ville gjort. «Beta» betyr at funksjonen fortsatt er under utvikling.',
  'po.hero.greeting.night': 'God natt.',
  'po.hero.greeting.morning': 'God morgen.',
  'po.hero.greeting.day': 'Hei.',
  'po.hero.greeting.evening': 'God kveld.',
  'po.hero.greetingNamed.night': 'God natt, {name}.',
  'po.hero.greetingNamed.morning': 'God morgen, {name}.',
  'po.hero.greetingNamed.day': 'Hei, {name}.',
  'po.hero.greetingNamed.evening': 'God kveld, {name}.',
  'po.hero.section.idag': 'Dagens råd',
  'po.hero.section.oversikt': 'Økonomisk oversikt',
  'po.hero.section.forbruk': 'Forbruk',
  'po.hero.section.familie': 'Familieøkonomi',
  'po.hero.section.fremtid': 'Fremtidsplan',
  'po.hero.section.reports': 'Rapporter',
  'po.hero.section.assets': 'Eiendeler',
  'po.hero.section.gjeld': 'Gjeld',
  'po.hero.section.import': 'Datagrunnlag',
  'po.hero.advice.idag': 'Jeg følger med på økonomien din og løfter frem de viktigste oppgavene og mulighetene akkurat nå.',
  'po.hero.advice.oversikt': 'Se hva som trekker den økonomiske helsen opp og ned. Start med området som trenger mest oppfølging.',
  'po.hero.advice.forbruk': 'Se etter kategorier som har økt, og velg ett realistisk grep som gir mer rom uten å gjøre hverdagen trang.',
  'po.hero.advice.familie': 'Avklar hva som er felles, hvem som betaler hva, og hvilke mål husholdningen skal prioritere sammen.',
  'po.hero.advice.fremtid': 'Gjør målene konkrete med beløp og dato. Da blir det enklere å se hva du bør spare hver måned.',
  'po.hero.advice.reports': 'Bruk rapportene til å forstå utviklingen over tid, ikke bare ett enkelt høyt eller lavt månedsbeløp.',
  'po.hero.advice.assets': 'Kontroller at verdier og kontosaldoer er oppdaterte før du vurderer nettoformue og langsiktige valg.',
  'po.hero.advice.gjeld': 'Prioriter trygg buffer først, og vurder deretter ekstra nedbetaling på gjelden med høyest effektiv rente.',
  'po.hero.advice.import': 'Et godt råd starter med gode data. Koble kontoutskriftene til riktig konto og rydd opp i manglende perioder.',
  'po.pickPerson': 'Velg person',
  'po.sections': 'Seksjoner',
  'po.sectionsHelp': 'Bytt mellom områdene: I dag (dagens innsikter), Oversikt (helsescore og nøkkeltall), Forbruk (hvor pengene går), Familie, Fremtid (prognose og «hva skjer hvis»), Rapporter, Eiendeler, Gjeld, Skatt og Import.',
  'po.outOf100': 'av 100',
  'po.todaysFocus': 'Dagens fokus',
  'po.todaysTasks': 'Dagens gjøremål',
  'po.mostImportantToday': 'Viktigst i dag',
  'po.markDone': 'Marker som fullført',
  'po.undo': 'Angre',
  'po.healthHeading': 'Din samlede økonomiske helse — og hva som beveger den',
  'po.healthHelp': 'Tallet i ringen (0–100) er en samlet vurdering av økonomien din — jo høyere, jo sunnere. Kategoriene under viser hva som trekker opp og ned: grønt er bra, gult betyr følg med, og rødt trenger oppfølging.',
  'po.noHistory': 'Ingen historikk å sammenligne med ennå',
  'po.whatAffectsScore': 'Hva påvirker scoren mest',
  'po.noDrivers': 'Ingen drivere beregnet ennå',
  'po.noDriversHelp': 'Når det er nok importerte transaksjoner, viser jeg hva som trekker scoren opp og ned.',
  'po.last30Days': 'Siste registrerte måned',
  'po.last30DaysSub': 'Sammenlignet med foregående kalendermåned',
  'po.financialOverview': 'Økonomisk oversikt',
  'po.financialOverviewSub': 'Et øyeblikksbilde av husholdningens økonomi',
  'po.recommendations': 'SuperPlummas anbefalinger',
  'po.recommendationsSub': 'De grepene som betyr mest for økonomien din akkurat nå',
  'po.askMe': 'Spør meg',
  'po.yourHealthScoreIs': 'Helsescoren din er',
  'po.adjustBudget': 'Juster budsjett',
  'po.budgetTotal': 'Sum budsjett:',
  'po.saveBudget': 'Lagre budsjett',
  'po.monthlyLimitPerCategory': 'Månedlig grense per kategori',
  'po.noCategoriesImported': 'Ingen forbrukskategorier importert ennå. Legg til egne kategorier under.',
  'po.ownCategories': 'Egne kategorier',
  'po.pickColour': 'Velg farge',
  'po.categoryName': 'Navn på kategori',
  'po.removeCategory': 'Fjern kategori',
  'po.addCategory': 'Legg til kategori',
  'po.budgetVsSpending': 'Budsjett mot forbruk',
  'po.budgetVsSpendingSub': 'Månedlig grense mot forbruket i valgt periode',
  'po.budgetVsSpendingHelp': 'Månedlig budsjett mot faktisk forbruk per kategori. Trykk «Juster budsjett» for å sette grensene eller opprette egne kategorier. Progresjonslinjen fylles etter hvor mye av budsjettet du har brukt — grønt er innenfor, gult nærmer seg grensen, og rødt betyr at kategorien er overskredet. Velger du årlig oversikt, ganges den månedlige grensen opp med antall måneder som har importerte data. Budsjettene lagres for valgt år.',
  'po.whereMoneyGoes': 'Hvor går pengene?',
  'po.whereMoneyGoesSub': 'Trykk en kategori for å se transaksjonene bak og flytte dem til riktig sted',
  'po.whereMoneyGoesHelp': 'Kakediagrammet og listen viser forbruket fordelt på kategorier for valgt periode. Bytt periode med knappen øverst — måneder uten importerte transaksjoner er grå. Trykk en kategori for å fremheve den. Prosenten til høyre er endringen mot forrige måned — grønt ned betyr mindre, rødt opp betyr mer.',
  'po.selectPeriod': 'Velg periode',
  'po.yearOverview': 'Årlig oversikt',
  'po.yearly': 'Årlig',
  'po.month.1': 'Januar',
  'po.month.2': 'Februar',
  'po.month.3': 'Mars',
  'po.month.4': 'April',
  'po.month.5': 'Mai',
  'po.month.6': 'Juni',
  'po.month.7': 'Juli',
  'po.month.8': 'August',
  'po.month.9': 'September',
  'po.month.10': 'Oktober',
  'po.month.11': 'November',
  'po.month.12': 'Desember',
  'po.largestCategoryIs': 'Største kostnadskategori er',
  'po.recurringCharges': 'Faste trekk å vurdere',
  'po.recurringChargesSub': 'Gjentakende abonnementstrekk som kan være verdt å kontrollere',
  'po.opportunity': 'Mulighet',
  'po.estimatedAnnualCost': 'Beregnet årlig kostnad',
  'po.saveAccount': 'Lagre konto',
  'po.allAccounts': 'Alle kontoer',
  'po.uploadedStatements': 'Opplastede utskrifter',
  'po.yourAccounts': 'Dine kontoer',
  'po.yourAccountsSub': 'Registrer og sorter kontoene dine etter type — importerte kontoutskrifter knyttes til riktig konto',
  'po.totalBalance': 'Sum innestående',
  'po.creditDebt': 'Kredittgjeld',
  'po.accounts': 'Kontoer',
  'po.analysis': 'SuperPlummas analyse',
  'po.analysisSub': 'Hvordan forbruket i kategorien fordeler seg — og hva du kan gjøre',
  'po.whoIsBehind': 'Hvem står bak',
  'po.noTransactionsToAnalyse': 'Ingen transaksjoner å analysere ennå.',
  'po.unusualPurchases': 'Uvanlige kjøp',
  'po.noUnusualPurchases': 'Ingen kjøp skiller seg ut i denne perioden.',
  'po.searchTransactions': 'Søk i transaksjoner …',
  'po.clearSearch': 'Tøm søk',
  'po.sort': 'Sorter',
  'po.linkStatementToAccount': 'Koble kontoutskrift til konto',
  'po.linkToAccount': 'Koble til konto',
  'po.newAccount': 'Ny konto',
  'po.accountNamePh': 'F.eks. DNB brukskonto',
  'po.accountNumberPh': 'F.eks. 1234.56.78901',
  'po.currentAccount': 'Brukskonto',
  'po.creditCard': 'Kredittkort',
  'po.me': 'jeg',
  'po.importTitle': 'Importer økonomiske data',
  'po.importSub': 'Last opp kontoutskrifter — SuperPlumma leser og kategoriserer automatisk',
  'po.pickStatement': 'Velg kontoutskrift fra banken',
  'po.pickStatementHelp': 'Last opp kontoutskrifter fra banken. XLSX og CSV leses direkte, PDF leses best effort fra tekst. SuperPlumma kategoriserer transaksjonene automatisk.',
  'po.pdf': 'PDF',
  'po.noStatementsUploaded': 'Ingen kontoutskrifter er lastet opp ennå.',
  'po.deleteStatement': 'Slett kontoutskrift',
  'po.sharedCosts': 'Bidrag til felleskostnader',
  'po.sharedCostsSub': 'Hvem betaler hva av de felles utgiftene — og hvordan det står mot inntektsandelen',
  'po.sharedCostsHelp': 'Søylen viser hvor stor andel av husholdningens felleskostnader hver av dere dekker. Til høyre står andelen av samlet inntekt. Er de to like store, er fordelingen proporsjonal med inntekt. Tallene kommer fra det hver av dere har lagt inn på sin egen profil.',
  'po.splitIsEven': 'Fordelingen er jevn. Dere deler',
  'po.togetherYouCan': 'Sammen kan dere',
  'po.togetherYouCanSub': 'Små grep dere kan ta som et lag — regnet ut fra husholdningens egne tall',
  'po.togetherHelp': 'Forslagene er regnet ut fra samlet inntekt og felleskostnader dere har lagt inn. De er ment som felles mål, ikke krav til enkeltpersoner.',
  'po.sharedSteps': 'Felles grep',
  'po.magnitude': 'Størrelsesorden',
  'po.youPartnerPh': 'Deg, partner …',
  'po.monthlyNetIncome': 'Månedlig nettoinntekt',
  'po.sharedCostShare': 'Andel felleskostnader per måned',
  'po.familyFinances': 'Familieøkonomi',
  'po.addPerson': 'Legg til person',
  'po.noHouseholdMembers': 'Ingen husholdningsmedlemmer er registrert ennå.',
  'po.householdHasRegistered': 'Husholdningen har registrert',

  // -------------------- Privatokonomi (fremtid, gjeld, eiendeler, skatt)
  'po.todaysPlan': 'Dagens plan',
  'po.savePlan': 'Lagre plan',
  'po.monthlySaving': 'Månedlig sparing (kr)',
  'po.monthlyExtraDebt': 'Månedlig ekstra gjeldsnedbetaling (kr)',
  'po.targetNetWealth': 'Ønsket nettoformue (kr)',
  'po.expectedReturn': 'Forventet årlig avkastning (%)',
  'po.yourAgeToday': 'Din alder i dag (år)',
  'po.desiredRetirementAge': 'Ønsket pensjonsalder (år)',
  'po.pickEvent': 'Velg en hendelse',
  'po.eventNamePh': 'F.eks. Barn nummer to',
  'po.starts': 'Starter',
  'po.oneOffCost': 'Engangskostnad (kr)',
  'po.monthlyEffect': 'Månedlig effekt (kr)',
  'po.durationMonths': 'Varighet (måneder)',
  'po.goalName': 'Navn på målet',
  'po.goalNamePh': 'F.eks. Buffer',
  'po.shortDescription': 'Kort beskrivelse',
  'po.whatSavingFor': 'Hva sparer du til?',
  'po.targetAmount': 'Målbeløp (kr)',
  'po.savedSoFar': 'Spart så langt (kr)',
  'po.icon': 'Ikon',
  'po.colour': 'Farge',
  'po.debtFree': 'Gjeldfri',
  'po.saveLoan': 'Lagre lån',
  'po.loanType': 'Lånetype',
  'po.spendingCategory': 'Kategori i Forbruk',
  'po.categoryPh': 'F.eks. Bolig',
  'po.debtOverview': 'Gjeldsoversikt',
  'po.debtOverviewSub': 'Alle lånene dine samlet — restgjeld, renter og nedbetalingstakt',
  'po.debtOverviewHelp': 'Nøkkeltallene for all gjelden din: samlet restgjeld, hva du betaler ned per måned, renteutgifter per år, snittrente og hvor lang tid til du er gjeldfri.',
  'po.totalDebt': 'Total gjeld',
  'po.repaymentPerMonth': 'Nedbetaling per måned',
  'po.interestPerYear': 'Renter per år',
  'po.averageRate': 'Snittrente',
  'po.debtFreeIn': 'Gjeldfri om',
  'po.loanCount': 'Antall lån',
  'po.yourLoans': 'Dine lån',
  'po.yourLoansSub': 'Trykk på et lån for å se nedbetalingsplan og simulere endringer',
  'po.addLoan': 'Legg til lån',
  'po.noLoans': 'Ingen lån lagt inn ennå. Trykk «Legg til lån» for å komme i gang.',
  'po.whichLoanFirst': 'Hvilke lån bør du betale ned først?',
  'po.whichLoanFirstSub': 'Rangert etter rente — det dyreste lånet først gir mest igjen for hver ekstra krone',
  'po.iRecommend': 'Jeg anbefaler',
  'po.snowballWithRate': 'rentemetoden (skredmetoden)',
  'po.repaymentSimSub': 'Se hvordan restgjelden faller, og simuler hva som skjer om du betaler mer eller mindre per måned',
  'po.myRecommendation': 'Min anbefaling',
  'po.withChange': 'Med endring',
  'po.extraRepaymentPerMonth': 'Ekstra nedbetaling per måned',
  'po.dragToPayMore': 'Dra for å betale mer (raskere gjeldfri) eller mindre (lengre løpetid)',
  'po.standard': 'Standard',
  'po.savedInInterest': 'Spart i renter',
  'po.overWholeTerm': 'over hele løpetiden',
  'po.netWealthEffect': 'Nettoformue-effekt',
  'po.becomesYours': 'blir din, ikke bankens',
  'po.interestPostedAs': 'Renter og avdrag på dette lånet føres som',
  'po.debtJourney': 'Din gjeldsreise',
  'po.debtJourneySub': 'De viktigste milepælene frem mot å bli helt gjeldfri',
  'po.yourFinancialFuture': 'Din økonomiske fremtid',
  'po.yourFinancialFutureSub': 'Hvor pengene tar deg — og hvordan valgene dine former veien dit',
  'po.showingScenario': 'Viser scenario:',
  'po.reset': 'Tilbakestill',
  'po.desiredNetWealth': 'Ønsket nettoformue',
  'po.lastsUntilYouAre': 'varer til du er',
  'po.lasts': 'varer',
  'po.forLife': 'livet ut',
  'po.plummaReadsChart': 'SuperPlumma leser grafen',
  'po.whatIf': 'Hva skjer hvis?',
  'po.whatIfSub': 'Sett utgangspunktet i Dagens plan, velg en beslutning og juster forutsetningene — så oppdateres grafen, målene, datoene og pensjonen samtidig',
  'po.todaysPlanBase': 'Dagens plan — utgangspunktet',
  'po.editTodaysPlan': 'Rediger dagens plan',
  'po.netWealthToday': 'Nettoformue i dag',
  'po.monthlySavingShort': 'Månedlig sparing',
  'po.extraDebtRepayment': 'Ekstra gjeldsnedbetaling',
  'po.return': 'Avkastning',
  'po.retirementAge': 'Pensjonsalder',
  'po.adjustAssumptions': 'Juster forutsetninger',
  'po.lifeEvents': 'Livshendelser',
  'po.lifeEventsSub': 'Planlegg store hendelser fremover — barn, bolig, permisjon, sabbatsår — og se hvordan de former hele fremtidsbildet',
  'po.addEvent': 'Legg til hendelse',
  'po.lifeEventsHelp': 'Legg inn fremtidige hendelser med startdato, engangskostnad, månedlig effekt og varighet. Hver aktiv hendelse legges inn på riktig tidspunkt i prognosen. Slå en hendelse av for å se planen uten den. Hendelsene lagres for valgt år.',
  'po.effectOver5Years': 'Effekt på 5 år',
  'po.goalScore': 'Målscore',
  'po.goalScoreSub': 'Hvor godt du ligger an til å nå målene dine — og hva som løfter scoren',
  'po.whatAffectsGoalScore': 'Dette påvirker målscoren',
  'po.myRecommendationNow': 'Min anbefaling akkurat nå',
  'po.prioritise': 'Prioriter',
  'po.talkAboutPlan': 'Snakk med meg om planen',
  'po.yourGoals': 'Dine mål',
  'po.yourGoalsSub': 'Hvert mål med beløp igjen, forventet dato og sannsynlighet',
  'po.newGoal': 'Nytt mål',
  'po.addGoal': 'Legg til mål',
  'po.editGoal': 'Rediger mål',
  'po.deleteGoal': 'Slett mål',
  'po.remaining': 'Igjen',
  'po.expectedDone': 'Forventet ferdig',
  'po.probability': 'Sannsynlighet',
  'po.largestEffect': 'Størst effekt',
  'po.howReachFaster': 'Hva kan jeg gjøre for å nå dette raskere?',
  'po.nextMilestone': 'Neste milepæl',
  'po.nextMilestoneSub': 'Det du sannsynligvis oppnår først — i kronologisk rekkefølge',
  'po.yourLifePlan': 'Din livsplan',
  'po.yourLifePlanSub': 'De viktigste økonomiske milepælene fremover, bygget av målene og planen din',
  'po.adjustLive': 'Juster forutsetningene — prognosen, målene og datoene oppdateres i sanntid mens du drar.',
  'po.deleteGoalTitle': 'Slette målet?',
  'po.deleteGoalConfirm': 'Slett målet',
  'po.doYouWantToDelete': 'Vil du slette',
  'po.ownPartnerSharedSub': 'Oversikt over egne, partners og felles kostnader',
  'po.you': 'Deg',
  'po.partner': 'Partner',
  'po.householdSpends': 'Husholdningen bruker',
  'po.reportSub': 'Se, sammenlign, skriv ut og last ned måneds- og årsrapporter',
  'po.print': 'Skriv ut',
  'po.downloadPdf': 'Last ned PDF',
  'po.pdfBusy': 'Lager PDF …',
  'po.pdfFailed': 'Kunne ikke lage PDF av rapporten. Prøv igjen, eller bruk Skriv ut.',
  'po.pdfFileName': 'privatokonomi-rapport',
  'po.compareWith': 'Sammenlign med',
  'po.compareHelp': 'Legg en tidligere periode ved siden av for å se endringen. «Av» viser bare den valgte perioden.',
  'po.ongoingPeriod': 'Pågående periode — tallene er foreløpige',
  'po.plummaSummary': 'SuperPlummas oppsummering',
  'po.wentWell': 'Dette gikk bra',
  'po.canImprove': 'Dette kan forbedres',
  'po.focusNextMonth': 'Fokus neste måned:',
  'po.goDeeper': 'Vil du gå dypere? Spør meg om rapporten.',
  'po.plummaNoticed': 'SuperPlumma la merke til',
  'po.savingsRate': 'Sparerate',
  'po.noImportedCosts': 'Ingen importerte kostnader',
  'po.totalCosts': 'Sum kostnader',
  'po.whatHappensNext': 'Hva skjer videre?',
  'po.setAsideOver12': 'Lagt til side på 12 mnd',
  'po.averagePerMonth': 'Snitt per måned',
  'po.askWhatHappensNext': 'Spør meg hva som skjer videre',
  'po.whatFiguresMean': 'Hva tallene betyr',
  'po.youHaveStated': 'Du har oppgitt at',
  'po.howItLooksAhead': 'Slik ser det ut fremover',
  'po.inSixMonths': 'Om 6 måneder',
  'po.inTwelveMonths': 'Om 12 måneder',
  'po.assetCategoryPh': 'F.eks. Eiendom',
  'po.assetsAndWealth': 'Eiendeler og formue',
  'po.assetsAndWealthSub': 'Alt du eier samlet — bolig, kjøretøy, sparing og investeringer',
  'po.assetsHelp': 'Samlet verdi av det du eier, gjelden din, og nettoformuen (eiendeler minus gjeld). «Forventet verdiendring» summerer hvordan eiendelene ventes å stige eller falle i verdi i året.',
  'po.totalAssets': 'Samlede eiendeler',
  'po.netWealth': 'Nettoformue',
  'po.expectedChangePerYear': 'Forventet verdiendring per år',
  'po.liquid': 'Likvid (sparing og fond)',
  'po.assetCount': 'Antall eiendeler',
  'po.wealthHealth': 'Formuehelse',
  'po.wealthHealthSub': 'Helhetsvurdering av hvor robust formuen din er — diversifisering, likviditet, risiko og gjeldsgrad',
  'po.wealthStrongestOn': 'Formuen din scorer sterkest på',
  'po.wealthDistribution': 'Hvordan formuen din er fordelt på kategorier',
  'po.expectedDevelopment': 'Forventet utvikling',
  'po.expectedDevelopmentSub': 'Basert på verdiendringen du selv har lagt inn per eiendel',
  'po.projectionHelp': 'Fremskrivningen bruker den forventede årlige verdiendringen du har lagt inn på hver eiendel. Plumme henter ennå ikke inn eksterne markedsdata for bolig, bruktbil eller fond.',
  'po.withYourAssumptions': 'Med forutsetningene du har lagt inn, endrer formuen din seg med omtrent',
  'po.explainSimply': 'Forklar utviklingen enkelt',
  'po.watchingClosely': 'Følger ekstra nøye',
  'po.watchingCloselySub': 'Eiendelene som ventes å tape verdi eller vokse saktere enn inflasjonen',
  'po.explain': 'Forklar',
  'po.yourAssets': 'Dine eiendeler',
  'po.yourAssetsSub': 'Trykk på en eiendel for å redigere verdi og detaljer',
  'po.addAsset': 'Legg til eiendel',
  'po.askAboutTax': 'Spør meg om skatten',
  'po.taxAssistant': 'Skattemeldingsassistent',
  'po.taxAssistantSub': 'SuperPlumma guider deg steg for steg og tilpasser spørsmålene underveis',
  'po.deductionHunter': 'Fradragsjeger',
  'po.deductionHunterSub': 'Fradragene sorteres etter forventet verdi — start øverst der gevinsten er størst',
  'po.whyIThinkThis': 'Hvorfor mener jeg dette?',
  'po.dataIUsed': 'Data jeg har brukt',
  'po.whyYouQualify': 'Hvorfor du har krav på fradraget',
  'po.estimatedTaxBenefit': 'Estimert skattefordel',
  'po.taxOptimisation': 'Skatteoptimalisering',
  'po.taxOptimisationSub': 'Konkrete grep sortert etter frist — og hva de betyr for i år og til neste år',
  'po.nextYearOnwards': 'Neste år og framover',
  'po.aiTaxCheck': 'AI Skattekontroll',
  'po.aiTaxCheckSub': 'SuperPlumma går gjennom de importerte skatteopplysningene dine',
  'po.readyToFile': 'Klar for ekstern kontroll',
  'po.readyToFileSub': 'Sammenlign grunnlaget med skattemeldingen og årsoppgavene',
  'po.checkBasis': 'Kontrollgrunnlag',
  'po.requiresIntegration': 'Krever offisiell integrasjon, sterk autentisering og eksplisitt godkjenning',
  'po.filingUnavailable': 'Innsending ikke tilgjengelig',
  'po.whatIsMissing': 'Hva mangler før ekstern kontroll?',
  'po.whatRemains': 'Dette gjenstår',
  'po.taxBasisNotFetched': 'Skattegrunnlaget er ikke hentet inn',
  'po.alreadyVerified': 'Allerede kvalitetssikret',
  'po.nothingVerified': 'Ingenting er kvalitetssikret ennå.',

  // ------------------ Produkter, abonnement, rapporter, spesifikasjoner
  'spx.taxScheme': 'Skatte og avgiftsordning',
  'spx.noItems': 'Ingen poster registrert ennå.',
  'spx.removeSpec': 'Fjern spesifikasjon',
  'prd.import': 'Importer produkter',
  'prd.excel': 'Excel (.xlsx)',
  'prd.export': 'Eksporter produkter',
  'prd.csvName': 'Produkter CSV',
  'prd.excelName': 'Produkter Excel',
  'prd.countTemplateName': 'Tellemal for varetelling',
  'prd.countTemplateEmpty': 'Ingen varer å telle. Tellemalen tar med produkter av typen Vare.',
  'prd.countTemplateDone': 'Tellemal lastet ned. Fyll inn antall per 31.12., og husk at lageret verdsettes til innkjøpspris.',
  'prd.countTemplateError': 'Kunne ikke lage tellemalen.',
  'prd.colProductId': 'Produkt-ID',
  'prd.colInventoryAccount': 'Lagerkonto',
  'prd.colStockToday': 'Beholdning i dag',
  'prd.colCountedQuantity': 'Opptalt antall',
  'prd.colTotalCostValue': 'Total kostverdi',
  'prd.colNote': 'Merknad',
  'prd.countSheetTitle': 'Varetelling',
  'prd.countSheetIntro': 'Antall og varekost er forhåndsutfylt fra dagens produktregister. Kontroller og korriger mot faktisk telling på telledatoen.',
  'prd.countSheetDate': 'Telledato',
  'prd.countSheetCountedBy': 'Opptalt av',
  'prd.countSheetReference': 'Referanse',
  'prd.countSheetSignature': 'Signatur',
  'prd.countSheetNoteLabel': 'Merk',
  'prd.countSheetNote': 'Denne listen dokumenterer tellingen. Regnskapsverdi og skattemessig verdi vurderes i årsavslutningen.',
  'prd.countSheetInfoTab': 'Informasjon',
  'prd.countSheetWrongTemplate': 'Bruk tellemalen fra Plumme. Kolonnene stemmer ikke.',
  'prd.countSheetOnlyXlsx': 'Automatisk innlesing støtter Excel-malen (.xlsx). Andre filer lagres som dokumentasjon.',
  'prd.countSheetTabNotFound': 'Fant ikke arket {name}.',
  'prd.countSheetRowError': 'Rad {row}: Kontroller vare, lagerkonto, opptalt antall og varekost.',
  'prd.countSheetNoneCounted': 'Ingen utfylte antall ble funnet i tellelisten.',
  'prd.countSheetUnmappedAccount': 'Lagerkonto {account} kan ikke fordeles automatisk. Kontroller kontoene i gjennomgangen.',
  'prd.filterHelp': 'Filtrer produktene på type (vare, tjeneste, utleie), om de er på lager, og om slettede skal vises.',
  'prd.listTitle': 'Produktliste',
  'prd.listSub': 'Varer og tjenester du selger',
  'prd.new': 'Nytt produkt',
  'prd.searchPh': 'Søk på produktnavn, beskrivelse, varenummer eller pris',
  'prd.searchHelp': 'Søk på produktnavn, beskrivelse, varenummer eller pris.',
  'prd.none': 'Ingen produkter her ennå',
  'prd.listHelpTitle': 'Produktlisten',
  'prd.listHelp': 'Hver rad er ett produkt med varenr., pris, MVA-sats, type og lagerbeholdning. Trykk på en rad for å se detaljer og redigere.',
  'prd.detailsTitle': 'Produktdetaljer',
  'prd.detailsHelp': 'Beskrivelse, varenummer, pris eks. MVA, MVA-sats, type og lagerbeholdning for produktet.',
  'prd.editHelp': 'Endre navn, pris, MVA, type og lager for produktet.',
  'prd.delete': 'Slett produkt',
  'prd.deleteHelp': 'Flytt produktet til slettede. Du kan gjenopprette det senere.',
  'prd.itemNo': 'Varenr.',
  'prd.colStockItem': 'Vare',
  'prd.stockReasonDefault': 'Fysisk telling',
  'prd.stock': 'Lager',
  'prd.deleted': 'Slettet',
  'prd.pickOwnColour': 'Velg egen farge',
  'prd.namePh': 'F.eks. Konsulenttime',
  'prd.priceExVat': 'Pris eks. MVA', 'prd.price': 'Pris',
  'prd.priceIncVat': 'Pris inkl. MVA',
  'prd.subscriptionPeriod': 'Abonnementsperiode',
  'prd.multiDayDiscount': 'Flerdagsrabatt',
  'prd.multiDayHelp': 'Gjelder bare dette utleieproduktet.',
  'prd.day2ChargedAt': 'Dag 2 belastes med',
  'prd.day3Onwards': 'Dag 3 og videre',
  'prd.itemNumber': 'Varenummer',
  'prd.accountFallbackName': 'Konto',
  'prd.acct3000': 'Salg og uttak med mva-plikt',
  'prd.acct3020': 'Salgsinntekt tjenester, høy mva-sats',
  'prd.acct3030': 'Salgsinntekt varer, middels mva-sats',
  'prd.acct3050': 'Salgsinntekt varer, lav mva-sats',
  'prd.acct3100': 'Salg og uttak med 0 prosent mva.',
  'prd.acct3200': 'Salg og uttak utenfor mva-loven',
  'prd.acct3900': 'Andre driftsinntekter',
  'prd.colProductName': 'Produktnavn',
  'prd.colDescription': 'Beskrivelse',
  'prd.colVat': 'MVA',
  'prd.colType': 'Type',
  'prd.colRentalDiscount': 'Utleierabatt',
  'prd.colSalesAccount': 'Salgskonto',
  'prd.colEquivalentAccount': 'Tilsvarer standardkonto',
  'prd.excelImportUnavailable': 'Excel-import er ikke tilgjengelig ennå.',
  'prd.excelExportUnavailable': 'Excel-eksport er ikke tilgjengelig ennå.',
  'prd.colStatus': 'Status',
  'prd.exportSheetName': 'Produkter',
  'prd.typeHeading': 'Overskrift',
  'prd.typeTextLine': 'Tekstlinje',
  'prd.textLinesTitle': 'Tekstlinjer',
  'prd.newTextLine': 'Ny tekstlinje',
  'prd.updateTextLine': 'Oppdater tekstlinje',
  'prd.saveTextLine': 'Lagre tekstlinje',
  'prd.textLineNamePh': 'F.eks. Standard monteringstekst',
  'prd.textLineTextPh': 'Skriv teksten som skal kunne brukes på dokumentlinjer',
  'prd.styleFor': 'Stil for {target}',
  'prd.styleTargetText': 'Tekst',
  'prd.styleTargetName': 'Navn',
  'prd.styleBold': 'Fet',
  'prd.styleItalic': 'Kursiv',
  'prd.styleDivider': 'Skillelinje',
  'prd.styleNoDivider': 'Uten skillelinje',
  'prd.styleSummary': 'Navn: {name} · Tekst: {text} · {divider}',
  'prd.toastProductUpdated': 'Produkt oppdatert',
  'prd.toastProductSaved': 'Produkt lagret',
  'prd.toastProductSaveError': 'Kunne ikke lagre produktet.',
  'prd.toastProductDeleted': 'Produkt slettet',
  'prd.toastProductDeleteError': 'Kunne ikke slette produktet.',
  'prd.toastTextLineUpdated': 'Tekstlinje oppdatert',
  'prd.toastTextLineSaved': 'Tekstlinje lagret',
  'prd.toastTextLineSaveError': 'Kunne ikke lagre tekstlinjen.',
  'prd.toastTextLineDeleted': 'Tekstlinje slettet',
  'prd.toastTextLineDeleteError': 'Kunne ikke slette tekstlinjen.',
  'prd.toastImportNoneFound': 'Fant ingen produkter i filen.',
  'prd.toastImportSuccess': '{count} produkter importert',
  'prd.toastImportError': 'Kunne ikke importere produkter.',
  'prd.toastExportNone': 'Ingen produkter å eksportere',
  'prd.toastExportDone': 'Produktliste lastet ned',
  'prd.toastExportError': 'Kunne ikke eksportere produktlisten.',
  'prd.textLineFilterHelp': 'Filtrer lagrede tekstlinjer og overskrifter.',
  'prd.filterOther': 'Annet',
  'prd.showDeleted': 'Vis slettede',
  'prd.typeGoods': 'Vare',
  'prd.typeService': 'Tjeneste',
  'prd.typeRental': 'Utleie',
  'prd.typeSubscription': 'Abonnement',
  'prd.stockOnly': 'Kun på lager',
  'prd.textLineSubtitle': 'Lagrede tekster og overskrifter til salgsdokumenter',
  'prd.titleHelp': 'Produktene dine — varer og tjenester du selger, med pris, MVA og lager. Trykk på et produkt for detaljer.',
  'prd.uploadHelp': 'Importer produkter fra en fil.',
  'prd.downloadHelp': 'Last ned produktlisten som CSV eller Excel.',
  'prd.addHelp': 'Legg til en ny vare, tjeneste, abonnement eller utleieprodukt.',
  'prd.textLineSearchPh': 'Søk på navn, tekst eller type',
  'prd.textLineSearchHelp': 'Søk i lagrede tekstlinjer og overskrifter.',
  'prd.emptyText': 'Legg til varer og tjenester du selger, så går faktureringen lynraskt.',
  'prd.textLineEmptyTitle': 'Ingen tekstlinjer ennå',
  'prd.textLineEmptyText': 'Lagre faste tekster, overskrifter og produkttekster uten pris.',
  'prd.colBalance': 'Beholdning',
  'prd.colCostPerUnit': 'Varekost per enhet',
  'prd.colTotalValue': 'Totalverdi',
  'prd.colStockAvailable': 'Lager/tilgjengelig',
  'prd.noneShort': 'Ingen',
  'prd.subscriptionLabel': 'Abonnement · {period}',
  'prd.month1Short': '1 mnd',
  'prd.months12Short': '12 mnd',
  'prd.copyToTextLine': 'Kopier til tekstlinje',
  'prd.colProduct': 'Produkt',
  'prd.colPrice': 'Pris',
  'prd.colName': 'Navn',
  'prd.colStyle': 'Stil',
  'prd.errNrTaken': 'Varenummeret «{nr}» er allerede i bruk.',
  'prd.errAccountCodeFormat': 'Bruk en inntektskonto som starter på 3 og har 4 eller 5 siffer.',
  'prd.errAccountNameRequired': 'Gi kontoen et navn.',
  'prd.errAccountEquivalentRequired': 'Velg standardkontoen denne skal tilsvare.',
  'prd.errAccountExists': 'Konto {code} finnes allerede.',
  'prd.errCostPriceInvalid': 'Kostpris må være et gyldig beløp på minst 0.',
  'prd.errTrackingDateRequired': 'Velg datoen automatisk lagerstyring skal starte.',
  'prd.errStockNegative': 'Startbeholdningen kan ikke være negativ.',
  'prd.errCostPriceRequired': 'Legg inn kostpris for startbeholdningen.',
  'prd.errCostPriceNegative': 'Kostpris kan ikke være negativ.',
  'prd.noName': 'Uten navn',
  'prd.updateProduct': 'Oppdater produkt',
  'prd.saveProduct': 'Lagre produkt',
  'prd.rentalQtyLabel': 'Antall tilgjengelig for utleie',
  'prd.autoInventoryTitle': 'Automatisk lager og varekost',
  'prd.autoInventoryHelp': 'Innkjøp øker lageret. Bokførte salg reduserer lageret og fører beregnet varekost etter veid gjennomsnitt.',
  'prd.calculatedStock': 'Beregnet lagerbeholdning',
  'prd.openingStock': 'Startbeholdning',
  'prd.avgCostPrice': 'Gjennomsnittlig kostpris',
  'prd.costPerUnit': 'Kostpris per enhet',
  'prd.inventoryValueLine': 'Lagerverdi: {value}',
  'prd.month1': '1 måned',
  'prd.months12': '12 måneder',
  'prd.advancedTitle': 'Avansert produktdata',
  'prd.advancedHelp': 'SKU, EAN/GTIN, produktgruppe og importdata.',
  'prd.noGroup': 'Ingen gruppe',
  'prd.removeGroup': 'Fjern produktgruppe',
  'prd.newGroupPh': 'Ny produktgruppe',
  'prd.brand': 'Merke',
  'prd.variantName': 'Variantnavn',
  'prd.supplierItemNumber': 'Leverandørvarenr.',
  'prd.internalReference': 'Intern referanse',
  'prd.tags': 'Tags',
  'prd.tagsPh': 'F.eks. nettbutikk, reservedel, vinter',
  'prd.saveAsTextLineTitle': 'Lagre også som tekstlinje',
  'prd.saveAsTextLineHelp': 'Oppretter en kopi uten pris for dokumentlinjer.',
  'prd.autoAccountLine': 'Automatisk: {account}',
  'prd.accountTypeLabel': 'Type konto',
  'prd.selectAccount': 'Velg konto',
  'prd.customAccountOption': 'Egendefinert',
  'prd.accountInLedger': 'Konto i regnskapet',
  'prd.accountNamePh': 'Gjennomfakturering',
  'prd.equivalentForYearEnd': 'Tilsvarer for årsregnskap/skatt',
  'prd.selectStandardAccount': 'Velg standardkonto',
  'sub.tabsHelp': 'Bytt mellom abonnementer med repeterende fakturering og kundelister for samlet fakturering eller e-post.',
  'sub.start': 'Start',
  'sub.end': 'Slutt',
  'sub.endHelp': 'La stå tom for å fortsette til abonnementet pauses eller slettes.',
  'sub.internalComment': 'Intern kommentar',
  'sub.saveCustomers': 'Lagre kunder',
  'sub.searchCustomers': 'Søk kunder',
  'sub.searchCustomersPh': 'Søk etter navn, e-post eller org.nr...',
  'sub.selectVisible': 'Velg synlige',
  'sub.deselectVisible': 'Fjern synlige',
  'sub.noCustomers': 'Ingen kunder enda',
  'sub.howToInvoice': 'Hvordan vil du fakturere?',
  'sub.manualFlowNote': 'Valget under starter en manuell fakturaflyt for abonnementet.',
  'sub.sendInvoice': 'Send faktura',
  'sub.openDraftFilled': 'Åpne et fakturautkast med abonnementet ferdig utfylt.',
  'sub.openBlankDraft': 'Åpne et blankt fakturautkast med kundemassen valgt.',
  'sub.subject': 'Emne',
  'sub.message': 'Melding',
  'sub.removeAllAttachments': 'Fjern alle vedlegg',
  'sub.addCustomers': 'Legg til kunder',
  'sub.noInvoiceSent': 'Ingen faktura sendt',
  'sub.noEmailSent': 'Ingen e-post sendt',
  'sub.unknownCustomer': 'Ukjent kunde',
  'sub.customersCount': '{count} kunder',
  'sub.cpiAnnualSuffix': ' · KPI {rate} % årlig',
  'sub.actionMenuLabel': 'Handling',
  'sub.nameRequiredSubscription': 'Gi abonnementet et navn',
  'sub.nameRequiredList': 'Gi listen et navn',
  'sub.nameRequiredListError': 'Gi listen et navn.',
  'sub.nameRequiredAgreementError': 'Gi avtalen et navn.',
  'sub.editSubTitle': 'Rediger abonnement',
  'sub.editListTitle': 'Rediger liste',
  'sub.newSubTitle': 'Nytt abonnement',
  'sub.newListTitle': 'Ny liste',
  'sub.saveChanges': 'Lagre endringer',
  'sub.saveSubscription': 'Lagre abonnement',
  'sub.saveList': 'Lagre liste',
  'sub.namePlaceholderSub': 'F.eks. Gullmedlemskap',
  'sub.namePlaceholderList': 'F.eks. Nyhetsbrev',
  'sub.nextInvoiceDateLabel': 'Neste fakturadato',
  'sub.cpiAdjustmentLabel': 'KPI-justering',
  'sub.cpiAdjustmentHelp': 'Årlig konsumprisjustering av abonnementsprisen.',
  'sub.customerSavedToast': 'Kunde "{name}" lagret',
  'sub.saveCustomerError': 'Kunne ikke lagre kunden.',
  'sub.addCustomersTitle': 'Legg til kunder · {name}',
  'sub.selectedCount': '{count} valgt',
  'sub.addAsNewCustomer': 'Legg til «{name}» som ny kunde',
  'sub.noContactInfo': 'Ingen kontaktinfo',
  'sub.addCustomersEmptyText': 'Legg til kunder i kunderegisteret først, eller skriv et navn for å opprette en ny kunde.',
  'sub.sendInvoiceTitle': 'Send faktura · {name}',
  'sub.attachmentTooLarge': 'Vedlegg kan maks være {max}.',
  'sub.fillSubject': 'Fyll inn emne.',
  'sub.writeMessage': 'Skriv en melding.',
  'sub.sendEmailTitle': 'Send e-post · {name}',
  'sub.sending': 'Sender...',
  'sub.sendEmailButton': 'Send e-post',
  'sub.readyCount': '{count} klare',
  'sub.attachmentsAddedCount': '{count} vedlegg lagt til',
  'sub.addAttachment': 'Legg til vedlegg',
  'sub.emailSendNote': 'E-post sendes via backend. Du kan slippe filer hvor som helst i dialogen eller lime inn med Ctrl+V. Mottakere uten e-postadresse logges som ikke sendt.',
  'sub.typeSubscription': 'Abonnement',
  'sub.typeList': 'Liste',
  'sub.actionClose': 'Lukk',
  'sub.actionOpen': 'Åpne',
  'sub.edit': 'Rediger',
  'sub.emailLabel': 'E-post',
  'sub.resume': 'Gjenoppta',
  'sub.pause': 'Pause',
  'sub.delete': 'Slett',
  'sub.tabCustomers': 'Kunder ({count})',
  'sub.tabInvoices': 'Faktura ({count})',
  'sub.tabEmails': 'E-post ({count})',
  'sub.addCustomersToInvoiceText': 'Legg til kunder for å fakturere dem.',
  'sub.removeMember': 'Fjern',
  'sub.noInvoiceSentText': 'Fakturaer du sender fra dette abonnementet vises her.',
  'sub.invoiceRunFallback': 'Fakturarunde',
  'sub.statusSaved': 'lagret',
  'sub.noEmailSentText': 'E-poster du sender til kundene vises her.',
  'sub.emailLogFallback': 'E-postlogg',
  'sub.recipientsCount': '{count} mottakere',
  'sub.changesSaved': 'Endringer lagret',
  'sub.listCreated': 'Liste opprettet',
  'sub.subscriptionCreated': 'Abonnement opprettet',
  'sub.saveError': 'Kunne ikke lagre.',
  'sub.customersSaved': 'Kunder lagret',
  'sub.saveCustomersError': 'Kunne ikke lagre kunder.',
  'sub.agreementResumed': 'Avtalen er aktiv igjen',
  'sub.agreementPaused': 'Avtalen er pauset',
  'sub.updateAgreementError': 'Kunne ikke oppdatere avtalen.',
  'sub.listDeleted': 'Listen ble slettet',
  'sub.subscriptionDeleted': 'Abonnementet ble slettet',
  'sub.deleteError': 'Kunne ikke slette.',
  'sub.emailsSentToast': '{count} e-post sendt',
  'sub.emailsSentFailedSuffix': ', {count} ikke sendt',
  'sub.sendEmailError': 'Kunne ikke sende e-post.',
  'sub.searchSubPlaceholder': 'Søk etter abonnement, kunde eller beløp...',
  'sub.searchListPlaceholder': 'Søk etter liste eller kunde...',
  'sub.emptySubTitle': 'Ingen abonnement enda',
  'sub.emptyListTitle': 'Ingen lister enda',
  'sub.emptySubText': 'Opprett ditt første abonnement for å fakturere kunder jevnlig.',
  'sub.emptyListText': 'Opprett din første kundeliste.',
  'sub.preservedSubscriptionsNotice': '{count} eldre kundeabonnement er bevart i app-state og kan migreres senere.',
  'agreements.customer': 'Kunde',
  'agreements.tab.subscriptions': 'Abonnement',
  'agreements.tab.recurring': 'Repeterende',
  'agreements.tab.lists': 'Lister',
  'agreements.unknownCustomer': 'Ukjent kunde',
  'agreements.recurringInvoice': 'Repeterende faktura',
  'agreements.lastSent': 'Sist sendt',
  'agreements.nextDelivery': 'Neste utsending',
  'agreements.net': 'Netto',
  'agreements.amount': 'Beløp',
  'agreements.total': 'Totalt',
  'agreements.status': 'Status',
  'agreements.status.active': 'Aktiv',
  'agreements.status.paused': 'Pauset',
  'agreements.status.ended': 'Avsluttet',
  'agreements.status.failed': 'Feilet',
  'agreements.pause': 'Pause',
  'agreements.resume': 'Gjenoppta',
  'agreements.interval': 'Intervall',
  'agreements.interval.weekly': 'Ukentlig',
  'agreements.interval.fourteen_days': 'Hver 14. dag',
  'agreements.interval.monthly': 'Månedlig',
  'agreements.interval.quarterly': 'Kvartalsvis',
  'agreements.interval.semiannual': 'Halvårlig',
  'agreements.interval.annual': 'Årlig',
  'agreements.paymentTerms': 'Betalingsfrist',
  'agreements.days': '{count} dager',
  'agreements.units': 'stk.',
  'agreements.invoiceLine': 'Fakturalinje',
  'agreements.deliveries': 'Utsendelser',
  'agreements.noDeliveries': 'Ingen automatiske utsendelser ennå.',
  'agreements.invoice': 'Faktura',
  'agreements.sent': 'Sendt',
  'agreements.processing': 'Behandles',
  'agreements.emptyTitle': 'Ingen repeterende fakturaer',
  'agreements.emptyText': 'Slå på Repeterende når du oppretter en faktura. Serien vises her og kan pauses når som helst.',
  'agreements.autoSend': 'Automatisk utsending',
  'agreements.autoSendHelp': 'Plumme oppretter og sender faktura på neste fakturadato. Kan pauses fra Avtaler.',
  'agreements.newRecurring': 'Ny repeterende',
  'agreements.newRecurringTitle': 'Ny repeterende faktura',
  'agreements.searchRecurring': 'Søk etter kunde, avtale eller beløp...',
  'agreements.sortBy': 'Sorter etter {column}',
  'rep.help': 'Hjelp',
  'rep.excel': 'Excel',
  'rep.allAccountsSub': 'Alle konti i kontoplanen for valgt periode.',
  'rep.openingChangeClosing': 'Inngående / Endring / Utgående',
  'rep.balanceModeHelp': 'Velg hvilken saldo som vises. Inngående er saldoen ved starten av perioden, Endring er bevegelsen i perioden, og Utgående er saldoen ved slutten. Utgående = inngående + endring.',
  'rep.groupsHelp': 'Kontoene er delt i grupper etter første siffer: eiendeler (1xxx), egenkapital og gjeld (2xxx), inntekter (3xxx) og kostnader (4xxx–7xxx). Trykk for å skjule eller vise gruppen.',
  'rep.displayHelp': 'Vis konto slår kontonummeret av eller på foran hver linje. Vis som velger om beløpene vises i kroner og øre, hele kroner eller hele tusen.',
  'rep.showAccount': 'Vis konto',
  'rep.showAs': 'Vis som',
  'rep.operatingIncomeHelp': 'Summen av det foretaket har tjent på ordinær drift i valgt periode.',
  'rep.operatingCostHelp': 'Summen av kostnadene ved å drive virksomheten i valgt periode.',
  'rep.resultHelp': 'Driftsinntekter minus driftskostnader og finansposter. Positivt tall er overskudd, negativt er underskudd.',
  'rep.groupHelp': 'En hovedgruppe i resultatregnskapet. Trykk for å åpne eller lukke gruppen og se kontoene bak summen.',
  'rep.noLedgerLines': 'Ingen hovedbokslinjer tilgjengelig fra backend.',

  // ---------------------- Onboarding, bankmodaler, sok, hjelpemodus
  'bwf.fixPostedEntry': 'Korriger postering',
  'bwf.createsDiscrepancy': 'Skaper avvik',
  'bwf.entry': 'Postering',
  'bwf.whatToDo': 'Hva vil du gjøre?',
  'bwf.correctPostedAmount': 'Riktig bokført beløp',
  'bwf.correctDate': 'Riktig dato',
  'bwf.postedEntry': 'Bokført post',
  'bwf.matched': 'Matchet',
  'bwf.plummaLinks': 'SuperPlumma kobler',
  'bwf.searchInbox': 'Søk på bilag eller beløp…',
  'bwf.clickForPreview': 'Klikk for forhåndsvisning, eller dra bilaget til en banklinje',
  'bwf.tapToPick': 'Trykk for å velge bilaget, og trykk deretter på banklinjen',
  'bwf.tapHint': 'Trykk på et bilag · velg deretter banklinjen det hører til',
  'bwf.pickedVoucher': 'Valgt bilag',
  'bwf.pickTapLine': 'Trykk på banklinjen bilaget hører til.',
  'bwf.cancelPick': 'Avbryt',
  'bwf.pickChooseLine': 'Velg banklinjen bilaget hører til',
  'bwf.possibleMatch': 'Mulig match',
  'bwf.previewVoucher': 'Forhåndsvis bilag',
  'bwf.annulEntry': 'Annuller posteringen',
  'bwf.correctEntry': 'Korriger postering',
  'bwf.account': 'Konto',
  'bwf.missing': 'mangler',
  'bwf.searchAccount': 'Søk konto …',
  'bwf.noAccountHits': 'Ingen treff',
  'bwf.selectedLines': 'linjer valgt',
  'bwf.selectedLinesHelp': 'Velg hva som skal gjøres med de valgte linjene.',
  'bwf.clearSelection': 'Fjern valg',
  'bwf.bulkProcessing': 'Behandler linje {{index}} av {{total}}',
  'bwf.andNext': 'og neste',
  'bwf.andLast': 'siste',
  'bwf.openInbox': 'Åpne innboksen',
  'bwf.drawerHint': 'Trykk på et bilag og deretter på banklinjen — eller dra det ut på linjen.',
  'bwf.selectLine': 'Velg banklinje',
  'bwf.selectLineHelp': 'Merk banklinjer for å behandle flere samtidig. Shift-klikk merker et intervall. Fargen viser fortsatt status på linjen.',
  'onb.getStartedTitle': 'Kom i gang med Plumme',
  'onb.getStarted': 'Kom i gang',
  'onb.whatCreate': 'Hva vil du opprette?',
  'onb.whatCreateHelp': 'Velg hva du vil sette opp nå. Du kan alltids legge til mer senere.',
  'onb.registerCompany': 'Registrer et selskap for fakturering, bokføring og MVA.',
  'onb.backendComing': 'Egen backend-modell kommer før denne kan aktiveres.',
  'onb.createPersonal': 'Opprett din private økonomi',
  'onb.createPersonalHelp': 'Dette lager en egen privatøkonomi-bruker som du finner fra Min side og brukervelgeren.',
  'onb.welcome': 'Velkommen',
  'onb.letsSetUp': 'La oss sette opp foretaket ditt',
  'onb.tellUsAbout': 'Fortell oss om foretaket',
  'onb.signedIn': 'Innlogget',
  'onb.sweden': 'Sverige',
  'onb.denmark': 'Danmark',
  'onb.companyNamePh': 'F.eks. Joda Consulting AS',
  'onb.nineDigits': '9 siffer',
  'onb.resetAndSearch': 'Nullstill og søk på nytt',
  'onb.checkingExisting': 'Sjekker om foretaket allerede finnes i Plumme...',
  'onb.searchingRegistry': 'Søker i Brønnøysundregistrene...',
  'onb.companyForm': 'Foretaksform',
  'onb.searchingAddress': 'Søker etter adresse...',
  'onb.oslo': 'Oslo',
  'onb.whichPages': 'Hvilke sider vil du bruke?',
  'onb.menuNotLoaded': 'Sidemenyen er ikke lastet ennå. Alle standard sider blir synlige.',
  'onb.bankLater': 'Bankkobling kommer senere',
  'onb.connectWith': 'Koble til med',
  'onb.noBankData': 'Bankkobling er ikke aktiv ennå. Du kan laste opp kontoutskrifter manuelt når du ønsker det.',
  'onb.allSet': 'Alt klart',
  'onb.allSetHelp': 'Foretaket er opprettet i backend, lagt til i dine virksomheter og valgt som aktivt foretak.',
  'onb.goToPlumme': 'Gå til Plumme',
  'air.sub': 'Se, sammenlign, skriv ut og last ned måneds- og årsrapporter for bedriften',
  'air.help': 'Her lager du måneds- og årsrapporter for bedriften. Velg periode og eventuelt et år å sammenligne med, så oppdateres nøkkeltallene, grafen og kostnadstabellen automatisk. Du kan skrive ut rapporten eller laste den ned som PDF.',
  'air.downloadPdf': 'Last ned PDF',
  'air.chooseWhatToShow': 'Velg hva rapporten skal vise',
  'air.chooseHelp': '«Visning» bytter mellom én måned og hele året. «År» velger hvilket år du ser på. «Sammenlign med» legger et tidligere år ved siden av, slik at alle tall også viser endringen mot samme periode det året.',
  'air.keyFigures': 'Nøkkeltall for perioden',
  'air.keyFiguresHelp': 'De fire viktigste tallene for valgt periode: inntekt, kostnader, resultat (inntekt minus kostnader) og resultatmargin (resultat i prosent av inntekten). Er sammenligning slått på, viser pilen og teksten under hvert tall endringen mot året før.',
  'air.profitMargin': 'Resultatmargin',
  'air.chartHelp': 'Søylediagrammet viser inntekt (grønn) og kostnad (lilla) for hver måned i året, slik at du raskt ser sesongsvingninger og måneder der kostnadene nærmer seg inntektene. I månedsvisning fremheves måneden du har valgt.',
  'air.costsByCategory': 'Kostnader fordelt på kategori',
  'air.costsByCategoryHelp': 'Tabellen bryter de samlede kostnadene ned på kategori — lønn, husleie, markedsføring og så videre. Er sammenligning slått på, ser du fjorårets tall og endringen i prosent, der rødt betyr økte kostnader og grønt betyr lavere.',
  'air.costCategory': 'Kostnadskategori',
  'pdf.cannotShow': 'Kan ikke vise PDF her',
  'pdf.browserBlocked': 'Nettleseren blokkerte visningen.',
  'pdf.rotate': 'Roter',
  'tf.subsistenceQuestion': 'Skal det beregnes diett på denne reisen?',
  'tf.accommodationQuestion': 'Hadde du overnatting på denne reisen?',
  'tf.pickEmployee': 'Velg ansatt',
  'tf.timeFrom': 'Tidspunkt fra',
  'tf.timeTo': 'Tidspunkt til',
  'tf.mealsCovered': 'Hvilke måltider var dekket av andre?',
  'hh.household': 'Husholdning',
  'hh.help': 'Koble sammen to separate Privatøkonomi-kontoer. Egne kontoer og transaksjoner forblir private; bare opplysninger som lagres på Familie deles.',
  'hh.privacyNote': 'Private kontoer, transaksjoner, skatt og personlige planer deles ikke automatisk.',
  'hh.partnerEmail': 'Partnerens e-post',
  'hh.partnerEmailPh': 'partner@epost.no',
  'hh.invitesForYou': 'Invitasjoner til deg',
  'hh.wantsToLink': 'Vil koble Privatøkonomi-kontoene som en husholdning',
  'hh.decline': 'Avslå',
  'hh.accept': 'Godta',
  'hh.pendingInvites': 'Ventende invitasjoner',
  'hh.awaitingReply': 'Venter på svar',
  'srch.placeholder': 'Søk i kunder, fakturaer, produkter, bilag, prosjekter …',
  'srch.esc': 'esc',
  'srch.recent': 'Siste søk',
  'srch.noMatches': 'Ingen treff på «{query}».',
  'srch.tryPageName': 'Prøv et navn, nummer, beløp, sidenavn eller hjelpe-emne.',
  'srch.group.customers': 'Kunder', 'srch.group.suppliers': 'Leverandører', 'srch.group.products': 'Produkter',
  'srch.group.sales': 'Salg og fakturaer', 'srch.group.vouchers': 'Kjøp og bilag', 'srch.group.documents': 'Dokumenter og innboks',
  'srch.group.projects': 'Prosjekter og timer', 'srch.group.other': 'Annet i regnskapet',
  'srch.tag.customer': 'Kunde', 'srch.tag.supplier': 'Leverandør', 'srch.tag.product': 'Produkt', 'srch.tag.invoice': 'Salgsdokument',
  'srch.tag.expense': 'Kjøp', 'srch.tag.other-sale': 'Annet salg', 'srch.tag.receipt': 'Innboks', 'srch.tag.project': 'Prosjekt',
  'srch.tag.activity': 'Aktivitet', 'srch.tag.mileage': 'Kjørebok', 'srch.tag.agreement': 'Avtale', 'srch.tag.company-document': 'Dokument',
  'srch.tag.bank-statement': 'Bankutskrift',
  'srch.recentDefaults': 'faktura|lønn|MVA',
  'srch.group.shortcuts': 'Snarveier',
  'srch.nav.sub': 'Side i Plumme',
  'srch.help.sub': 'Hjelpeartikkel',
  'srch.hint.browse': 'bla', 'srch.hint.open': 'åpne', 'srch.hint.close': 'lukk',
  'srch.countShown': '{count} treff vist',
  'srch.fallback.trip': 'Kjøretur',
  'srch.kind.offer': 'Tilbud', 'srch.kind.invoice': 'Faktura', 'srch.kind.invoiceDraft': 'Fakturautkast',
  'srch.kind.orderConfirmation': 'Ordrebekreftelse', 'srch.kind.sale': 'Salg', 'srch.kind.customerList': 'Kundeliste',
  'hlp.explainMode': 'Forklar meg – trykk, så trykk på det du lurer på (snarvei: ? eller Ctrl+I)',
  'hlp.helpModeOn': 'Hjelpemodus er på.',
  'hlp.tapWhatever': 'Trykk på det du lurer på, så forklarer vi det.',
  'hlp.shortcutHint': 'Trykk ? eller Ctrl+I for å slå av/på.',
  'hlp.exit': 'Avslutt',

  // ------------------------------------ Data-fanen i innstillinger
  'sd.deleteAllCustomers': 'Slett alle kunder',
  'sd.deleteAllSuppliers': 'Slett alle leverandører',
  'sd.deleteAllProducts': 'Slett alle produkter',
  'sd.exportLedger': 'Eksporter hovedbok',
  'sd.importLedger': 'Importer hovedbok',
  'sd.exportDetails': 'Eksporter detaljer',
  'sd.importDetails': 'Importer detaljer',
  'sd.exportVouchers': 'Eksporter bilag',
  'sd.importVouchers': 'Importer bilag',
  'sd.deleteBusinessHelp': 'Slett foretak fjerner valgt foretak etter 30 dager via backend. Dette er en alvorlig handling.',
  'sd.permissionsHelp': 'Bare eier eller admin kan nullstille data og tømme registre. Bare eier kan slette foretaket.',

  // ------------------------------------------ Hjelpeartikler (h6, h12, h13)
  'ha.h6.title': 'Slik leverer du MVA-meldingen',
  'ha.cat.vat': 'MVA og avgift',
  'ha.read3': '3 min å lese',
  'ha.h6.lead': 'MVA-meldingen viser hvor mye merverdiavgift bedriften har krevd inn på salg og betalt på kjøp i en termin. Plumme regner ut tallene automatisk fra bokførte bilag — du kontrollerer dem, og leverer meldingen hos Skatteetaten. Slik gjør du det.',
  'ha.h6.before': 'Før du begynner',
  'ha.h6.beforeText': 'Sørg for at alle kjøp og salg i terminen er bokført, og at innboksen er tom. Tallene i meldingen hentes rett fra regnskapet, så det som ikke er ført, kommer heller ikke med på meldingen.',
  'ha.h6.reminded': 'Du blir varslet i god tid',
  'ha.h6.remindedText': 'Plumme minner deg på fristen automatisk. Du finner alltid neste frist på forsiden og under Innleveringer.',
  'ha.h6.openPeriod': 'Åpne riktig termin',
  'ha.h6.openPeriodText': 'Gå til Innleveringer → MVA-melding. Terminene som krever handling ligger øverst. Trykk «Åpne melding» på terminen du skal levere.',
  'ha.h6.fig1': 'Terminer-oversikten. «3. termin 2026» krever handling og har frist 31. august.',
  'ha.h6.check': 'Kontroller beregningen',
  'ha.h6.checkText': 'Øverst ser du utgående MVA (det du har krevd inn på salg) minus inngående MVA (det du har betalt på kjøp). Differansen er enten å betale eller til gode. I dette eksempelet er 49 834 kr til gode.',
  'ha.h6.fig2': 'Utgående minus inngående MVA gir beløpet du skal betale eller få tilbake.',
  'ha.h6.codes': 'Gå gjennom kodeoversikten',
  'ha.h6.codesText': 'Kodeoversikten viser hvordan grunnlaget fordeler seg på de ulike MVA-kodene — salg, kjøp og innførsel. Trykk på en kode for å se hvilke bilag som ligger bak tallet. Stemmer alt, trykker du «Kontroller tallene».',
  'ha.h6.fig3': 'Hver linje viser grunnlag, sats og MVA per kode. Trykk en kode for å se bilagene bak.',
  'ha.h6.deviation': 'Sjekk avvik før du sender',
  'ha.h6.deviationText': 'Får du et beløp du ikke kjenner igjen, bør du gå gjennom bokføringen før innsending. Det er enklere å rette opp før meldingen er sendt enn etterpå.',
  'ha.h6.send': 'Lever meldingen hos Skatteetaten',
  'ha.h6.sendText': 'Plumme kan ikke sende MVA-meldingen til Skatteetaten. Før inn tallene fra Plumme og lever meldingen i Skatteetatens tjeneste, og ta vare på kvitteringen. Gå så tilbake til terminen i Plumme og trykk «Marker som levert utenfor Plumme». Legg inn datoen du leverte og gjerne referansen fra kvitteringen. Da låses bilagene i terminen, og terminen teller som levert i årsavslutningen.',
  'ha.h6.after': 'Etter innlevering',
  'ha.h6.afterText': 'Skal du betale, finner du KID og kontonummer på kvitteringen fra Skatteetaten. Når terminen er markert som levert utenfor Plumme og beløpet er betalt eller tilbakebetalt, registrerer du oppgjøret på terminen med «Registrer betaling» eller «Registrer tilbakebetaling», så stemmer regnskapet med skattekontoen.',
  'ha.h12.title': 'Slik lager du en faktura',
  'ha.cat.sales': 'Salg og faktura',
  'ha.h12.lead': 'Med Nytt salg lager du en faktura til en kunde på noen få steg. Du velger kunde, fyller inn linjene, og ser en levende forhåndsvisning før du oppretter og sender. Salget bokføres automatisk.',
  'ha.h12.beforeText': 'Det er en fordel å ha kunden og produktene lagret fra før, men du kan også skrive inn både mottaker og linjer som fritekst underveis. Alt kan endres før du oppretter fakturaen.',
  'ha.h12.open': 'Åpne Nytt salg og velg faktura',
  'ha.h12.openText': 'Gå til Nytt salg i menyen. Øverst velger du dokumenttype — velg «Faktura». Du kan også lage tilbud eller ordrebekreftelse herfra.',
  'ha.h12.quoteOrder': 'Tilbud og ordrebekreftelse',
  'ha.h12.quoteOrderText': 'Samme fremgangsmåte gjelder for tilbud og ordrebekreftelse — velg bare riktig type i «Ny faktura»-menyen øverst, så er stegene og feltene de samme. «Annet salg» er litt annerledes: der laster du opp et bilag som dokumentasjon i stedet for å velge kunde.',
  'ha.h12.customerText': 'I steget «Kunde» søker du opp en lagret kunde, liste eller abonnement — eller trykk «Ny kunde» for å skrive inn en mottaker som ikke er lagret. Navn og adresse hentes automatisk inn på dokumentet.',
  'ha.h12.fig1': 'Steg 1 «Kunde»: søk opp en lagret kunde, liste eller abonnement — eller opprett en ny mottaker.',
  'ha.h12.details': 'Fyll inn detaljer',
  'ha.h12.detailsText': 'Under «Detaljer» setter du fakturadato og forfallsdato, og eventuelle referanser. Vil du at fakturaen skal sendes automatisk hver periode, slår du på «Repeterende».',
  'ha.h12.fig2': 'Steg 2 «Detaljer»: fakturadato, forfallsdato og referanser. Slå på «Repeterende» for automatisk utsending.',
  'ha.h12.lines': 'Legg til linjer',
  'ha.h12.linesText': 'I steget «Linjer» legger du til det du selger. Velg et lagret produkt eller skriv fritekst, og angi antall, pris og MVA-sats. Linjesummen regnes ut automatisk.',
  'ha.h12.fig3': 'Steg 3 «Linjer»: hver linje har antall, pris og MVA-sats. Linjesum og totalsum regnes ut for deg.',
  'ha.h12.livePreview': 'Levende forhåndsvisning',
  'ha.h12.livePreviewText': 'Ved siden av skjemaet ser du hele tiden hvordan det ferdige dokumentet blir for kunden. Bruk «Bytt til alt på en side» hvis du heller vil se alle feltene samtidig.',
  'ha.h12.preview': 'Forhåndsvis og opprett',
  'ha.h12.previewText': 'I «Forhåndsvisning» kontrollerer du avsender, kundeinfo, linjer og totalsum. Stemmer alt, oppretter du fakturaen — og kan sende den til kunden på e-post eller laste den ned som PDF.',
  'ha.h12.fig4': 'Steg 4 «Forhåndsvisning»: kontroller dokumentet og totalsummen før du oppretter fakturaen.',
  'ha.h12.afterText': 'Når fakturaen er opprettet, bokføres salget automatisk på riktig konto, og du finner den igjen i Fakturalisten med status og forfall.',
  'ha.h13.title': 'Registrere annet salg',
  'ha.read2': '2 min å lese',
  'ha.h13.lead': 'Annet salg er for salg som ikke trenger en vanlig faktura — som kontantsalg, uttak eller salg gjort utenfor Plumme. Du velger «Annet salg» i Nytt salg, laster opp et bilag som dokumentasjon, fyller inn beløp og MVA, og velger hvor pengene kom inn. Salget bokføres automatisk.',
  'ha.h13.when': 'Når bruker du annet salg?',
  'ha.h13.whenText': 'Bruk annet salg når du ikke skal sende en faktura til en kunde — for eksempel kontantsalg, privat uttak av varer, eller et salg som allerede er gjort utenfor systemet og bare skal bokføres. Skal kunden faktureres, lager du en faktura i stedet.',
  'ha.h13.choose': 'Velg Annet salg',
  'ha.h13.chooseText': 'Gå til Nytt salg og velg «Annet salg» i dokumenttype-menyen øverst. Flyten får da et eget «Bilag»-steg først.',
  'ha.h13.receiptText': 'I «Bilag»-steget laster du opp et bilde eller en PDF som dokumentasjon på salget — for eksempel en kvittering eller et salgsnotat.',
  'ha.h13.details': 'Fyll inn detaljer og «Betalt til»',
  'ha.h13.detailsText': 'Under «Detaljer» setter du dato, og velger «Betalt til» — hvor pengene kom inn: Driftskonto, Kontant eller Privat. Valget styrer hvilken konto salget bokføres mot (bank, kasse eller privatuttak).',
  'ha.h13.fig1': 'I «Detaljer» velger du «Betalt til» — Driftskonto, Kontant eller Privat. Det avgjør hvilken konto salget bokføres mot.',
  'ha.h13.linesText': 'I «Linjer» legger du til det du solgte, med antall, pris og MVA-sats. Sum og MVA regnes ut automatisk.',
  'ha.h13.fig2': 'Legg til salgslinjer med beløp og MVA-sats. Summen regnes ut for deg.',
  'ha.h13.register': 'Registrer salget',
  'ha.h13.registerText': 'Kontroller oppsummeringen og trykk «Registrer salg». Salget bokføres, og bilaget arkiveres under Transaksjoner.',
  'ha.h13.invoiceOrOther': 'Faktura eller annet salg?',
  'ha.h13.invoiceOrOtherText': 'Skal du kreve betaling fra en kunde, lag en faktura (Nytt salg → Faktura). Annet salg er for salg som allerede er oppgjort eller ikke trenger et betalingskrav.',

  // ------------------------------------------ Hjelpeartikler (h1, h2, h4)
  'ha.h1.title': 'Lage en repeterende faktura',
  'ha.h1.lead': 'En repeterende faktura sendes automatisk med jevne mellomrom — perfekt for abonnement og faste tjenester. Du setter den opp én gang, så tar Plumme resten.',
  'ha.h1.start': 'Start en ny faktura',
  'ha.h1.startText': 'Gå til Nytt salg og fyll ut kunde og fakturalinjer som vanlig.',
  'ha.h1.turnOn': 'Slå på «Repeterende»',
  'ha.h1.turnOnText': 'Under Detaljer skrur du på «Repeterende». Velg hvor ofte fakturaen skal sendes (hver uke, hver 14. dag, måned, kvartal eller år) og når den forfaller.',
  'ha.h1.fig1': 'Slå på «Repeterende» i Detaljer-steget. Da velger du «Sendes hver» (intervall) og «Forfall».',
  'ha.h1.autoText': 'Plumme lager og sender en ny faktura på e-post automatisk hver periode. Under Avtaler → Repeterende ser du når neste faktura sendes, og kan pause og gjenoppta den.',
  'ha.h1.control': 'Pause i tide',
  'ha.h1.controlText': 'Fakturaen sendes uten varsel på forhånd. Har noe endret seg, pauser du den under Avtaler → Repeterende før fakturadatoen. Kunden må ha e-postadresse, ellers sendes ingen faktura.',
  'ha.h2.title': 'Betalingen stemmer ikke med fakturaen',
  'ha.h2.lead': 'Når et innbetalt beløp er ulikt fakturabeløpet, registrerer du beløpet som faktisk er kommet inn — så holder Plumme styr på hva som gjenstår.',
  'ha.h2.open': 'Åpne fakturaen',
  'ha.h2.openText': 'Finn fakturaen i Fakturalisten og åpne den. Under «Betalingsstatus» ser du om den er betalt, delvis betalt eller ikke betalt.',
  'ha.h2.fig1': '«Betalingsstatus» på fakturaen: hva som er betalt, hva som gjenstår, og «Registrer betaling»-knappen.',
  'ha.h2.registerText': 'Trykk «Registrer betaling» og legg inn beløpet som er kommet inn. Er beløpet mindre enn fakturaen, blir den stående som «Delvis betalt», og gjenstående beløp vises.',
  'ha.h2.fig2': 'I «Registrer betaling» legger du inn beløpet som er kommet inn. Gjenstående vises, og «Oppgjort uten betaling» avslutter resten uten innbetaling.',
  'ha.h2.handle': 'Håndter det som gjenstår',
  'ha.h2.handleText': 'Kommer resten senere, registrerer du en ny betaling da. Skal du avslutte fakturaen uten at resten betales, velger du «Oppgjort uten betaling». En registrert betaling kan reverseres, og hele betalingen kan nullstilles om du har ført feil.',
  'ha.h2.autoStatus': 'Status beregnes automatisk',
  'ha.h2.autoStatusText': 'Betalt / delvis betalt / ikke betalt regnes ut fra de registrerte betalingene mot fakturabeløpet — du trenger ikke sette status selv.',
  'ha.cat.payroll': 'Lønn og ansatte',

  // ------------------------------------------ Hjelpeartikler (h5, h7, h8)
  'ha.cat.purchase': 'Kjøp og bilag',
  'ha.cat.bank': 'Bank og betaling',

  // ------------------------------------------ Hjelpeartikler (h9, h10, h11)
  'ha.cat.assets': 'Eiendeler',
  'ha.cat.budget': 'Budsjett',
  'ha.cat.closing': 'Årsavslutning',
  'ha.h9.title': 'Registrere en eiendel og avskrivning',
  'ha.h9.lead': 'Større ting bedriften kjøper og bruker over flere år — som en PC, et kjøretøy eller maskiner — føres som eiendeler (driftsmidler). I stedet for å kostnadsføres med en gang, avskrives de litt hvert år. Plumme holder styr på avskrivningen for deg.',
  'ha.h9.whenAsset': 'Når er noe en eiendel?',
  'ha.h9.whenAssetText': 'Et kjøp må normalt avskrives når ett driftsmiddel har en kostpris på minst 30 000 kr og en forventet brukstid på minst tre år. Grensen vurderes per driftsmiddel, ikke ut fra fakturasummen alene.',
  'ha.h9.limit': '30 000-grensen',
  'ha.h9.limitText': 'Koster det enkelte driftsmiddelet under 30 000 kr, kan kostprisen normalt føres direkte samme år. Fysisk eller funksjonelt integrerte deler kan måtte vurderes samlet.',
  'ha.h9.register': 'Registrer eiendelen',
  'ha.h9.registerText': 'Gå til Kjøp → Eiendeler og trykk «Ny eiendel» — eller registrer den direkte fra kjøpet. Gi den et navn og legg inn kostpris og anskaffelsesdato.',
  'ha.h9.group': 'Velg saldogruppe',
  'ha.h9.groupText': 'Velg hvilken gruppe eiendelen hører til (f.eks. gruppe a for datautstyr, c for varebiler, d for maskiner og inventar). Gruppen bestemmer avskrivningssatsen.',
  'ha.h9.depreciate': 'La Plumme avskrive',
  'ha.h9.depreciateText': 'Hvert år beregnes avskrivningen automatisk som en fast prosent av gjenstående verdi (saldometoden). Du ser bokført verdi og samlet avskrivning i eiendelsregisteret.',
  'ha.h9.sell': 'Når du selger eller kvitter deg med eiendelen',
  'ha.h9.sellText': 'Selger du eiendelen, registrerer du salgssummen på den. Gevinst eller tap mot bokført verdi håndteres automatisk — eventuelt via en gevinst- og tapskonto som fordeler beløpet over flere år.',
  'ha.h10.title': 'Lage et budsjett for året',
  'ha.h10.lead': 'Et budsjett er en plan for inntektene og kostnadene dine gjennom året. Når du har lagt det inn, sammenligner Plumme budsjettet mot de faktiske tallene fortløpende, så du ser om du ligger an som planlagt.',
  'ha.h10.method': 'Velg metode',
  'ha.h10.methodText': 'Gå til Budsjett og velg hvordan du vil starte: «Manuelt» legger du inn alt selv, «Forslag» svarer du på noen enkle spørsmål, og «AI-forslag» beskriver du virksomheten med egne ord så lager Plumme et utkast.',
  'ha.h10.amounts': 'Legg inn inntekter og kostnader',
  'ha.h10.amountsText': 'Under «Budsjett per kategori» legger du til en inntekts- eller kostnadskategori med et årsbeløp. Beløpet fordeles på måneder, som du kan justere om aktiviteten varierer gjennom året.',
  'ha.h10.variance': 'Følg opp avvik',
  'ha.h10.varianceText': 'I «Analyse» og «Oversikt» ser du budsjett mot faktisk resultat, måned for måned. Avviket viser om du ligger over eller under planen, og hvilken konto som avviker mest.',
  'ha.h10.startSimple': 'Start enkelt',
  'ha.h10.startSimpleText': 'Du trenger ikke budsjettere alt. Begynn med de største inntektene og kostnadene — du kan alltid legge til flere kategorier senere.',
  'ha.h11.title': 'Avslutte regnskapsåret',
  'ha.h11.lead': 'Årsavslutningen lukker regnskapsåret. Du kontrollerer at alt er ført riktig, låser året, og forbereder deretter skattemelding og årsregnskap. Plumme guider deg gjennom hvert steg.',
  'ha.h11.before': 'Før du avslutter',
  'ha.h11.beforeText': 'Sørg for at alle bilag er bokført, innboksen er tom, og at MVA-terminene er levert. Jo mer som er på plass, jo glattere går avslutningen.',
  'ha.h11.checklist': 'Gå gjennom kontrollisten',
  'ha.h11.checklistText': 'Velg «Gå gjennom kontrollisten». Plumme sjekker punkter som bankavstemming, MVA, lønn og eiendeler. Punkter som trenger handling må løses før året kan lukkes.',
  'ha.h11.closeYear': 'Avslutt året',
  'ha.h11.closeYearText': 'Når alt er kontrollert, avslutter du regnskapsåret. Året låses for endringer — men du kan alltid åpne det igjen hvis noe må rettes.',
  'ha.h11.taxReturn': 'Forbered skattemeldingen',
  'ha.h11.taxReturnText': 'Plumme lager et utkast til skattemeldingen fra regnskapet. Gå gjennom utkastet og kontroller tallene. Selve skattemeldingen leverer du hos Skatteetaten, utenfor Plumme, og markerer den som levert her.',
  'ha.h11.annualAccounts': 'Lag årsregnskapet',
  'ha.h11.annualAccountsText': 'Til slutt settes årsregnskapet opp fra tallene, og dokumentene signeres. Årsregnskapet leverer du til Regnskapsregisteret i Altinn, utenfor Plumme (gjelder regnskapspliktige).',
  'ha.h11.reconciled': 'Bankavstemte perioder',
  'ha.h11.reconciledText': 'Bilag i en bankavstemt periode kan ikke endres uten å åpne perioden på nytt. Det sikrer at avstemmingen forblir riktig.',

  // ------------------------------------------ Hjelpeartikler: rammen og resten
  'ha.h1.save': 'Lagre',
  'ha.h2.register': 'Registrer betaling',
  'ha.h12.customer': 'Velg kunde',
  'ha.h13.receipt': 'Last opp bilag',
  'ha.eyebrow': 'Hjelp · {category}',
  'ha.readOn': 'Hjelp · les videre',
  'ha.backToSearch': 'Tilbake til søk',
  'ha.goTo': 'Gå til {page}',
  'ha.openedInBackground': 'Åpnet {page} i bakgrunnen',
  'ha.reopen': 'Åpne hjelpeartikkelen igjen',
  'ha.closeArticle': 'Lukk hjelpeartikkel',
  'ha.expandImage': 'Åpne bildet i full størrelse',
  'ha.collapseImage': 'Legg ned bildet',
  'ha.minimize': 'Legg ned',
  'ha.minimizeHelp': 'Legg ned — ta den opp igjen senere',
  'ha.dragWidth': 'Dra for å endre bredde',
  'ha.changeWidth': 'Endre bredde',

  // ------------------------------------------------------------ preferanser
  // ------------------------------------------- feilmeldinger fra serveren
  // Nøkkelen er domenekoden functions/ sender i HttpsError-detaljene, slått opp
  // som t('err.' + domainCode, serverMessage). Mangler koden her, står serverens
  // egen tekst igjen — så migreringen kan tas ett kast om gangen.
  'err.auth.required': 'Du må logge inn først.',
  'err.auth.emailNotVerified': 'Bekreft e-postadressen din først. Vi har sendt deg en lenke — åpne den, og prøv på nytt.',
  'err.auth.sessionRevoked': 'Økten er avsluttet. Logg inn på nytt.',
  'err.invoice.publicLinkExpired': 'Denne lenken har utløpt. Be avsender sende dokumentet på nytt.',
  'err.business.alreadyVerified': 'Dette foretaket er allerede registrert i Plumme. Be eier invitere deg.',
  'err.business.idPortenRequired': 'Logg inn med ID-porten for å verifisere foretaket.',
  'err.business.notAnAltinnActor': 'Du står ikke som aktør for dette foretaket i Altinn.',
  'err.business.altinnUnavailable': 'Kunne ikke slå opp rollene dine i Altinn akkurat nå. Prøv igjen senere.',
  'err.email.invalid': 'Skriv inn en gyldig e-postadresse.',
  'err.pf.notCreated': 'Opprett Privatøkonomi før du kobler til en husholdning.',
  'err.pf.noAccess': 'Du har ikke tilgang til denne Privatøkonomi-klienten.',
  'err.household.alreadyLinked': 'Du er allerede koblet til en husholdning.',
  'err.household.notLinked': 'Du er ikke koblet til en husholdning.',
  'err.household.selfInvite': 'Du kan ikke invitere deg selv.',
  'err.household.selfLink': 'Du kan ikke koble deg til deg selv.',
  'err.household.invitePending': 'Det finnes allerede en ventende invitasjon til denne e-postadressen.',
  'err.household.invalidResponse': 'Ugyldig svar på invitasjonen.',
  'err.household.inviteNotFound': 'Invitasjonen finnes ikke.',
  'err.household.inviteOtherEmail': 'Invitasjonen tilhører en annen e-postadresse.',
  'err.household.inviteInactive': 'Invitasjonen er ikke lenger aktiv.',
  'err.household.someoneLinked': 'En av brukerne er allerede koblet til en husholdning.',
  'err.household.cannotWithdraw': 'Du kan ikke trekke denne invitasjonen.',
  'err.business.missing': 'Mangler aktivt foretak.',
  'err.business.notFound': 'Foretaket finnes ikke.',
  'err.business.dataNotFound': 'Foretaksdata finnes ikke.',
  'err.import.noAccess': 'Du har ikke tilgang til å importere regnskap for dette foretaket.',
  'err.import.jobMissing': 'Mangler importjobb.',
  'err.import.jobNotFound': 'Importjobben finnes ikke.',
  'err.import.packageMissingFile': 'Den lagrede importen mangler filreferanse. Last opp filene på nytt.',
  'err.import.packageAlreadyCommitted': 'Det samme importfilsettet er allerede importert. Slett duplikatet i listen over lagrede importpakker.',
  'err.import.packageActive': 'Dette er den aktive importpakken og kan ikke slettes. Slett en eldre pakke i stedet.',
  'err.advisor.insightIncomplete': 'AI-rådet ble avkortet før det var ferdig. Prøv igjen om litt.',
  'err.advisor.insightUnavailable': 'SuperPlumma kunne ikke lage et trygt råd fra dette grunnlaget nå.',
  'err.advisor.insightEmpty': 'SuperPlumma fikk ikke laget et ferdig råd. Prøv igjen om litt.',
  'err.import.notAnalyzed': 'Importjobben må være analysert før den kan godkjennes.',
  'err.import.noProposal': 'Importjobben mangler grunnlagsforslag.',
  'err.pf.clientMissing': 'Mangler privatøkonomi-klient.',
  'err.pf.clientNotFound': 'Privatøkonomi-klienten finnes ikke.',
  'err.pf.notPersonalClient': 'Denne klienten er ikke en privatøkonomi-klient.',
  'err.pf.noValidFields': 'Ingen gyldige privatøkonomi-felt å lagre.',
  'err.tx.pickAtLeastOne': 'Velg minst en transaksjon.',
  'err.tx.maxBatch': 'Du kan flytte maks 200 transaksjoner om gangen.',
  'err.tx.pickCategory': 'Velg kategori.',
  'err.tx.notFound': 'En eller flere transaksjoner finnes ikke.',
  'err.tx.otherClient': 'Transaksjonen tilhører ikke denne klienten.',
  'err.statement.missing': 'Mangler kontoutskrift.',
  'err.statement.notFound': 'Kontoutskriften finnes ikke.',
  'err.account.pickOrCreate': 'Velg eller opprett konto.',
  'err.account.missing': 'Mangler konto.',
  'err.account.notFound': 'Kontoen finnes ikke.',
  'err.account.hasTransactions': 'Kontoen har importerte transaksjoner. Slett kontoutskriften først.',
  'err.asset.missing': 'Mangler eiendel.',
  'err.asset.notFound': 'Eiendelen finnes ikke.',
  'err.loan.missing': 'Mangler lån.',
  'err.loan.notFound': 'Lånet finnes ikke.',
  'err.assistant.emptyQuestion': 'Skriv et spørsmål først.',
  'err.assistant.tooLong': 'Meldingen er for lang.',
  'err.assistant.conversationLimit': 'Samtalen har nådd grensen. Start en ny samtale for å fortsette.',
  'err.idporten.expired': 'ID-porten-token mangler eller er utløpt. Logg inn med ID-porten på nytt.',

  'pref.title': 'Preferanser',
  'pref.sub': 'Justér varsler, språk, tema og standard arbeidsflyt.',
  'pref.deadlineMail': 'E-postpåminnelser for frister',
  'pref.deadlineMailSub': 'Få e-post 7 dager før MVA-frister og 30 dager før skattemelding, årsregnskap og aksjonærregisteroppgave. Gjelder norske foretak der du er eier eller administrator.',
  'pref.deadlineMailNotManager': 'Du er ikke eier eller administrator i dette foretaket, så du får ingen fristpåminnelser for det.',
  'pref.language': 'Språk',
  'pref.languageSub': 'Ditt språk på tvers av foretak. Andre brukere beholder sitt språk. Regnskapsregler og valuta følger foretakets land.',
  'pref.mascots': 'Maskotbilder',
  'pref.mascotsSub': 'Vis SuperPlumma og andre maskoter i appen.',
  'pref.theme': 'Tema',
  'pref.theme.light': 'Lyst',
  'pref.theme.dark': 'Mørkt',
  'pref.saved': 'Preferanser lagret',
  'set.transitionImport.title': 'Importer overgangsfil',
  'set.transitionImport.help': 'Bruk SAF-T XML, Excel eller CSV med konto og enten debet/kredit eller signert saldo. Filen behandles som oppstart eller inngående balanse, ikke som komplett historikk.',
  'set.transitionImport.choose': 'Velg fil',
  'set.transitionImport.readError': 'Kunne ikke lese overgangsfilen.',
  'set.transitionImport.summaryBalance': 'Lest {accounts} kontoer og {balanceLines} balanselinjer. Kontroller tallene før lagring.',
  'set.transitionImport.summaryStartup': 'Lest {accounts} kontoer: {salesLines} inntektslinjer, {costLines} kostnadslinjer, utgående MVA {outgoingVat} og inngående MVA {incomingVat}. Kontroller tallene før lagring.',
  'set.transitionImport.includeVat': 'Ta MVA-beløpene med i en MVA-melding i Plumme',
  'set.transitionImport.includeVatHelp': 'Slå bare på dette dersom beløpene ikke allerede er rapportert fra det tidligere systemet. Ellers blir MVA telt to ganger.',
  'set.transitionImport.vatPeriod': 'MVA-termin som skal motta oppstartstallene',
  'set.transitionImport.chooseVatPeriod': 'Velg termin',
  'set.transitionImport.chooseVatPeriodError': 'Velg hvilken MVA-termin oppstartstallene skal tas med i.',
  'set.transitionImport.vatFootnote': 'Oppstarts-MVA lagres som overgangsgrunnlag. Den legges bare til i en MVA-melding når du aktivt velger terminen over.',
  'set.transitionImport.useSimple': 'Bruk enkel overgang',
  'set.transitionImport.simpleTitle': 'De fleste bør bruke en enkel overgang',
  'set.transitionImport.simpleHelp': 'Ved nytt regnskapsår er inngående balanse vanligvis nok. Ved bytte midt i året kan du bruke oppstartstall. Begge kan fylles ut manuelt eller importeres fra SAF-T eller saldobalanse under Regnskap.',
  'set.transitionImport.completeTitle': 'Komplett historikkimport er avansert',
  'set.transitionImport.completeRisk': 'Eksporter fra andre regnskapssystemer kan inneholde forskjeller, mangler eller korreksjoner som ikke kan tolkes sikkert.',
  'set.transitionImport.completeCheck': 'Kontroller inngående balanse, MVA-beløp og leveringsstatus mot tidligere system og myndighetenes arkiver.',
  'set.transitionImport.completeKeep': 'Behold original eksport og regnskapsdokumentasjon i hele oppbevaringstiden.',
  'set.transitionImport.completeAccept': 'Jeg forstår at importerte opplysninger må kontrolleres før jeg rapporterer eller korrigerer noe.',
  'set.transitionImport.error.noRows': 'Filen mangler saldolinjer.',
  'set.transitionImport.error.noAccount': 'Filen må ha en kolonne for konto eller kontonummer.',
  'set.transitionImport.error.ambiguousAmount': 'Filen må ha separate debet- og kreditkolonner, eller beløp sammen med en sidekolonne.',
  'set.transitionImport.error.notBalanced': 'Inngående balanse er ikke i balanse. Debet {debit} og kredit {credit} må være like.',
  'set.transitionImport.error.fileType': 'Velg SAF-T XML eller en CSV- eller tekstfil med saldobalanse.',
  'set.transitionImport.warning.noSaftBalances': 'Fant ingen kontosaldoer i SAF-T-filen.',
  'set.transitionImport.warning.noBalances': 'Fant ingen saldoer med beløp i filen.',
  'set.transitionImport.lineNote': 'Importert fra {source}',
  'set.transitionImport.note': 'Importert fra {source}. Kontroller saldoene mot tidligere regnskapssystem.',
  'set.transitionImport.accountName': 'Konto {account}',
  'set.transitionImport.sourceTrialBalance': 'saldobalanse',
  'set.transitionImport.yearMismatch': 'Filen gjelder overgang til {detectedYear}, men oppstartsår er satt til {selectedYear}. Endre oppstartsår eller velg riktig fil.',
  'importCompliance.warningTitle': 'Kontroller importerte opplysninger',
  'importCompliance.warningBody': 'Opplysningene er hentet fra et annet regnskapssystem. Plumme kontrollerer at dataene kan leses og behandles, men kan ikke bekrefte at eksporten er fullstendig, at tallene er korrekte eller at oppgavene er mottatt av myndighetene. Kontroller mot tidligere regnskapssystem og myndighetenes arkiver dersom du er usikker.',
  'importCompliance.historicalTitle': 'Historiske år settes som ferdige',
  'importCompliance.historicalBody': 'For komplette år eldre enn fjoråret ({years}) settes årsavslutning og relevante oppgaver som levert. Importerte MVA-terminer settes som levert, men ikke som betalt.',
  'importCompliance.previousTitle': 'Bekreft status for {year}',
  'importCompliance.previousHelp': 'Vi antar ikke at fjoråret er ferdig. Velg «Usikker» hvis dette må kontrolleres; da beholdes oppgaven åpen.',
  'importCompliance.question.yearClosing': 'Er årsavslutningen ferdig?',
  'importCompliance.question.taxReturn': 'Er skattemeldingen levert?',
  'importCompliance.question.annualAccounts': 'Er årsregnskapet levert?',
  'importCompliance.question.vatReturns': 'Er MVA-meldingene for de importerte terminene levert?',
  'importCompliance.selectStatus': 'Velg status',
  'importCompliance.yes': 'Ja',
  'importCompliance.no': 'Nei',
  'importCompliance.unknown': 'Usikker – behold åpen',
  'importCompliance.accept': 'Jeg forstår at importerte tall og historiske innleveringsstatuser må kontrolleres mot tidligere regnskapssystem og myndighetenes arkiver.',
  'importCompliance.noPaymentAssumption': 'Betalingsstatus for MVA antas ikke bare fordi en termin er gammel.',
  'importCompliance.noticeTitle': 'Importerte opplysninger for {year}',
  'importCompliance.area.vat': 'MVA-meldingene',
  'importCompliance.area.tax': 'skattemeldingen',
  'importCompliance.area.annualAccounts': 'årsregnskapet',
  'importCompliance.area.yearClosing': 'årsavslutningen',
  'importCompliance.statusDelivered': '{area} står som {status} basert på importvalget.',
  'importCompliance.statusOpen': '{area} er beholdt åpen.',
  'importCompliance.statusNotApplicable': '{area} er ikke markert som leveringspliktig for denne foretaksformen.',
  'importCompliance.statusFiled': 'levert',
  'importCompliance.statusClosed': 'ferdig',
  'importCompliance.noticeBody': 'Tall og historiske statuser er hentet fra et annet regnskapssystem. Plumme kan ikke bekrefte at eksporten er fullstendig, at tallene er korrekte eller at oppgaven er mottatt av myndighetene. Kontroller mot tidligere regnskapssystem og myndighetenes arkiver før du gjør endringer eller sender inn.',
  'importCompliance.understood': 'Jeg forstår',
  'importOpen.title': 'Importert reskontro',
  'importOpen.items': 'poster',
  'importOpen.customerInvoice': 'Faktura',
  'importOpen.supplierInvoice': 'Leverandørfaktura',
  'importOpen.noDate': 'uten dato',
  'importOpen.due': 'Forfall {date}',
  'importOpen.controlBasis': 'importert kontrollgrunnlag',
  'importOpen.open': 'Importert åpen post',
  'importOpen.partial': 'Delvis oppgjort',
  'importOpen.settled': 'Oppgjort',
  'importOpen.credit': 'Kredit / overbetaling',
  'importOpen.registerSettlement': 'Registrer oppgjør',
  'importOpen.dialogTitle': 'Registrer oppgjør av importert post',
  'importOpen.amount': 'Oppgjort beløp',
  'importOpen.date': 'Oppgjørsdato',
  'importOpen.note': 'Merknad (valgfritt)',
  'importOpen.noPostingNotice': 'Oppgjøret bokføres mot valgt bankkonto og importert kunde- eller leverandørreskontro. Det opprettes ingen ny inntekt, kostnad eller MVA.',
  'importOpen.settledToast': 'Oppgjøret er registrert',
  'importOpen.reopenedToast': 'Den importerte posten er gjenåpnet',
  'importOpen.error': 'Kunne ikke oppdatere den importerte posten',
  'importOpen.reopen': 'Gjenåpne',
  'importOpen.reopenTitle': 'Gjenåpne importert post',
  'importOpen.reopenWarning': 'Posten blir igjen utestående, og det bokførte oppgjøret reverseres på valgt dato.',
  // ------------------------------------------------- prosjekter og timeføring
  'inv.detail.overpaid': 'Overbetalt',
  'inv.detail.customerOverpayment': 'Uavklart tilgode hos kunden',
  'inv.detail.registerExtraPayment': 'Registrer ekstra innbetaling',
  'inv.pay.overpaymentNote': 'Innbetalingen er {amount} høyere enn fakturaens restbeløp. Hele beløpet registreres, og det overskytende blir stående som uavklart tilgode på kunden.',
  'inv.overpayment.refund': 'Tilbakebetal overbetaling',
  'inv.overpayment.allocate': 'Fordel overbetaling',
  'inv.overpayment.available': 'Tilgjengelig ufordelt overbetaling: {amount}.',
  'inv.overpayment.source': 'Overbetaling fra faktura',
  'inv.overpayment.allocations': 'Fordelinger av overbetaling',
  'inv.overpayment.receivedFrom': 'Mottatt fra {document}',
  'inv.overpayment.allocatedTo': 'Fordelt til {document}',
  'inv.overpayment.refundNote': 'Tilbakebetaling av kundeoverbetaling',
  'inv.overpayment.allocationNote': 'Fordelt kundeoverbetaling fra {source}',
  'inv.overpayment.refunded': 'Overbetalingen er tilbakebetalt',
  'inv.overpayment.allocated': 'Overbetalingen er fordelt',
  'inv.overpayment.reverseRefund': 'Reverser tilbakebetaling',
  'inv.overpayment.reverseAllocation': 'Reverser fordeling',
  'inv.overpayment.notConnected': 'Tilbakebetaling av overbetaling er ikke koblet til backend.',
  'inv.overpayment.noSource': 'Velg en faktura med tilgjengelig overbetaling.',
  'inv.overpayment.refundFailed': 'Kunne ikke tilbakebetale overbetalingen.',
  'inv.overpayment.allocationFailed': 'Kunne ikke fordele overbetalingen.',
  'inv.overpayment.reverseRefundFailed': 'Kunne ikke reversere tilbakebetalingen.',
  'inv.overpayment.reverseAllocationFailed': 'Kunne ikke reversere fordelingen.',
  'sup.overpayment.invalidAmount': 'Skriv inn et gyldig beløp.',
  'sup.overpayment.refunded': 'Tilbakebetalingen er registrert.',
  'sup.overpayment.allocated': 'Overbetalingen er fordelt.',
  'sup.overpayment.failed': 'Kunne ikke behandle overbetalingen.',
  'sup.overpayment.refundTitle': 'Tilbakebetal leverandøroverbetaling',
  'sup.overpayment.allocateTitle': 'Fordel leverandøroverbetaling',
  'sup.overpayment.refundAction': 'Registrer tilbakebetaling',
  'sup.overpayment.allocateAction': 'Fordel overbetaling',
  'sup.overpayment.source': 'Overbetaling fra faktura',
  'sup.overpayment.amount': 'Beløp',
  'sup.overpayment.date': 'Dato',
  'sup.overpayment.bankAccount': 'Bankkonto',
  'sup.overpayment.reverseRefund': 'Reverser tilbakebetaling',
  'sup.overpayment.refundReversed': 'Tilbakebetalingen er reversert.',
  'sup.overpayment.reverseRefundFailed': 'Kunne ikke reversere tilbakebetalingen.',
  'sup.overpayment.reverseAllocation': 'Reverser fordeling',
  'sup.overpayment.allocationReversed': 'Fordelingen er reversert.',
  'sup.overpayment.reverseAllocationFailed': 'Kunne ikke reversere fordelingen.',
  'settlement.linkExisting': 'Koble eksisterende postering',
  'settlement.title': 'Koble eksisterende postering',
  'settlement.noNewPosting': 'Koblingen oppdaterer reskontroen. Den lager ingen ny hovedbokspostering.',
  'settlement.noMatchesTitle': 'Ingen mulige treff',
  'settlement.noMatchesText': 'Kontroller at den frie posteringen bruker kredit 1500 for valgt kunde eller debet 2400 for valgt leverandør, og at beløpet ikke allerede er koblet.',
  'settlement.exactMatch': 'Eksakt beløpstreff',
  'settlement.manualPosting': 'Fri postering',
  'settlement.customerInvoice': 'Kundefaktura',
  'settlement.supplierInvoice': 'Leverandørfaktura',
  'settlement.noDate': 'Uten dato',
  'settlement.canLink': 'Kan kobles: {amount} · Ledig i posteringen: {available}',
  'settlement.amount': 'Beløp som skal kobles',
  'settlement.amountTooHigh': 'Beløpet er høyere enn disponibelt beløp.',
  'settlement.linkSelected': 'Koble valgte',
  'settlement.linking': 'Kobler…',
  'settlement.linkedOne': 'Posteringen er koblet til den åpne posten.',
  'settlement.linkedMany': '{count} åpne poster er koblet.',
  'settlement.cardTitle': 'Åpne poster kan kobles',
  'settlement.cardText': 'Velg selv faktura og beløp. Ingenting oppgjøres automatisk.',
  'settlement.linkPosting': 'Koble {voucher}',
  'settlement.linkFailed': 'Kunne ikke koble posteringen.',
  'settlement.voucherNotFound': 'Fant ikke bilaget som skal kobles.',
  'settlement.actionHelp': 'Kobler et ubrukt beløp på en fri postering til en åpen kunde- eller leverandørpost uten å lage ny hovedbokspostering.',
  'accounting.importedStatisticsTitle': 'Importert regnskapsstatistikk',
  'accounting.importedStatisticsReconciliation': 'Saldoene kommer fra kontrollert importert kontostatistikk, ikke journalhendelser i Plumme. Avstemmingen kan gjennomgås, men sertifisering og avslutning er fortsatt sperret.',
});

window.PlummeI18n.register("no", {"nav.kjopsoversikt": "Kjøpsliste", "route.kjopsoversikt": "Kjøpsliste"});
